import AddIcon from "@mui/icons-material/Add";
import CampaignIcon from '@mui/icons-material/Campaign';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import CloseIcon from "@mui/icons-material/Close";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import CorporateFareOutlinedIcon from "@mui/icons-material/CorporateFareOutlined";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import EngineeringIcon from "@mui/icons-material/Engineering";
import EngineeringOutlinedIcon from "@mui/icons-material/EngineeringOutlined";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import InsertChartOutlinedIcon from "@mui/icons-material/InsertChartOutlined";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import DeleteIcon from "@mui/icons-material/Delete";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import EditIcon from "@mui/icons-material/Edit";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MenuIcon from "@mui/icons-material/Menu";
import SaveIcon from "@mui/icons-material/Save";
import SearchIcon from "@mui/icons-material/Search";
import UpdateIcon from "@mui/icons-material/Update";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import passwordKey from "../../images/passwordKey.webp";
import WarningIcon from "@mui/icons-material/Warning";
import {
  Backdrop,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  InputAdornment,
  MenuItem,
  Radio,
  RadioGroup,
  Typography,
  Divider,
  ListItemIcon,
  ListItemText,
  useMediaQuery,
} from '@mui/material';
import TextField from '../SanitizedTextField/SanitizedTextField';
import AppLoader from '../AppLoader/AppLoader';
import MuiAppBar from "@mui/material/AppBar";
import DialogActions from "@mui/material/DialogActions";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import Select from "@mui/material/Select";
import { styled, useTheme } from "@mui/material/styles";
import { useFormik } from "formik";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { yupSafeFormText, yupSafePersonName } from "../../utils/sanitizeFormText";
import CheckPermissions, { hasServicePermission } from "../../authorization/authorization";
import EditLinemanDialog from "./EditLinemanDialog";
import AddWorkforceDialog from "./AddWorkforceDialog";
import ChangeWorkforcePasswordDialog from "./ChangeWorkforcePasswordDialog";
import {
  actionableNormal,
  resetState as resetActionableNormal,
} from "../../features/actionable/actionableNormalSlice";
import {
  actionableOverdue,
  resetState as resetActionableOverdue,
} from "../../features/actionable/actionableOverdueSlice";
import {
  setSelectedAdminCompanyCode,
  signOut,
  updateEmail,
  updateName,
  updatePhone,
  updateProfilePicture,
} from "../../features/authentication/authenticationSlice";
import { updateOC } from "../../features/officeCodeForName/officeCodeForName";
import { resetState as resetStateDueDate } from "../../features/billingAndCollection/dueDateExtensionNormalSlice";
import { resetState as resetStateInstallmentsNormal } from "../../features/billingAndCollection/installmentsNormalSlice";
import { resetState as resetStateInstallmentsOverdue } from "../../features/billingAndCollection/installmentsOverdueSlice";
import { resetOverallPerformanceState } from "../../features/dashboard/overallPerformance";
import { resetState as resetStateColNormal } from "../../features/generalServices/colNormalSlice";
import { resetState as resetStateColOverdue } from "../../features/generalServices/colOverdueSlice";
import { resetState as resetStateConNormal } from "../../features/generalServices/coaNormalSlice";
import { resetState as resetStateConOverdue } from "../../features/generalServices/coaOverdueSlice";
import { resetState as resetStateCotNormal } from "../../features/generalServices/cotNormalSlice";
import { resetState as resetStateCotOverdue } from "../../features/generalServices/cotOverdueSlice";
import { resetState as resetStateNcNormal } from "../../features/generalServices/ncNormalSlice";
import { resetState as resetStateNcOverdue } from "../../features/generalServices/ncOverdueSlice";
import {
  fetchFeederStatus,
  resetFeederStatusState,
} from "../../features/geoJson/feedersStatus";
import { fetchAuth } from "../../features/mdm/authorization";
import {
  fetchGeoJson,
  resetGeoJsonState,
} from "../../features/geoJson/geoJson";
import {
  fetchPaginatedAllComplaints,
  resetState as resetStateAllComplaints,
} from "../../features/powerComplaints/getComplaintSlice";
import { allStatsAPI, removeStats } from "../../features/stats/statsSlice";
import { updateHomeButton } from "../../features/powerComplaints/homeButtonSlice";
import Complaintsmanagemnt from "../../images/Complaintsmanagemnt.webp";
import { getDiscoCompanyNativeOptions } from "../AdminCompanySelect/DiscoCompanyMenuItems";
import UserIconImage from "../../images/user.webp";
import Allocated1 from "../../images/AllocatedComplaints.webp";
import Escalated1 from "../../images/EscalatedComplaints.webp";
import Onhold1 from "../../images/OnholdComplaints.webp";
import Complaints from "../../images/Alert.webp";
import Pending1 from "../../images/PendingComplaints.webp";
import Alarm from "../../images/alarm.webp";
import Reports1 from "../../images/Reports.webp";
import smartphone from "../../images/smartphone.webp";
import Resolved1 from "../../images/ResolvedComplaints.webp";
import Working1 from "../../images/WorkingComplaints.webp";
import bell from "../../images/bell.webp";
import closeIconWhite from "../../images/close_icon_white.webp";
import circleIcon from "../../images/dashboard/Circle.webp";
import divisionIcon from "../../images/dashboard/Division.webp";
import subDivisionIcon from "../../images/dashboard/Sub-Division.webp";
import trendingUpIcn from "../../images/dashboard/green_arrow_icon.webp";
import trendingDownIcn from "../../images/dashboard/red_arrow_icon.webp";
import EOps from "../../images/eops.webp";
import EOpsDark from "../../images/eops-white-01.webp";
import feederIcon1 from "../../images/feedericon.webp";
import InfoImage from "../../images/informationButton.webp";
import Key1 from "../../images/key.webp";
import lineman1 from "../../images/lineman.webp";
import Logout1 from "../../images/log-out.webp";
import PDF1 from "../../images/pdf.webp";
import complaints from "../../images/sidebaricons/complaints.webp";
import cnicupdation from "../../images/sidebaricons/small/CNIC Updation.webp";
import companyIcon from "../../images/sidebaricons/small/Company.webp";
import duplicateBill from "../../images/sidebaricons/small/Duplicate Bill.webp";
import amendDuplicateBill from "../../images/amendDuplicateBill.webp";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import partPayment from "../../images/partPayment.webp";
import adjustLastBill from "../../images/adjustLastBill.webp";

import supportCenterIcon from "../../images/sidebaricons/small/Facilitation Centre.webp";
import meterChangeRequest from "../../images/sidebaricons/small/Meter Change Request.webp";
import permissionManagement from "../../images/sidebaricons/small/Permission Management.webp";
import installments from "../../images/sidebaricons/small/bill installment icon.webp";
import usermanagement from "../../images/sidebaricons/small/businessman.webp";
import ChangeOfName1 from "../../images/sidebaricons/small/change_name_load_icon.webp";
import dateextension1 from "../../images/sidebaricons/small/date_extention_icon.webp";
import Disconnection1 from "../../images/sidebaricons/small/disconnection_icon.webp";
import ChangeOfLoad1 from "../../images/sidebaricons/small/extention_load_icon.webp";
import GIS from "../../images/sidebaricons/small/map.webp";
import OptForNetMetering1 from "../../images/sidebaricons/small/net_meter_icon.webp";
import NewConnection1 from "../../images/sidebaricons/small/new_connection_icon.webp";
import readingcorrection1 from "../../images/sidebaricons/small/reading_correction_icon.webp";
import ChangeOfTariff1 from "../../images/sidebaricons/small/reduction_load_icon.webp";
import roleMgmt from "../../images/sidebaricons/small/role management.webp";
import transformer1 from "../../images/transformer.webp";

import apmsdashboard from "../../images/apmsdashboard.webp";
import home1 from "../../images/home.webp";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import XLSX from "../../utils/xlsxStyled";
import useDiscoLogo from "../../hooks/useDiscoLogo";
import { loadDiscoLogo, loadDiscoWatermark, loadEopsPng } from "../../utils/discoAssets";
import batchIcon from "../../images/batchWarning.webp";
import excel from "../../images/excel.webp";
import pdf from "../../images/pdf.webp";
import pencilIcon from "../../images/pencil.webp";
import print from "../../images/print.webp";
import Profile1 from "../../images/user-edit.webp";
import {
  deleteWFData,
  getFieldStaffDesignations,
  getWorkforceData,
} from "../../network/APIs/APIs";
import { cfpBaseUrl, cpBaseUrl, wfsBaseUrl } from "../../network/urls";
import {
  convertDatewithTime,
  convertDateYYYYMMDD,
  dBillAPI,
  getName,
  numberFormatting,
  officeName,
  subdivisionName,
  companyShortName,
  permissionsVariables,
} from "../../services/Functions";
import { internalIconStyles } from "../../style/common";
import {
  BulkDistributionTheft,
  damagedMeter,
  DelayedBillingNewConnection,
  DetectionBill,
  electricFire,
  ElectricityTheft,
  fluctuation,
  imageExtensions,
  InstalledTransformerMeterWireTheft,
  lineFault,
  lowVoltageLongTerm,
  lowVoltageShortTerm,
  MeterPosition,
  NonDeliveryofBill,
  otherComplaintsArray,
  otherComplaintsArrayCommerical,
  others,
  passwordRegex,
  powerOutage,
} from "../../utils/PortalName";
import {
  canManageRolesAndPermissions,
  getInitialAdminOfficeCode,
  persistAdminCompanySelectionToStorage,
  resolveApiOfficeCode,
} from "../../utils/adminCompany";
import SearchPopup, {
  fetchSearchApplicationTypes,
  getSearchServiceTypeFromPath,
  normalizeSearchApplicationTypeId,
} from "../SearchPopups/SearchPopup";
import SearchResultsPopup from "../SearchPopups/SearchResultsPopup";
import Error from "../error/error";
import Time from "../time/time";
import "./sidebar.scss";

import { fetchDivisionGeoJson } from "../../features/geoJson/divisionGeoJson";
import AddButton from "../AddButton/AddButton";
import { useSearchFormik } from "../../hooks/useSearchFormik";
import JsBarcode from "jsbarcode";
import staffPerformance from "../../images/staffperformance.webp";
import pitcLogo from "../../images/pitc.webp";
import Success from "../success/success";
import SidebarNavMenu from "./SidebarNavMenu";

const SIDEBAR_ICON_TONE_BY_LABEL = {
  Home: "blue",
  "New Complaint": "amber",
  "Comp. Detailed History": "purple",
  "Comp. & Control Center": "teal",
  ComplaintAndControlCenter: "teal",
  Map: "teal",
  "Feeder List": "purple",
  "APMS List": "teal",
  "APMS Dashboard": "teal",
  Linemen: "orange",
  "Line Staff": "orange",
  "Load Shedding Schedule": "amber",
  "Mobile App Stats": "purple",
  "Complaint Register": "purple",
  "APMS Complaints Summary": "purple",
  "Complaints Management": "blue",
  "Pending Complaints": "blue",
  "Allocated Complaints": "teal",
  "Working Complaints": "green",
  "Onhold Complaints": "amber",
  "Escalated Complaints": "orange",
  "APMS Escalated": "orange",
  "Resolved Complaints": "green",
  Logout: "red",
  "Sign Out": "red",
  "Logged In Users": "purple",
  "Logged In User Summary": "purple",
  "Reports / Summary": "purple",
  "Complaints Summary": "purple",
  "APMS Resolved Complaint Stats": "purple",
  "User Complaint Processing Statistics": "purple",
  "eOps App Usage Summary": "teal",
  "eOps Mobile App Usage Summary": "teal",
  "Not Logged In User In Last 24 Hours": "amber",
  "Eops Users Status": "green",
  "Source & Complaint Type Wise": "teal",
  "Top Best And Worst Field Staff Performer": "orange",
  Actionables: "amber",
  "New Connection": "blue",
  "Due Date Ext.": "teal",
  "Bill Installments": "purple",
  "Withdrawal of Installment": "purple",
  "Amend Duplicate Bill": "orange",
  "Part Payment": "green",
  "Advance Payment": "blue",
  Reconnection: "blue",
  Disconnection: "orange",
  "Change of Attributes": "teal",
  "Adjust Last Bill": "amber",
  "Update Tenant CNIC": "purple",
  "Meter Change Order": "teal",
  "Duplicate Bill": "blue",
  "Escalation Complaints": "orange",
  "Workforce Management": "purple",
  "User Management": "purple",
  "Role Management": "purple",
  Company: "teal",
  Circle: "blue",
  Division: "green",
  "Sub Division": "orange",
};

/** Dark-mode image treatment for sidebar raster icons. */
const SIDEBAR_DARK_ICON_FILTER_BY_LABEL = {
  "Feeder List": "invert",
  "Complaints Management": "brighten",
  "New Complaint": "knockout",
  "Comp. & Control Center": "soft",
  ComplaintAndControlCenter: "soft",
  Map: "soft",
  Home: "soft",
  "APMS List": "soft",
  "APMS Dashboard": "soft",
  "Complaint Register": "knockout",
  "APMS Complaints": "knockout",
  "APMS Complaints Summary": "knockout",
  "Reports / Summary": "knockout",
  "Complaints Summary": "knockout",
  "New Connection Reports": "knockout",
  "Change of Attributes Reports": "knockout",
  "Reconnection Reports": "knockout",
  "Cash Collection Report": "knockout",
  "Comp. Detailed History": "soft",
  "Load Shedding Schedule": "soft",
  "Line Staff": "soft",
  Linemen: "soft",
  Logout: "soft",
  "Sign Out": "soft",
  "Pending Complaints": "soft",
  "Allocated Complaints": "soft",
  "Working Complaints": "soft",
  "Onhold Complaints": "soft",
  "Escalated Complaints": "soft",
  "Resolved Complaints": "soft",
  "APMS Escalated": "soft",
  "Mobile App Stats": "soft",
};

const DEFAULT_SIDEBAR_IMAGE_ICON_TONE = "blue";

const IconWithLabel = (icon, label, tone = null) => {
  const isImageIcon = !React.isValidElement(icon);
  const resolvedTone =
    tone ??
    SIDEBAR_ICON_TONE_BY_LABEL[label] ??
    (isImageIcon ? DEFAULT_SIDEBAR_IMAGE_ICON_TONE : null);
  const darkFilter =
    (isImageIcon && SIDEBAR_DARK_ICON_FILTER_BY_LABEL[label]) ||
    (isImageIcon ? "knockout" : null);

  const toneClass = resolvedTone
    ? `sidebar-nav-icon sidebar-nav-icon--tone sidebar-nav-icon--tone-${resolvedTone}`
    : "sidebar-nav-icon sidebar-nav-icon--outline";
  const darkFilterClass = darkFilter
    ? ` sidebar-nav-icon--dark-${darkFilter}`
    : "";

  return (
    <div className="sidebar-menu-item-label">
      {React.isValidElement(icon) ? (
        <span className={`${toneClass}${darkFilterClass}`}>{icon}</span>
      ) : resolvedTone ? (
        <span className={`${toneClass}${darkFilterClass}`}>
          <img src={icon} alt={label} width="18" height="18" />
        </span>
      ) : (
        <span className={`sidebar-nav-icon sidebar-nav-icon--bare${darkFilterClass}`}>
          <img src={icon} alt={label} width="22" height="22" />
        </span>
      )}
      <span className="sidebar-menu-item-label__text">{label}</span>
    </div>
  );
};

const Sidebar = () => {
  const {
    code: userCode,
    name: userName,
    roleName: userRole,
    wmsPrivateToken,
  } = useSelector((state) => state.auth);

  const {
    userId,
    token,
    cscID,
    permissions,
    code,
    hierarchy,
    showAllApplicationsFlag,
    name,
    roleName,
    profilePicture,
    roleTypeId,
    phoneNo,
    roleId,
    cnic,
    email,
    circleCode,
    cfcLevelId,
    roleTypeName,
    selectedAdminCompanyCode,
  } = useSelector((state) => state.auth);
  const companyCode = String(code ?? "").slice(0, 2);
  const showAPMSDashboard = companyCode === "15";
  // TAC: Feeder List for MEPCO (15) + IESCO (14)
  const showFeederList =
    hierarchy == 52 && (companyCode === "15" || companyCode === "14");
  // IESCO TAC should see Feeder List, not APMS List
  const showApmsList = !(hierarchy == 52 && companyCode === "14");
  const canShowFeederListMenu =
    showFeederList &&
    (CheckPermissions(
      permissions,
      permissionsVariables.powerComplaints,
      "Feeder List",
    ) ||
      (companyCode === "14" &&
        CheckPermissions(
          permissions,
          permissionsVariables.powerComplaints,
          "APMS List",
        )));
  const canShowApmsListMenu =
    showApmsList &&
    CheckPermissions(
      permissions,
      permissionsVariables.powerComplaints,
      "APMS List",
    );
  const {
    totalNewConnectionApplications,
    totalChangeOfLoadApplications,
    totalChangeOfNameApplications,
    totalChangeOfTariffApplications,
    totalChangeOfMeterRequrestApplications,
    totalOptForSmartMeterApplications,
    totalDueDateExtensionApplications,
    totalBillInstallmentApplications,
    totalComplaintsApplications,
    totalMeterReadingCorrectionApplications,
    totalNetMeteringApplications,
    error,
  } = useSelector((state) => state.stats);

  const [pendings, setPendings] = useState([]);

  const { totalRecords: totalActionablesNormal } = useSelector(
    (state) => state.actionableNormal,
  );
  const { totalRecords: totalActionablesOverdue } = useSelector(
    (state) => state.actionableOverdue,
  );

  const [openAmendBillPopup, setOpenAmendBillPopup] = useState(false);
  const [success, setSuccess] = useState(false);

  const onCloseAmendBillPopup = () => {
    setOpenAmendBillPopup(false);
  };
  const handleLogout = async () => {
    setViewBackdrop(true);

    const sessionId = sessionStorage.getItem("sessionId");
    let tabs = [];
    try {
      const storedTabs = JSON.parse(localStorage.getItem("appTabs") || "[]");
      tabs = Array.isArray(storedTabs) ? storedTabs : [];
    } catch {
      tabs = [];
    }
    tabs = tabs.filter((id) => id !== sessionId);
    localStorage.setItem("appTabs", JSON.stringify(tabs));

    try {
      await callLogoutAPI();
      dispatch(resetStateNcNormal());
      dispatch(resetStateNcOverdue());
      dispatch(resetStateConNormal());
      dispatch(resetStateConOverdue());
      dispatch(resetStateColNormal());
      dispatch(resetStateColOverdue());
      dispatch(resetStateCotNormal());
      dispatch(resetStateCotOverdue());
      dispatch(resetStateDueDate());
      dispatch(resetStateInstallmentsNormal());
      dispatch(resetStateInstallmentsOverdue());
      dispatch(removeStats());
      dispatch(resetOverallPerformanceState());
      dispatch(resetFeederStatusState());
      dispatch(resetGeoJsonState());
      dispatch(resetActionableNormal());
      dispatch(resetActionableOverdue());
      dispatch(resetStateAllComplaints());
      dispatch(signOut());
    } catch (error) {
    } finally {
      setViewBackdrop(false);
    }
  };

  const items = [
    // {
    //   key: "DummyDashboard",
    //   icon: IconWithLabel(apmsdashboard, "Dummy Dashboard"),
    //   label: "",
    //   onClick: () => handleItemClick("DummyDashboard"),
    //   permission: true,
    // },
    // {
    //   key: "OperationalPerformance",
    //   icon: IconWithLabel(
    //     <HomeOutlinedIcon sx={{ fontSize: 18 }} />,
    //     permissionsVariables.operationalPerformance,
    //     "blue",
    //   ),
    //   label: "",
    //   onClick: () => handleItemClick("OperationalPerformance"),
    //   permission: CheckPermissions(
    //     permissions,
    //     "Dashboard",
    //     permissionsVariables.operationalPerformance,
    //   ),
    // },
    {
      key: "CFCDashboard",
      icon: IconWithLabel(
        <DashboardOutlinedIcon sx={{ fontSize: 18 }} />,
        "Dashboard",
        "purple",
      ),
      label: "",
      onClick: () => handleItemClick("CFCDashboard"),
      permission: CheckPermissions(permissions, "Dashboard", "CFC Dashboard"),
    },
    {
      key: "CFCPerformance",
      icon: IconWithLabel(
        <InsertChartOutlinedIcon sx={{ fontSize: 18 }} />,
        "CFC Performance",
        "green",
      ),
      label: "",
      onClick: () => handleItemClick("CFCPerformance"),
      permission: CheckPermissions(
        permissions,
        "Dashboard",
        permissionsVariables.commercialOperations,
      ),
    },
    // {
    //   key: "FieldOfficeDashboard",
    //   icon: IconWithLabel(
    //     <EngineeringOutlinedIcon sx={{ fontSize: 18 }} />,
    //     "Tech & Comm Dashboard",
    //     "orange",
    //   ),
    //   label: "",
    //   onClick: () => handleItemClick("FieldOfficeDashboard"),
    //   permission: CheckPermissions(
    //     permissions,
    //     "Dashboard",
    //     "Field Office Dashboard",
    //   ),
    // },
    {
      key: permissionsVariables.commercialOperations,
      label: "",
      onClick: () => handleItemClick("CommercialPerformance"),
      permission: true,
      icon: IconWithLabel(
        <BusinessCenterIcon sx={{ fontSize: 18 }} />,
        permissionsVariables.commercialOperations,
        "blue",
      ),
      children: [
        {
          key: "Actionables",
          label: "",
          icon: IconWithLabel(bell, "Actionables"),
          onClick: () => handleItemClick("Actionables"),
          permission:
            (totalActionablesNormal || totalActionablesOverdue) &&
            (CheckPermissions(
              permissions,
              permissionsVariables.generalServices,
            ) ||
              CheckPermissions(
                permissions,
                permissionsVariables.billingAndCollection,
              )),
        },
        {
          key: "NewConnection",
          label: "",
          icon: IconWithLabel(NewConnection1, "New Connection"),
          onClick: () => handleItemClick("NewConnection"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.generalServices,
            permissionsVariables.newConnection,
          ),
        },
        {
          key: "DueDateExt",
          label: "",
          icon: IconWithLabel(dateextension1, "Due Date Ext."),
          onClick: () => handleItemClick("DueDateExt"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.billingAndCollection,
            permissionsVariables.dueDateExtension,
          ),
        },
        {
          key: "BillInstallments",
          label: "",
          icon: IconWithLabel(installments, "Bill Installments"),
          onClick: () => handleItemClick("BillInstallments"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.billingAndCollection,
            permissionsVariables.billInstallments,
          ),
        },
        {
          key: "WithdrawalOfInstallment",
          label: "",
          icon: IconWithLabel(installments, "Withdrawal of Installment"),
          onClick: () => handleItemClick("WithdrawalOfInstallment"),
          permission:
            hasServicePermission(
              permissions,
              permissionsVariables.withdrawalOfInstallment,
            ) ||
            CheckPermissions(
              permissions,
              permissionsVariables.billingAndCollection,
              permissionsVariables.withdrawalOfInstallment,
            ),
        },
        // {
        //   key: "DuplicateBill",
        //   label: "",
        //   icon: IconWithLabel(duplicateBill, "Duplicate Bill"),
        //   onClick: () => handleItemClick("DuplicateBill"),
        //   permission: hasServicePermission(
        //     permissions,
        //     permissionsVariables.duplicateBill,
        //   ),
        // },
        {
          key: "AmendDuplicateBill",
          label: "",
          icon: IconWithLabel(amendDuplicateBill, "Amend Duplicate Bill"),
          onClick: () => handleItemClick("AmendDuplicateBill"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.generalServices,
            permissionsVariables.amendDuplicateBill,
          ),
        },
        {
          key: "amendBill2636",
          label: "",
          icon: IconWithLabel(partPayment, "Part Payment"),
          onClick: () => handleItemClick("AmendBill2636"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.generalServices,
            permissionsVariables.partPayment,
          ),
        },
        // {
        //   key: "advancePayment",
        //   label: "",
        //   icon: IconWithLabel(partPayment, "Advance Payment"),
        //   onClick: () => handleItemClick("AmendBill2636"),
        //   permission: CheckPermissions(
        //     permissions,
        //     permissionsVariables.generalServices,
        //     permissionsVariables.partPayment,
        //   ),
        // },
        {
          key: "advancePayment",
          label: "",
          icon: IconWithLabel(<PaymentsOutlinedIcon sx={{ fontSize: 18 }} />, "Advance Payment"),
          onClick: () => handleItemClick("AdvancePayment"),
          permission:
            CheckPermissions(
              permissions,
              permissionsVariables.generalServices,
              permissionsVariables.advancePayment,
            )
        },
        // { key: 'SetAside', label: '', icon: IconWithLabel(installments, 'Set Aside / Withdrawal ('.concat('0', ")")), onClick: () => handleItemClick('SetAside'), permission: CheckPermissions(permissions, permissionsVariables.billingAndCollection, "Installments") },
        {
          key: "Reconnection",
          label: "",
          icon: IconWithLabel(NewConnection1, "Reconnection"),
          onClick: () => handleItemClick("Reconnection"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.generalServices,
            permissionsVariables.reConnection,
          ),
        },
        // {
        //   key: "Disconnection",
        //   label: "",
        //   icon: IconWithLabel(Disconnection1, "Disconnection"),
        //   onClick: () => handleItemClick("Disconnection"),
        //   permission: true,
        // },
        // { key: 'BillCorrection', label: '', icon: IconWithLabel(NewConnection1, 'Bill Correction ('.concat('0', ")")), onClick: () => handleItemClick('BillCorrection'), permission: CheckPermissions(permissions, permissionsVariables.generalServices, "Reconnection") },
        { key: 'MeterReadingCorrection', label: '', icon: IconWithLabel(bell, 'Meter Reading Correction'), onClick: () => handleItemClick('MeterReadingCorrection'), permission: hasServicePermission(permissions, permissionsVariables.meterReadingCorrection) },
        {
          key: "ChangeofAttributes",
          label: "",
          icon: IconWithLabel(ChangeOfName1, "Change of Attributes"),
          onClick: () => handleItemClick("ChangeOfName"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.generalServices,
            permissionsVariables.changeOfAttributes,
          ),
        },
        {
          key: "AdjustLastBill",
          label: "",
          icon: IconWithLabel(adjustLastBill, "Adjust Last Bill"),
          onClick: () => handleItemClick("AdjustLastBill"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.generalServices,
            permissionsVariables.adjustLastBill,
          ),
        },

        // {
        //   key: 'ChangeofAttributes', label: 'Change of Attributes',
        //   onClick: () => handleItemClick('ChangeofAttributed'),
        //   permission: CheckPermissions(permissions, permissionsVariables.generalServices, "Change of Attributes"),
        //   icon: IconWithLabel(ChangeOfName1, 'Change of Attributes'), children: [
        //     { key: 'ChangeOfName', label: '', onClick: () => handleItemClick('ChangeOfName'), icon: IconWithLabel(ChangeOfName1, 'Change of Name'), permission: CheckPermissions(permissions, permissionsVariables.generalServices, "Change of Attributes"), },
        //     { key: 'ChangeOfLoad', label: '', onClick: () => handleItemClick('ChangeOfLoad'), icon: IconWithLabel(ChangeOfLoad1, 'Change of Load'), permission: CheckPermissions(permissions, permissionsVariables.generalServices, "Change of Attributes"), },
        //     { key: 'ChangeOfTariff', label: '', onClick: () => handleItemClick('ChangeOfTariff'), icon: IconWithLabel(ChangeOfTariff1, 'Change of Tariff'), permission: CheckPermissions(permissions, permissionsVariables.generalServices, "Change of Attributes"), },
        //   ],
        // },
        // { key: 'ShiftToNetMeter', label: '', icon: IconWithLabel(OptForNetMetering1, 'Shift To Net Meter ('.concat(totalNetMeteringApplications ? numberFormatting(totalNetMeteringApplications) : "0", ")")), onClick: () => handleItemClick('ShiftToNetMeter'), permission: CheckPermissions(permissions, permissionsVariables.generalServices, "Shift to Net Meter"), },
        {
          key: "UpdateTenantCNIC",
          label: "",
          icon: IconWithLabel(cnicupdation, "Update Tenant CNIC"),
          onClick: () => handleItemClick("UpdateTenantCNIC"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.generalServices,
            permissionsVariables.tenantCNICUpdation,
          ),
        },
        {
          key: "MeterChangeRequest",
          label: "",
          icon: IconWithLabel(meterChangeRequest, "Meter Change Order"),
          onClick: () => handleItemClick("MeterChangeRequest"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.generalServices,
            permissionsVariables.mco,
          ),
        },
        {
          key: "DuplicateBill",
          label: "",
          icon: IconWithLabel(duplicateBill, "Duplicate Bill"),
          onClick: () => handleItemClick("DuplicateBill"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.generalServices,
            permissionsVariables.mco,
          ),
        },
        // {
        //   key: "DuplicateBill",
        //   label: "",
        //   icon: IconWithLabel(duplicateBill, "Duplicate Bill"),
        //   onClick: () => handleItemClick("DuplicateBill"),

        // },
        // { key: 'PowerComplaintTable', label: '', icon: IconWithLabel(complaints, 'Power Complaints ('.concat(totalComplaintsApplications ? numberFormatting(totalComplaintsApplications) : "0", ")")), onClick: () => handleItemClick('PowerComplaintTable'), permission: true },
        // { key: 'Wrong Reading', label: '', icon: IconWithLabel(complaints, 'Wrong Reading ('.concat(totalComplaintsApplications ? numberFormatting(totalComplaintsApplications) : "0", ")")), onClick: () => handleItemClick('WrongReadingTable'), permission: true },
        {
          key: "CommercialReports",
          label: "",
          icon: IconWithLabel(Reports1, "Reports / Summary"),
          onClick: () => handleItemClick("CommercialReports"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.generalServices,
            permissionsVariables.reports,
          ),
          children: [
            {
              key: "NewConnectionReports",
              label: "",
              icon: IconWithLabel(Reports1, "New Connection Reports"),
              onClick: () => handleItemClick("NewConnectionReports"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.generalServices,
                permissionsVariables.reports,
                permissionsVariables.newConnection,
              ),
              children: [
                {
                  key: "NewConnectionReport",
                  label: "",
                  icon: IconWithLabel(Reports1, "New Connection Summary"),
                  onClick: () => handleItemClick("NewConnectionReport"),
                  permission: CheckPermissions(
                    permissions,
                    permissionsVariables.generalServices,
                    permissionsVariables.reports,
                    permissionsVariables.newConnection,
                    "New Connection Summary",
                  ),
                },
                {
                  key: "NewConnectionPostedToIBSReport",
                  label: "",
                  icon: IconWithLabel(
                    Reports1,
                    "New Connection Posted for Proof Listing",
                  ),
                  onClick: () =>
                    handleItemClick("NewConnectionPostedToIBSReport"),
                  permission: CheckPermissions(
                    permissions,
                    permissionsVariables.generalServices,
                    permissionsVariables.reports,
                    permissionsVariables.newConnection,
                    "Posted to IBS for Proof Listin",
                  ),
                },
                {
                  key: "NewConnectionSubDivisionWiseApplicationsStatus",
                  label: "",
                  icon: IconWithLabel(
                    Reports1,
                    "New Connection Exceeded Application Summary",
                  ),
                  onClick: () =>
                    handleItemClick(
                      "NewConnectionSubDivisionWiseApplicationsStatus",
                    ),
                  permission: CheckPermissions(
                    permissions,
                    permissionsVariables.generalServices,
                    permissionsVariables.reports,
                    permissionsVariables.newConnection,
                    "Exceeded Applicaitons",
                  ),
                },
                {
                  key: "NewConnectionStatusReport",
                  label: "",
                  icon: IconWithLabel(Reports1, "New Connection Status Report"),
                  onClick: () => handleItemClick("NewConnectionStatusReport"),
                  permission: CheckPermissions(
                    permissions,
                    permissionsVariables.generalServices,
                    permissionsVariables.reports,
                    permissionsVariables.newConnection,
                    "Status Report",
                  ),
                },
                {
                  key: "NewConnectionStatusWiseCountReport",
                  label: "",
                  icon: IconWithLabel(
                    Reports1,
                    "New Connection Status Wise Count Report",
                  ),
                  onClick: () =>
                    handleItemClick("NewConnectionStatusWiseCountReport"),
                  permission: CheckPermissions(
                    permissions,
                    permissionsVariables.generalServices,
                    permissionsVariables.reports,
                    permissionsVariables.newConnection,
                    "NC Status-wise Count Report",
                  ),
                },
                {
                  key: "NewConnectionCancelApplicationReport",
                  label: "",
                  icon: IconWithLabel(Reports1, "NC Cancel Application Report"),
                  onClick: () =>
                    handleItemClick("NewConnectionCancelApplicationReport"),
                  permission: CheckPermissions(
                    permissions,
                    permissionsVariables.generalServices,
                    permissionsVariables.reports,
                    permissionsVariables.newConnection,
                    "NC Cancel Applications",
                  ),
                },
                {
                  key: "ExceededMonthWisePendingRipeReport",
                  label: "",
                  icon: IconWithLabel(
                    Reports1,
                    "Exceeded Month-Wise Pending Ripe Applications",
                  ),
                  onClick: () =>
                    handleItemClick("ExceededMonthWisePendingRipeReport"),
                  permission: CheckPermissions(
                    permissions,
                    permissionsVariables.generalServices,
                    permissionsVariables.reports,
                    permissionsVariables.newConnection,
                    "Exceeded Month-Wise Pending Ripe",
                  ),
                },
                {
                  key: "SrReports",
                  label: "",
                  icon: IconWithLabel(Reports1, "SR NC Report"),
                  onClick: () => handleItemClick("SrOnEmail"),
                  permission: CheckPermissions(
                    permissions,
                    permissionsVariables.generalServices,
                    permissionsVariables.reports,
                    permissionsVariables.newConnection,
                    "New Connection SR",
                  ),
                },
                {
                  key: "PerformanceEvaluationReport",
                  label: "",
                  icon: IconWithLabel(Reports1, "NC Performance Evaluation Report"),
                  onClick: () => handleItemClick("PerformanceEvaluationReport"),
                  permission: CheckPermissions(
                    permissions,
                    permissionsVariables.generalServices,
                    permissionsVariables.reports,
                    permissionsVariables.newConnection,
                    "PerformanceEvaluationReport",
                  ),
                },
                {
                  key: "CancelApplicationsDueToNonPaymentReport",
                  label: "",
                  icon: IconWithLabel(
                    Reports1,
                    "Cancel Applications Due To Non Payment",
                  ),
                  onClick: () =>
                    handleItemClick("CancelApplicationsDueToNonPaymentReport"),
                  permission: CheckPermissions(
                    permissions,
                    permissionsVariables.generalServices,
                    permissionsVariables.reports,
                    permissionsVariables.newConnection,
                    "CancelAppsDueToNonPayment",
                  ),
                },
                {
                  key: "MdmSyncReport",
                  label: "",
                  icon: IconWithLabel(Reports1, "NC MDM Sync Report"),
                  onClick: () => handleItemClick("MdmSyncReport"),
                  permission: CheckPermissions(
                    permissions,
                    permissionsVariables.generalServices,
                    permissionsVariables.reports,
                    permissionsVariables.newConnection,
                    // "MdmSyncReport",
                  ),
                },
              ],
            },
            {
              key: "ChangeOfAttributesReports",
              label: "",
              icon: IconWithLabel(Reports1, "Change of Attributes Reports"),
              onClick: () => handleItemClick("ChangeOfAttributesReports"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.generalServices,
                permissionsVariables.reports,
                permissionsVariables.changeOfAttributes,
              ),
              children: [
                {
                  key: "COASummaryReports",
                  label: "",
                  icon: IconWithLabel(Reports1, "COA Summary Reports"),
                  onClick: () => handleItemClick("COASummaryReports"),
                  permission: CheckPermissions(
                    permissions,
                    permissionsVariables.generalServices,
                    permissionsVariables.reports,
                    permissionsVariables.changeOfAttributes,
                    "COA Summary Reports"
                  ),
                },
                {
                  key: "COASrReports",
                  label: "",
                  icon: IconWithLabel(Reports1, "COA SR Report"),
                  onClick: () => handleItemClick("COASrOnEmail"),
                  permission: CheckPermissions(
                    permissions,
                    permissionsVariables.generalServices,
                    permissionsVariables.reports,
                    permissionsVariables.changeOfAttributes,
                    "SR Report "
                  ),
                },
                {
                  key: "COAStatusReports",
                  label: "",
                  icon: IconWithLabel(Reports1, "COA Status Report"),
                  onClick: () => handleItemClick("COAStatusReports"),
                  permission: CheckPermissions(
                    permissions,
                    permissionsVariables.generalServices,
                    permissionsVariables.reports,
                    permissionsVariables.changeOfAttributes,
                    "COA Status Report"
                  ),
                },
                {
                  key: "ChangeOfAttributesPostedToIBSReport",
                  label: "",
                  icon: IconWithLabel(Reports1, "COA Posted to IBS Report"),
                  onClick: () => handleItemClick("ChangeOfAttributesPostedToIBSReport"),
                  permission: CheckPermissions(
                    permissions,
                    permissionsVariables.generalServices,
                    permissionsVariables.reports,
                    permissionsVariables.changeOfAttributes,
                    "COA Posted to IBS Report"
                  ),
                },
                {
                  key: "ChangeOfAttributesStatusWiseCountReport",
                  label: "",
                  icon: IconWithLabel(Reports1, "COA Status Wise Count Report"),
                  onClick: () => handleItemClick("ChangeOfAttributesStatusWiseCountReport"),
                  permission: CheckPermissions(
                    permissions,
                    permissionsVariables.generalServices,
                    permissionsVariables.reports,
                    permissionsVariables.changeOfAttributes,
                    "COA Status Wise Count Report"
                  ),
                },
                {
                  key: "ChangeOfAttributesCancelApplicationReport",
                  label: "",
                  icon: IconWithLabel(Reports1, "COA Cancel Application Report"),
                  onClick: () => handleItemClick("ChangeOfAttributesCancelApplicationReport"),
                  permission: CheckPermissions(
                    permissions,
                    permissionsVariables.generalServices,
                    permissionsVariables.reports,
                    permissionsVariables.changeOfAttributes,
                    "COA Cancel Applications"
                  ),
                },
              ],
            },
            {
              key: "ReconnectionReports ",
              label: "",
              icon: IconWithLabel(Reports1, "Reconnection Reports"),
              onClick: () => handleItemClick("ReconnectionReports"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.generalServices,
                permissionsVariables.reports,
                permissionsVariables.reConnection,
              ),
              children: [
                {
                  key: "ReconnectionPostedToIBSReport",
                  label: "",
                  icon: IconWithLabel(Reports1, "Reconnection Posted to IBS Report"),
                  onClick: () => handleItemClick("ReconnectionPostedToIBSReport"),
                  permission: CheckPermissions(
                    permissions,
                    permissionsVariables.generalServices,
                    permissionsVariables.reports,
                    permissionsVariables.reConnection,
                    "RCO Posted to IBS Report"
                  ),
                },
                {
                  key: "ReconnectionStatusReport",
                  label: "",
                  icon: IconWithLabel(Reports1, "Reconnection Status Report"),
                  onClick: () => handleItemClick("ReconnectionStatusReport"),
                  permission: CheckPermissions(
                    permissions,
                    permissionsVariables.generalServices,
                    permissionsVariables.reports,
                    permissionsVariables.reConnection,
                    "RCO Status Report"
                  ),
                },
              ],
            },
            {
              key: "MeterChangeOrderStatusReport",
              label: "",
              icon: IconWithLabel(Reports1, "Meter Change Order Status Report"),
              onClick: () => handleItemClick("MeterChangeOrderStatusReport"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.generalServices,
                permissionsVariables.reports,
                "MCO",
                "Status Report",
              ),
            },
            {
              key: "DueDateExtensionReport",
              label: "",
              icon: IconWithLabel(Reports1, "Due Date Extension Report"),
              onClick: () => handleItemClick("DueDateExtensionReport"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.generalServices,
                permissionsVariables.reports,
                "Due Date Extension Report",
              ),
            },
            {
              key: "InstallmentReport",
              label: "",
              icon: IconWithLabel(Reports1, "Installment Reports"),
              onClick: () => handleItemClick("InstallmentReport"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.generalServices,
                permissionsVariables.reports,
                "Installment Report",
              ),
            },
            // {
            //   key: "MeterReadingCorrectionReport",
            //   label: "",
            //   icon: IconWithLabel(Reports1, "Meter Reading Correction Report"),
            //   onClick: () => handleItemClick("MeterReadingCorrectionReport"),
            //   permission: CheckPermissions(
            //     permissions,
            //     permissionsVariables.generalServices,
            //     permissionsVariables.reports,
            //     "Meter Reading Correction"
            //   ),
            // },
            {
              key: "CashCollectionReport",
              label: "",
              icon: IconWithLabel(Reports1, "Cash Collection Report"),
              onClick: () => handleItemClick("CashCollectionReport"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.generalServices,
                permissionsVariables.reports,
                "Cash Collection Report",
              ),
              children: [
                {
                  key: "CashCollectionSummaryReport",
                  label: "",
                  icon: IconWithLabel(Reports1, "Cash Collection Summary"),
                  onClick: () => handleItemClick("CashCollectionSummaryReport"),
                  permission: CheckPermissions(
                    permissions,
                    permissionsVariables.generalServices,
                    permissionsVariables.reports,
                    "Cash Collection Report",
                  ),
                },
                {
                  key: "BatchWiseAssessment",
                  label: "",
                  icon: IconWithLabel(Reports1, "(Batch-Wise) Assessment"),
                  onClick: () => handleItemClick("BatchWiseAssessment"),
                  permission: CheckPermissions(
                    permissions,
                    permissionsVariables.generalServices,
                    permissionsVariables.reports,
                    "Cash Collection Report",
                  ),
                },
              ],
            },
            {
              key: "DailyProgressReport",
              label: "",
              icon: IconWithLabel(Reports1, "Daily Progress Report"),
              onClick: () => handleItemClick("DailyProgressReport"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.generalServices,
                permissionsVariables.reports,
                "Daily Progress Report",
              ),
            },
            {
              key: "DailyProgressReportCfcWise",
              label: "",
              icon: IconWithLabel(Reports1, "Daily Progress Report CFC Wise"),
              onClick: () => handleItemClick("DailyProgressReportCfcWise"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.generalServices,
                permissionsVariables.reports,
                "CFC Wise Progress Report",
              ),
            },
            {
              key: "FeederLossesReport",
              label: "",
              icon: IconWithLabel(Reports1, "Feeder Losses Report"),
              onClick: () => handleItemClick("FeederLossesReport"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.generalServices,
                permissionsVariables.reports,
                "Feeder Losses Report",
              ),
            },
            {
              key: "DeadDefaulterReport",
              label: "",
              icon: IconWithLabel(Reports1, "Dead Defaulter Report"),
              onClick: () => handleItemClick("DeadDefaulterReport"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.generalServices,
                permissionsVariables.reports,
                "Dead Defaulter Report",
              ),
            },
            {
              key: "ComputedBillingAndCollectionAnalysis",
              label: "",
              icon: IconWithLabel(
                Reports1,
                "Collection Vs Computed Assessment (Category Wise)",
              ),
              onClick: () =>
                handleItemClick("ComputedBillingAndCollectionAnalysis"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.generalServices,
                permissionsVariables.reports,
                "Collection Vs Computed Assessm",
              ),
            },
          ],
        },
        // {
        //   key: 'SrReports', label: 'SR Reports',permission: true,
        //   onClick: () => handleItemClick('SrReports'),
        //   permission: CheckPermissions(permissions, 'General Services', 'Reports', "New Connection SR"),
        //   icon: IconWithLabel(ChangeOfName1, 'SR Reports'), children: [
        //     { key: 'SrOnEmail', label: '', onClick: () => handleItemClick('SrOnEmail'), icon: IconWithLabel(ChangeOfName1, 'Sr On Email'), },
        //   ],
        // },
      ],
    },
    {
      key: "TechnicalOperations",
      label: "",
      icon: IconWithLabel(
        <EngineeringIcon sx={{ fontSize: 18 }} />,
        "Technical Operations",
        "green",
      ),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
      ),
      children: [
        {
          key: "NewComplaint",
          label: "",
          onClick: () => handleItemClick("NewComplaint"),
          icon: IconWithLabel(complaints, "New Complaint"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "New Complaint",
          ),
        },
        {
          key: "LoggedInUsers",
          label: "",
          onClick: () => handleItemClick("LoggedInUsers"),
          icon: IconWithLabel(permissionManagement, "Logged In Users"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "Logged In Users",
          ),
        },
        {
          key: "LinemanAPPUserSummary",
          label: "",
          onClick: () => handleItemClick("LinemanAPPUserSummary"),
          icon: IconWithLabel(permissionManagement, "Logged In User Summary"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "User Logged In Summary",
          ),
        },
        {
          key: "ComplaintAndControlCenter",
          label: "",
          icon: IconWithLabel(GIS, "Comp. & Control Center"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
          ),
          children: [
            {
              key: "CircleHome",
              label: "",
              onClick: () => {
                dispatch(updateHomeButton(true));
              },
              icon: IconWithLabel(home1, "Home"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                "Technical Dashboard",
              ),
            },
            // {
            //   key: "NewComplaintCCC",
            //   label: "",
            //   onClick: () => handleItemClick("NewComplaint"),
            //   icon: IconWithLabel(complaints, "New Complaint"),
            //   permission: CheckPermissions(
            //     permissions,
            //     permissionsVariables.powerComplaints,
            //     "New Complaint",
            //   ),
            // },
            {
              key: "Map",
              label: "",
              onClick: () => handleItemClick("ComplaintAndControlCenter"),
              icon: IconWithLabel(GIS, "Map"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                "ComplaintAndControlCenter",
              ),
            },
            // {
            //   key: "FeederList",
            //   label: "",
            //   onClick: () => handleItemClick("FeederList"),
            //   icon: IconWithLabel(feederIcon1, "Feeder List"),
            //   permission: CheckPermissions(
            //     permissions,
            //     permissionsVariables.powerComplaints,
            //     "Feeder List",
            //   ),
            // },
            {
              key: "FeederList",
              label: "",
              onClick: () => handleItemClick("FeederList"),
              icon: IconWithLabel(feederIcon1, "Feeder List"),
              permission: canShowFeederListMenu,
            },
            {
              key: "ApmsList",
              label: "",
              onClick: () => handleItemClick("ApmsList"),
              icon: IconWithLabel(transformer1, "APMS List"),
              permission: canShowApmsListMenu,
            },
            {
              key: "APMSDashboard",
              label: "",
              onClick: () => handleItemClick("APMSDashboard"),
              icon: IconWithLabel(transformer1, "APMS Dashboard"),
              permission:
                showAPMSDashboard &&
                CheckPermissions(
                  permissions,
                  permissionsVariables.powerComplaints,
                  "APMS List",
                ),
            },

            {
              key: "Linemen",
              label: "",
              onClick: () => handleItemClick("Linemen"),
              icon: IconWithLabel(lineman1, "Line Staff"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                "Line Staff",
              ),
            },
          ],
        },
        // { key: 'LineStaffPerformance', label: '', onClick: () => handleItemClick('LineStaffPerformance'), icon: IconWithLabel(staffPerformance, 'Line Staff Performance'), permission: CheckPermissions(permissions, permissionsVariables.powerComplaints, 'Line Staff Performance'), },
        {
          key: "LoadSheddingSchedule",
          label: "",
          onClick: () => handleItemClick("LoadSheddingSchedule"),
          icon: IconWithLabel(Disconnection1, "Load Shedding Schedule"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "Load Shedding Schedule",
          ),
        },
        {
          key: "MobileAppStats",
          label: "",
          onClick: () => handleItemClick("MobileAppStats"),
          icon: IconWithLabel(smartphone, "Mobile App Stats"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "Power Smart Mobile App Summary",
          ),
        },
        {
          key: "Complaints Management",
          label: "",
          icon: IconWithLabel(Complaintsmanagemnt, "Complaints Management"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
          ),
          children: [
            {
              key: "PendingComplaints",
              label: "",
              onClick: () => handleItemClick("PendingComplaints"),
              icon: IconWithLabel(Pending1, "Pending Complaints"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                "Pending Complaints",
              ),
            },
            {
              key: "AllocatedComplaints",
              label: "",
              onClick: () => handleItemClick("AllocatedComplaints"),
              icon: IconWithLabel(Allocated1, "Allocated Complaints"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                "Allocated Complaints",
              ),
            },
            {
              key: "WorkingComplaints",
              label: "",
              onClick: () => handleItemClick("WorkingComplaints"),
              icon: IconWithLabel(Working1, "Working Complaints"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                "Working Complaints",
              ),
            },
            {
              key: "OnholdComplaints",
              label: "",
              onClick: () => handleItemClick("OnholdComplaints"),
              icon: IconWithLabel(Onhold1, "Onhold Complaints"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                "Onhold Complaints",
              ),
            },
            {
              key: "EscalatedComplaints",
              label: "",
              onClick: () => handleItemClick("EscalatedComplaints"),
              icon: IconWithLabel(Escalated1, "Escalated Complaints"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                "Escalated Complaints",
              ),
            },

            // {
            //   key: "APMSSummaryReport",
            //   label: "APMS Summary Report",
            //   onClick: () => handleItemClick("APMSSummaryReport"),
            //   icon: IconWithLabel(Reports1, "APMS Summary Report"),
            //   permission: true
            // },
            {
              key: "APMSEscalatedComplaints",
              label: "",
              onClick: () => handleItemClick("APMSEscalatedComplaints"),
              icon: IconWithLabel(Escalated1, "APMS Escalated"),
              permission: true,
            },
            // {
            //   key: "APMSComplaintsSummary",
            //   label: "APMS Complaints Summary",
            //   onClick: () => handleItemClick("APMSComplaintsSummary"),
            //   icon: IconWithLabel(Reports1, "APMS Complaints Summary"),
            //   permission: true,
            // },
            {
              key: "ResolvedComplaints",
              label: "",
              onClick: () => handleItemClick("ResolvedComplaints"),
              icon: IconWithLabel(Resolved1, "Resolved Complaints"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                "Resolved Complaints",
              ),
            },
          ],
        },
        {
          key: "ComplaintDetailedHistory",
          label: "",
          onClick: () => handleItemClick("ComplaintDetailedHistory"),
          icon: IconWithLabel(
            <HistoryOutlinedIcon sx={{ fontSize: 18 }} />,
            "Comp. Detailed History",
          ),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "New Complaint",
          ),
        },
        {
          key: "ComplaintsReports",
          label: "",
          onClick: () => handleItemClick("ComplaintsReports"),
          icon: IconWithLabel(Reports1, "Reports / Summary"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
          ),
          children: [
            {
              key: "ComplaintRegister",
              label: "",
              onClick: () => handleItemClick("ComplaintRegister"),
              icon: IconWithLabel(Reports1, "Complaint Register"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                "Complaint Register",
              ),
            },
            {
              key: "ComplaintsSummary",
              label: "",
              onClick: () => handleItemClick("ComplaintsSummary"),
              icon: IconWithLabel(Reports1, "Complaints Summary"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                "Complaint Summary",
              ),
            },
            // {
            //   key: "EscalationComplaints",
            //   label: "",
            //   onClick: () => handleItemClick("EscalationComplaints"),
            //   icon: IconWithLabel(Reports1, "Escalation Complaints"),
            //   permission: CheckPermissions(
            //     permissions,
            //     permissionsVariables.powerComplaints,
            //     "Escalation Complaints",
            //   ),
            // },
            {
              key: "APMSComplaintsSummary",
              label: "",
              onClick: () => handleItemClick("APMSComplaintsSummary"),
              icon: IconWithLabel(Reports1, "APMS Complaints Summary"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                permissionsVariables.reports,
                "APMS Compalint Summary",
              ),
            },
            {
              key: "SubdivisionWiseAPMSComplaintSummary",
              label: "",
              onClick: () => handleItemClick("SubdivisionWiseAPMSComplaintSummary"),
              icon: IconWithLabel(
                Reports1,
                "CAD APMS Stats",
              ),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                permissionsVariables.reports,
                "APMSResolvedComplaintStats",
              ),
            },
            {
              key: "CADLineComplaintsStats",
              label: "",
              onClick: () => handleItemClick("CADLineComplaintsStats"),
              icon: IconWithLabel(
                Reports1,
                "CAD Line Complaints Stats",
              ),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                permissionsVariables.reports,
                "CADLineComplaintsStats",
              ),
            },
            {
              key: "FeederLengthReport",
              label: "",
              onClick: () => handleItemClick("FeederLengthReport"),
              icon: IconWithLabel(Reports1, "Feeder Length Report"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                permissionsVariables.reports,
                "CADLineComplaintsStats",
              ),
            },
            {
              key: "EopsMobileAppUsageSummary",
              label: "",
              onClick: () => handleItemClick("EopsMobileAppUsageSummary"),
              icon: IconWithLabel(Reports1, "eOps Mobile App Usage Summary"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                permissionsVariables.reports,
                "eOps Mobile App Usage Summary",
              ),
            },
            {
              key: "NotLoggedInUserInLast24Hours",
              label: "",
              onClick: () => handleItemClick("NotLoggedInUserInLast24Hours"),
              icon: IconWithLabel(
                Reports1,
                "Not Logged In User In Last 24 Hours",
              ),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                permissionsVariables.reports,
                "Not logged in Users",
              ),
            },
            {
              key: "EopsUsersStatus",
              label: "",
              onClick: () => handleItemClick("EopsUsersStatus"),
              icon: IconWithLabel(Reports1, "Eops Users Status"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                permissionsVariables.reports,
                "eOps Users Status Report",
              ),
            },
            {
              key: "UserComplaintProcessingStatistics",
              label: "",
              onClick: () =>
                handleItemClick("UserComplaintProcessingStatistics"),
              icon: IconWithLabel(
                Reports1,
                "User Complaint Processing Statistics",
              ),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                permissionsVariables.reports,
                "Staff Performance",
                "User Complaint Processing Stat",
              ),
            },
            {
              key: "ComplaintSourceWise",
              label: "",
              onClick: () => handleItemClick("ComplaintSourceWise"),
              icon: IconWithLabel(Reports1, "Source & Complaint Type Wise"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                permissionsVariables.reports,
                "eOps Users Status Report",
              ),
            },
            {
              key: "TopBestAndWorstPerformer",
              label: "",
              onClick: () => handleItemClick("TopBestAndWorstPerformer"),
              icon: IconWithLabel(
                Reports1,
                "Top Best And Worst Field Staff Performer",
              ),
              permission:
                CheckPermissions(
                  permissions,
                  permissionsVariables.powerComplaints,
                  permissionsVariables.reports,
                  permissionsVariables.staffPerformance,
                  "Top 5% Best Performers",
                ) ||
                CheckPermissions(
                  permissions,
                  permissionsVariables.powerComplaints,
                  permissionsVariables.reports,
                  permissionsVariables.staffPerformance,
                  "Worst 10% Non-Performers",
                ),
            },
            // { key: 'PendingComplaints', label: 'Pending Complaints', onClick: () => handleItemClick('PendingComplaints'), icon: IconWithLabel(Pending1, 'Pending Complaints'), permission: CheckPermissions(permissions, permissionsVariables.powerComplaints, 'Pending Complaints'), },
            // { key: 'AllocatedComplaints', label: 'Allocated Complaints', onClick: () => handleItemClick('AllocatedComplaints'), icon: IconWithLabel(Allocated1, 'Allocated Complaints'), permission: CheckPermissions(permissions, permissionsVariables.powerComplaints, 'Allocated Complaints'), },
            // { key: 'WorkingComplaints', label: 'Working Complaints', onClick: () => handleItemClick('WorkingComplaints'), icon: IconWithLabel(Working1, 'Working Complaints'), permission: CheckPermissions(permissions, permissionsVariables.powerComplaints, 'Working Complaints'), },
            // { key: 'OnholdComplaints', label: 'Onhold Complaints', onClick: () => handleItemClick('OnholdComplaints'), icon: IconWithLabel(Onhold1, 'Onhold Complaints'), permission: CheckPermissions(permissions, permissionsVariables.powerComplaints, 'Onhold Complaints'), },
            // { key: 'EscalatedComplaints', label: 'Escalated Complaints', onClick: () => handleItemClick('EscalatedComplaints'), icon: IconWithLabel(Escalated1, 'Escalated Complaints'), permission: CheckPermissions(permissions, permissionsVariables.powerComplaints, 'Escalated Complaints'), },
            // { key: 'ResolvedComplaints', label: 'Resolved Complaints', onClick: () => handleItemClick('ResolvedComplaints'), icon: IconWithLabel(Resolved1, 'Resolved Complaints'), permission: CheckPermissions(permissions, permissionsVariables.powerComplaints, 'Resolved Complaints'), },

            // { key: 'ResolvedComplaints', label: 'Logout', onClick: () => handleItemClick('ResolvedComplaints'), icon: IconWithLabel(Resolved1, 'Logout'), permission: CheckPermissions(permissions, permissionsVariables.powerComplaints), },
          ],
        },
      ],
    },
    {
      key: "AccessManagement",
      icon: IconWithLabel(
        <AdminPanelSettingsIcon sx={{ fontSize: 18 }} />,
        "Access Management",
        "purple",
      ),
      label: "",
      permission:
        canManageRolesAndPermissions(code, roleId) ||
        CheckPermissions(
          permissions,
          permissionsVariables.accessManagement,
        ),
      onClick: () => handleItemClick("AccessManagement"),
      // children: [
      //   { key: 'WorkforceManagement', label: '', onClick: () => handleItemClick('WorkforceManagement'), icon: IconWithLabel(usermanagement, 'Workforce Management'), permission: CheckPermissions(permissions, permissionsVariables.accessManagement, 'User Management') },
      //   { key: 'UserManagement', label: '', onClick: () => handleItemClick('UserManagement'), icon: IconWithLabel(usermanagement, 'User Management'), permission: CheckPermissions(permissions, permissionsVariables.accessManagement, 'User Management') },
      //   { key: 'RoleManagement', label: '', onClick: () => handleItemClick('RoleManagement'), icon: IconWithLabel(roleMgmt, 'Role Management'), permission:   CheckPermissions(permissions, permissionsVariables.accessManagement, 'Role Management') },
      //   { key: 'PermissionManagement', label: '', onClick: () => handleItemClick('PermissionManagement'), icon: IconWithLabel(permissionManagement, 'Permission Management'), permission:  CheckPermissions(permissions, permissionsVariables.accessManagement, 'Role Management') },
      // ]
      children: [
        {
          key: "WorkforceManagement",
          label: "",
          onClick: () => handleItemClick("WorkforceManagement"),
          icon: IconWithLabel(usermanagement, "Workforce Management"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.accessManagement,
            "Workforce Management",
          ),
        },
        {
          key: "UserManagement",
          label: "",
          onClick: () => handleItemClick("UserManagement"),
          icon: IconWithLabel(usermanagement, "User Management"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.accessManagement,
            "User Management",
          ),
        },
        ...(canManageRolesAndPermissions(code, roleId)
          ? [
            {
              key: "RoleManagement",
              label: "",
              onClick: () => handleItemClick("RoleManagement"),
              icon: IconWithLabel(roleMgmt, "Role Management"),
              permission:
                canManageRolesAndPermissions(code, roleId) ||
                CheckPermissions(
                  permissions,
                  permissionsVariables.accessManagement,
                  "Role Management",
                ),
            },
            {
              key: "PermissionManagement",
              label: "",
              onClick: () => handleItemClick("PermissionManagement"),
              icon: IconWithLabel(
                permissionManagement,
                "Permission Management",
              ),
              permission:
                canManageRolesAndPermissions(code, roleId) ||
                CheckPermissions(
                  permissions,
                  permissionsVariables.accessManagement,
                  "Permission Management",
                ),
            },
          ]
          : []),
      ],
    },
    {
      key: "OrganizationManagement",
      icon: IconWithLabel(
        <CorporateFareOutlinedIcon sx={{ fontSize: 18 }} />,
        "Organization Management",
        "teal",
      ),
      label: "",
      onClick: () => handleItemClick("OrganizationManagement"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.organizationManagement,
      ),
      children: [
        {
          key: "Company",
          label: "",
          onClick: () => handleItemClick("Company"),
          icon: IconWithLabel(companyIcon, "Company"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.organizationManagement,
            "Company Management",
          ),
        },
        {
          key: "Circle",
          label: "",
          onClick: () => handleItemClick("Circle"),
          icon: IconWithLabel(circleIcon, "Circle"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.organizationManagement,
            "Circle Management",
          ),
        },
        {
          key: "Division",
          label: "",
          onClick: () => handleItemClick("Division"),
          icon: IconWithLabel(divisionIcon, "Division"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.organizationManagement,
            "Division Management",
          ),
        },
        {
          key: "CFC",
          label: "",
          onClick: () => handleItemClick("CFC"),
          icon: IconWithLabel(
            supportCenterIcon,
            "Customer Facilitation Center",
          ),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.organizationManagement,
            "CSC Management",
          ),
        },
        {
          key: "SubDivision",
          label: "",
          onClick: () => handleItemClick("SubDivision"),
          icon: IconWithLabel(subDivisionIcon, "Sub Division"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.organizationManagement,
            "Sub Division Management",
          ),
        },
      ],
    },
    {
      key: "EopsUpdates",
      icon: IconWithLabel(
        <CampaignIcon sx={{ fontSize: 18 }} />,
        "eOps Updates",
        "amber",
      ),
      label: "",
      onClick: () => handleItemClick("EopsUpdates"),
      permission:
        code == 10 &&
        CheckPermissions(
          permissions,
          permissionsVariables.accessManagement,
          "eOps Updates",
        ),
      // true,
    },
  ];

  const tacItems = [
    // { icon: IconWithLabel(home1, 'Home'),  permission: CheckPermissions(permissions, permissionsVariables.powerComplaints), },
    {
      key: "HomeTac",
      label: "",
      onClick: () => handleItemClick("HomeTac"),
      icon: IconWithLabel(home1, "Home"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
        "Technical Dashboard",
      ),
    },
    {
      key: "NewComplaint",
      label: "",
      onClick: () => handleItemClick("NewComplaint"),
      icon: IconWithLabel(complaints, "New Complaint"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
        "New Complaint",
      ),
    },
    {
      key: "ComplaintAndControlCenter",
      label: "",
      onClick: () => handleItemClick("ComplaintAndControlCenter"),
      icon: IconWithLabel(GIS, "Comp. & Control Center"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
        "ComplaintAndControlCenter",
      ),
    },
    {
      key: "FeederList",
      label: "",
      onClick: () => handleItemClick("FeederList"),
      icon: IconWithLabel(feederIcon1, "Feeder List"),
      permission: canShowFeederListMenu,
    },
    {
      key: "ApmsList",
      label: "",
      onClick: () => handleItemClick("ApmsList"),
      icon: IconWithLabel(transformer1, "APMS List"),
      permission: canShowApmsListMenu,
    },
    {
      key: "APMSDashboard",
      label: "",
      onClick: () => handleItemClick("APMSDashboard"),
      icon: IconWithLabel(transformer1, "APMS Dashboard"),
      permission:
        showAPMSDashboard &&
        CheckPermissions(
          permissions,
          permissionsVariables.powerComplaints,
          "APMS List",
        ),
    },
    // {
    //   key: "APMSDashboard",
    //   label: "",
    //   onClick: () => handleItemClick("APMSDashboard"),
    //   icon: IconWithLabel(apmsdashboard, "APMS Dashboard"),
    //   permission: CheckPermissions(
    //     permissions,
    //     permissionsVariables.powerComplaints,
    //     "APMS List"
    //   ),
    // },
    {
      key: "Linemen",
      label: "",
      onClick: () => handleItemClick("Linemen"),
      icon: IconWithLabel(lineman1, "Line Staff"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.accessManagement,
        "Workforce Management",
      ),
    },
    // { key: 'LineStaffPerformance', label: '', onClick: () => handleItemClick('LineStaffPerformance'), icon: IconWithLabel(staffPerformance, 'Line Staff Performance'), permission: CheckPermissions(permissions, permissionsVariables.powerComplaints, 'Line Staff Performance'), },
    {
      key: "LoadSheddingSchedule",
      label: "",
      onClick: () => handleItemClick("LoadSheddingSchedule"),
      icon: IconWithLabel(Disconnection1, "Load Shedding Schedule"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
        "Load Shedding Schedule",
      ),
    },
    {
      key: "MobileAppStats",
      label: "",
      onClick: () => handleItemClick("MobileAppStats"),
      icon: IconWithLabel(smartphone, "Mobile App Stats"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
        "Power Smart Mobile App Summary",
      ),
    },
    {
      key: "ComplaintDetailedHistory",
      label: "",
      onClick: () => handleItemClick("ComplaintDetailedHistory"),
      icon: IconWithLabel(
        <HistoryOutlinedIcon sx={{ fontSize: 18 }} />,
        "Comp. Detailed History",
      ),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
        "New Complaint",
      ),
    },
    {
      key: "ComplaintRegister",
      label: "",
      onClick: () => handleItemClick("ComplaintRegister"),
      icon: IconWithLabel(Reports1, "Complaint Register"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
        "Complaint Register",
      ),
    },
    {
      key: "APMS Complaints",
      label: "",
      icon: IconWithLabel(Reports1, "APMS Complaints"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
        permissionsVariables.reports,
      ),
      children: [
        {
          key: "APMSComplaintsSummary",
          label: "",
          onClick: () => handleItemClick("APMSComplaintsSummary"),
          icon: IconWithLabel(Reports1, "APMS Complaints Summary"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            permissionsVariables.reports,
            "APMS Compalint Summary",
          ),
        },
        {
          key: "SubdivisionWiseAPMSComplaintSummary",
          label: "",
          onClick: () => handleItemClick("SubdivisionWiseAPMSComplaintSummary"),
          icon: IconWithLabel(
            Reports1,
            "APMS Resolved Complaint Stats",
          ),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            permissionsVariables.reports,
            "APMSResolvedComplaintStats",
          ),
        },
        {
          key: "CADLineComplaintsStats",
          label: "",
          onClick: () => handleItemClick("CADLineComplaintsStats"),
          icon: IconWithLabel(
            Reports1,
            "CAD Line Complaints Stats",
          ),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            permissionsVariables.reports,
            "CADLineComplaintsStats",
          ),
        },
        {
          key: "FeederLengthReport",
          label: "",
          onClick: () => handleItemClick("FeederLengthReport"),
          icon: IconWithLabel(Reports1, "Feeder Length Report"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            permissionsVariables.reports,
            "CADLineComplaintsStats",
          ),
        },
      ],
    },
    {
      key: "Complaints Management",
      label: "",
      icon: IconWithLabel(Complaintsmanagemnt, "Complaints Management"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
      ),
      children: [
        {
          key: "PendingComplaints",
          label: "",
          onClick: () => handleItemClick("PendingComplaints"),
          icon: IconWithLabel(Pending1, "Pending Complaints"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "Pending Complaints",
          ),
        },
        {
          key: "AllocatedComplaints",
          label: "",
          onClick: () => handleItemClick("AllocatedComplaints"),
          icon: IconWithLabel(Allocated1, "Allocated Complaints"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "Allocated Complaints",
          ),
        },
        {
          key: "WorkingComplaints",
          label: "",
          onClick: () => handleItemClick("WorkingComplaints"),
          icon: IconWithLabel(Working1, "Working Complaints"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "Working Complaints",
          ),
        },
        {
          key: "OnholdComplaints",
          label: "",
          onClick: () => handleItemClick("OnholdComplaints"),
          icon: IconWithLabel(Onhold1, "Onhold Complaints"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "Onhold Complaints",
          ),
        },
        {
          key: "EscalatedComplaints",
          label: "",
          onClick: () => handleItemClick("EscalatedComplaints"),
          icon: IconWithLabel(Escalated1, "Escalated Complaints"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "Escalated Complaints",
          ),
        },

        // {
        //   key: "APMSSummaryReport",
        //   label: "APMS Summary Report",
        //   onClick: () => handleItemClick("APMSSummaryReport"),
        //   icon: IconWithLabel(Reports1, "APMS Summary Report"),
        //   permission: true
        // },
        {
          key: "APMSEscalatedComplaints",
          label: "",
          onClick: () => handleItemClick("APMSEscalatedComplaints"),
          icon: IconWithLabel(Escalated1, "APMS Escalated"),
          permission: true,
        },

        {
          key: "ResolvedComplaints",
          label: "",
          onClick: () => handleItemClick("ResolvedComplaints"),
          icon: IconWithLabel(Resolved1, "Resolved Complaints"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "Resolved Complaints",
          ),
        },
      ],
    },
    {
      key: "Logout",
      label: "",
      icon: IconWithLabel(Logout1, "Logout"),
      permission: true,
    },
  ];

  const tacItemsCircle = [
    // { icon: IconWithLabel(home1, 'Home'), permission: CheckPermissions(permissions, permissionsVariables.powerComplaints), },
    {
      key: "HomeTac",
      label: "",
      onClick: () => handleItemClick("HomeTac"),
      icon: IconWithLabel(home1, "Home"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
        "Technical Dashboard",
      ),
    },
    {
      key: "NewComplaint",
      label: "",
      onClick: () => handleItemClick("NewComplaint"),
      icon: IconWithLabel(complaints, "New Complaint"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
        "New Complaint",
      ),
    },
    {
      key: "LoggedInUsers",
      label: "",
      onClick: () => handleItemClick("LoggedInUsers"),
      icon: IconWithLabel(permissionManagement, "Logged In Users"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
        "Logged In Users",
      ),
    },
    {
      key: "LinemanAPPUserSummary",
      label: "",
      onClick: () => handleItemClick("LinemanAPPUserSummary"),
      icon: IconWithLabel(permissionManagement, "Logged In User Summary"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
        "User Logged In Summary",
      ),
    },
    {
      key: "ComplaintAndControlCenter",
      label: "",
      onClick: () => handleItemClick("ComplaintAndControlCenter"),
      icon: IconWithLabel(GIS, "Comp. & Control Center"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
        "ComplaintAndControlCenter",
      ),
    },
    // { key: 'LineStaffPerformance', label: '', onClick: () => handleItemClick('LineStaffPerformance'), icon: IconWithLabel(staffPerformance, 'Line Staff Performance'), permission: CheckPermissions(permissions, permissionsVariables.powerComplaints, 'Line Staff Performance'), },
    {
      key: "LoadSheddingSchedule",
      label: "",
      onClick: () => handleItemClick("LoadSheddingSchedule"),
      icon: IconWithLabel(Disconnection1, "Load Shedding Schedule"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
        "Load Shedding Schedule",
      ),
    },
    {
      key: "ApmsList",
      label: "",
      onClick: () => handleItemClick("ApmsList"),
      icon: IconWithLabel(transformer1, "APMS List"),
      permission:
        CheckPermissions(
          permissions,
          permissionsVariables.powerComplaints,
          "APMS List",
        ) ||
        (showAPMSDashboard &&
          CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "Load Shedding Schedule",
          )),
    },
    {
      key: "APMSDashboard",
      label: "",
      onClick: () => handleItemClick("APMSDashboard"),
      icon: IconWithLabel(transformer1, "APMS Dashboard"),
      permission:
        showAPMSDashboard &&
        CheckPermissions(
          permissions,
          permissionsVariables.powerComplaints,
          "Load Shedding Schedule",
        ),
    },
    // {
    //   key: "APMSDashboard",
    //   label: "",
    //   onClick: () => handleItemClick("APMSDashboard"),
    //   icon: IconWithLabel(apmsdashboard, "APMS Dashboard"),
    //   permission: CheckPermissions(
    //     permissions,
    //     permissionsVariables.powerComplaints,
    //     "Load Shedding Schedule"
    //   ),
    // },
    {
      key: "MobileAppStats",
      label: "",
      onClick: () => handleItemClick("MobileAppStats"),
      icon: IconWithLabel(smartphone, "Mobile App Stats"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
        "Power Smart Mobile App Summary",
      ),
    },
    {
      key: "ComplaintDetailedHistory",
      label: "",
      onClick: () => handleItemClick("ComplaintDetailedHistory"),
      icon: IconWithLabel(
        <HistoryOutlinedIcon sx={{ fontSize: 18 }} />,
        "Comp. Detailed History",
      ),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
        "New Complaint",
      ),
    },
    {
      key: "Reports",
      label: "",
      icon: IconWithLabel(Reports1, "Reports / Summary"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
      ),
      children: [
        {
          key: "ComplaintRegister",
          label: "",
          onClick: () => handleItemClick("ComplaintRegister"),
          icon: IconWithLabel(Reports1, "Complaint Register"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "Complaint Register",
          ),
        },
        {
          key: "ComplaintsSummary",
          label: "",
          onClick: () => handleItemClick("ComplaintsSummary"),
          icon: IconWithLabel(Reports1, "Complaints Summary"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "Complaint Summary",
          ),
        },
        // {
        //   key: "EscalationComplaints",
        //   label: "",
        //   onClick: () => handleItemClick("EscalationComplaints"),
        //   icon: IconWithLabel(Reports1, "Escalation Complaints"),
        //   permission: CheckPermissions(
        //     permissions,
        //     permissionsVariables.powerComplaints,
        //     "Escalation Complaints",
        //   ),
        // },
        {
          key: "APMSComplaintsSummary",
          label: "",
          onClick: () => handleItemClick("APMSComplaintsSummary"),
          icon: IconWithLabel(Reports1, "APMS Complaints Summary"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            permissionsVariables.reports,
            "APMS Compalint Summary",
          ),
        },
        {
          key: "SubdivisionWiseAPMSComplaintSummary",
          label: "",
          onClick: () => handleItemClick("SubdivisionWiseAPMSComplaintSummary"),
          icon: IconWithLabel(
            Reports1,
            "CAD APMS Stats",
          ),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            permissionsVariables.reports,
            "APMSResolvedComplaintStats",
          ),
        },
        {
          key: "CADLineComplaintsStats",
          label: "",
          onClick: () => handleItemClick("CADLineComplaintsStats"),
          icon: IconWithLabel(
            Reports1,
            "CAD Line Complaints Stats",
          ),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            permissionsVariables.reports,
            "CADLineComplaintsStats",
          ),
        },
        {
          key: "FeederLengthReport",
          label: "",
          onClick: () => handleItemClick("FeederLengthReport"),
          icon: IconWithLabel(Reports1, "Feeder Length Report"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            permissionsVariables.reports,
            "CADLineComplaintsStats",
          ),
        },
        {
          key: "EopsMobileAppUsageSummary",
          label: "",
          onClick: () => handleItemClick("EopsMobileAppUsageSummary"),
          icon: IconWithLabel(Reports1, "eOps Mobile App Usage Summary"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            permissionsVariables.reports,
            "eOps Mobile App Usage Summary",
          ),
        },
        {
          key: "NotLoggedInUserInLast24Hours",
          label: "",
          onClick: () => handleItemClick("NotLoggedInUserInLast24Hours"),
          icon: IconWithLabel(
            Reports1,
            "Not Logged In User In Last 24 Hours",
          ),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            permissionsVariables.reports,
            "Not logged in Users",
          ),
        },
        {
          key: "EopsUsersStatus",
          label: "",
          onClick: () => handleItemClick("EopsUsersStatus"),
          icon: IconWithLabel(Reports1, "Eops Users Status"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            permissionsVariables.reports,
            "eOps Users Status Report",
          ),
        },
        {
          key: "UserComplaintProcessingStatistics",
          label: "",
          onClick: () =>
            handleItemClick("UserComplaintProcessingStatistics"),
          icon: IconWithLabel(
            Reports1,
            "User Complaint Processing Statistics",
          ),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            permissionsVariables.reports,
            "Staff Performance",
            "User Complaint Processing Stat",
          ),
        },
        {
          key: "ComplaintSourceWise",
          label: "",
          onClick: () => handleItemClick("ComplaintSourceWise"),
          icon: IconWithLabel(Reports1, "Source & Complaint Type Wise"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            permissionsVariables.reports,
            "eOps Users Status Report",
          ),
        },
        {
          key: "TopBestAndWorstPerformer",
          label: "",
          onClick: () => handleItemClick("TopBestAndWorstPerformer"),
          icon: IconWithLabel(
            Reports1,
            "Top Best And Worst Field Staff Performer",
          ),
          permission:
            CheckPermissions(
              permissions,
              permissionsVariables.powerComplaints,
              permissionsVariables.reports,
              permissionsVariables.staffPerformance,
              "Top 5% Best Performers",
            ) ||
            CheckPermissions(
              permissions,
              permissionsVariables.powerComplaints,
              permissionsVariables.reports,
              permissionsVariables.staffPerformance,
              "Worst 10% Non-Performers",
            ),
        },
      ],
    },
    {
      key: "Complaints Management",
      label: "",
      icon: IconWithLabel(Complaintsmanagemnt, "Complaints Management"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
      ),
      children: [
        {
          key: "PendingComplaints",
          label: "",
          onClick: () => handleItemClick("PendingComplaints"),
          icon: IconWithLabel(Pending1, "Pending Complaints"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "Pending Complaints",
          ),
        },
        {
          key: "AllocatedComplaints",
          label: "",
          onClick: () => handleItemClick("AllocatedComplaints"),
          icon: IconWithLabel(Allocated1, "Allocated Complaints"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "Allocated Complaints",
          ),
        },
        {
          key: "WorkingComplaints",
          label: "",
          onClick: () => handleItemClick("WorkingComplaints"),
          icon: IconWithLabel(Working1, "Working Complaints"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "Working Complaints",
          ),
        },
        {
          key: "OnholdComplaints",
          label: "",
          onClick: () => handleItemClick("OnholdComplaints"),
          icon: IconWithLabel(Onhold1, "Onhold Complaints"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "Onhold Complaints",
          ),
        },
        {
          key: "EscalatedComplaints",
          label: "",
          onClick: () => handleItemClick("EscalatedComplaints"),
          icon: IconWithLabel(Escalated1, "Escalated Complaints"),
          permission: true,
        },

        {
          key: "APMSEscalatedComplaints",
          label: "",
          onClick: () => handleItemClick("APMSEscalatedComplaints"),
          icon: IconWithLabel(Escalated1, "APMS Escalated"),
          permission: true,
        },
        // {
        //   key: "APMSComplaintsSummary",
        //   label: "APMS Complaints Summary",
        //   onClick: () => handleItemClick("APMSComplaintsSummary"),
        //   icon: IconWithLabel(Reports1, "APMS Complaints Summary"),
        //   permission: true,
        // },
        {
          key: "ResolvedComplaints",
          label: "",
          onClick: () => handleItemClick("ResolvedComplaints"),
          icon: IconWithLabel(Resolved1, "Resolved Complaints"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "Resolved Complaints",
          ),
        },
      ],
    },
    {
      key: "Logout",
      label: "",
      icon: IconWithLabel(Logout1, "Logout"),
      permission: true,
    },
  ];

  const filterItemsByPermissions = (items) => {
    return items
      .filter((item) => item.permission)
      .map((item) => {
        const { permission, ...rest } = item;
        if (rest.children) {
          rest.children = filterItemsByPermissions(rest.children);
        }
        return rest;
      });
  };

  const filteredItems = filterItemsByPermissions(
    roleId == 1135 || roleId == 1177
      ? tacItems
      : roleId == 1148 || roleId == 1154 || roleId == 1153
        ? tacItemsCircle
        : items,
  );

  const [arrayOfShift, setArrayOfShift] = useState([]);

  const handleCheckboxChange = (shiftId) => {
    let temp = [...arrayOfShift];
    const exists = temp.find((item) => item.shiftId === shiftId);

    if (exists) {
      temp = temp.filter((item) => item.shiftId !== shiftId);
    } else {
      let shiftObj = { shiftId: shiftId };
      temp.push(shiftObj);
    }

    setArrayOfShift(temp);

    setSelectedItems((prevSelected) => {
      const updated = prevSelected.includes(shiftId)
        ? prevSelected.filter((id) => id !== shiftId)
        : [...prevSelected, shiftId];

      const formatted = updated.map((id) => ({ shiftId: id }));
      setAddSelectedItems1(formatted);

      return updated;
    });
  };

  const handleCheckboxChange1 = (shiftId) => {
    let temp = [...arrayOfShift];
    const exists = temp.find((item) => item.shiftId === shiftId);

    if (exists) {
      temp = temp.filter((item) => item.shiftId !== shiftId);
    } else {
      let shiftObj = { shiftId: shiftId };
      temp.push(shiftObj);
    }

    setArrayOfShift(temp);

    setEditSelectedItems((prevSelected) => {
      const updated = prevSelected.includes(shiftId)
        ? prevSelected.filter((id) => id !== shiftId)
        : [...prevSelected, shiftId];

      const formatted = updated.map((id) => ({ shiftId: id }));
      setEditSelectedItems1(formatted);

      return updated;
    });
  };

  const handleEditPasswordWF = (WFData) => {
    // setPasswordWF(true)
    if (WFData) {
      setWorkForceToPassword(WFData);
      passwordChangeWorkForceFormik.values.iv_userId = WFData.userId;
      // editWorkForceFormik.values.iv_name = WFData.name
      // editWorkForceFormik.values.iv_designation = WFData.designation

      // const shiftIdsArray = WFData.shift ? WFData.shift.split(",").map(Number) : [];
      // setEditSelectedItems(shiftIdsArray)

      // const shiftIdsArrays = WFData.shift
      //   ? WFData.shift.split(",").map(Number)
      //   : [];

      // const formattedShiftIds = shiftIdsArrays.map(id => ({ shiftId: id }));
      // setEditSelectedItems1(formattedShiftIds);

      // editWorkForceFormik.values.iv_shift = WFData.shift
      // editWorkForceFormik.values.iv_phone = WFData.phoneNo
      // editWorkForceFormik.values.iv_cnic = WFData.cnic
      // editWorkForceFormik.values.iv_employeeCode = WFData.employeeCode
      // editWorkForceFormik.values.iv_userId = WFData.userId
      // editWorkForceFormik.values.iv_password = WFData.password
      // editWorkForceFormik.values.iv_confirm_password = WFData.password
      setPasswordWF(true);
    }
  };
  const [selectedItems, setSelectedItems] = useState([]);
  const [editSelectedItems, setEditSelectedItems] = useState([]);
  const [editSelectedItems1, setEditSelectedItems1] = useState([]);
  const [addSelectedItems1, setAddSelectedItems1] = useState([]);
  const [filteredSubDivisions, setFilteredSubDivisions] = useState([]);
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedSubDivision, setSelectedSubDivision] = useState("");
  const [filteredDivisions, setFilteredDivisions] = useState([]);
  const [filteredCircles, setFilteredCircles] = useState([]);
  const [officeCodee, setOfficeCodee] = useState("");
  const [circleCodee, setCircleCodee] = useState("");
  const [officeNamee, setOfficeName] = useState("");
  const [circleName, setCircleName] = useState("");
  const [hierarchye, setHierarchye] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  // Selected officeCode state
  const [selectedOfficeCode, setSelectedOfficeCode] = useState("15");
  const [shifts, setShifts] = useState([
    {
      shiftId: 1,
      shiftName: "Morning",
      startTime: "6:00 AM",
      endTime: "2:00 PM",
    },
    {
      shiftId: 2,
      shiftName: "Evening",
      startTime: "2:00 PM",
      endTime: "10:00 PM",
    },
    {
      shiftId: 3,
      shiftName: "Night",
      startTime: "10:00 PM",
      endTime: "6:00 AM",
    },
  ]);
  const [mode, setMode] = useState("vertical");
  // Theme is CSS-driven via html[data-sidebar-theme] — do NOT store in React state.
  // setState here re-renders the entire sidebar (~10k lines) and fights CSS mid-toggle (flicker).
  const themeRef = useRef(
    (() => {
      try {
        const stored = localStorage.getItem("eops-sidebar-theme");
        return stored === "dark" || stored === "light" ? stored : "light";
      } catch {
        return "light";
      }
    })(),
  );

  useEffect(() => {
    document.documentElement.setAttribute(
      "data-sidebar-theme",
      themeRef.current || "light",
    );
  }, []);

  useEffect(() => {
    [EOps, EOpsDark].forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  const toggleSidebarTheme = () => {
    const current =
      document.documentElement.getAttribute("data-sidebar-theme") ||
      themeRef.current ||
      "light";
    const next = current === "dark" ? "light" : "dark";
    const root = document.documentElement;

    themeRef.current = next;
    root.setAttribute("data-sidebar-theme", next);
    try {
      localStorage.setItem("eops-sidebar-theme", next);
    } catch {
      // ignore
    }

    // Update toggle a11y without re-rendering the whole sidebar tree.
    const btn = root.querySelector(".navbar-theme-btn");
    if (btn) {
      const toLight = next === "dark";
      btn.setAttribute(
        "aria-label",
        toLight ? "Switch to light theme" : "Switch to dark theme",
      );
      btn.setAttribute("title", toLight ? "Light mode" : "Dark mode");
    }
  };

  const renderNavbarThemeToggle = () => (
    <button
      type="button"
      className="navbar-theme-btn"
      onClick={toggleSidebarTheme}
      aria-label={
        themeRef.current === "dark"
          ? "Switch to light theme"
          : "Switch to dark theme"
      }
      title={themeRef.current === "dark" ? "Light mode" : "Dark mode"}
    >
      <span className="navbar-theme-btn__icons" aria-hidden>
        <DarkModeOutlinedIcon className="navbar-theme-btn__icon navbar-theme-btn__icon--moon" />
        <LightModeOutlinedIcon className="navbar-theme-btn__icon navbar-theme-btn__icon--sun" />
      </span>
      <span className="navbar-theme-btn__label navbar-theme-btn__label--dark">
        Dark mode
      </span>
      <span className="navbar-theme-btn__label navbar-theme-btn__label--light">
        Light mode
      </span>
    </button>
  );

  const initialValues = {
    // Classification group Initial Values
    iv_name: "",
    iv_phone_no: "",
    iv_address: "",
    iv_consumer_id: "",
    iv_con_id_ref_no: "",
    // userprofile field
    iv_full_name: "",
    iv_user_phone_no: "",
    iv_user_email: "",
    iv_user_cnic: "",
    iv_profile_picture: "",
    //Search Bar fields
    iv_reference_no: "",
    iv_application_id: "",
    iv_cnic: "",
    iv_applicant_name: "",
    iv_application_type: "",
    iv_company_code:
      String(code) === "10" ? String(selectedAdminCompanyCode || "") : "",
  };

  const workForceInitialValues = {
    iv_userId: "",
    iv_name: "",
    iv_designation: "",
    iv_phone: "",
    iv_password: "",
    iv_cnic: "",
    iv_employeeCode: "",
    iv_subDivision: "",
  };
  const [subDivisions, setSubDivisions] = useState(() => {
    try {
      return JSON.parse(window.localStorage.getItem("subDivisions")) || [];
    } catch {
      return [];
    }
  });
  // const subDivisions = JSON.parse(window.localStorage.getItem('subDivisions'))

  let subDivList = [];
  try {
    subDivList = JSON.parse(window.localStorage.getItem("subDivisions")) || [];
  } catch {
    subDivList = [];
  }
  let userCompany = String(userCode || "").slice(0, 2);
  const dispatch = useDispatch();

  let location = useLocation();

  const { officeCode } = useSelector((state) => state.officeCode);
  const [passwordWF, setPasswordWF] = useState(false);
  const [officeNameForDashboard, setOfficeNameForDashboard] = useState(
    officeName(officeCode ? officeCode : code, subDivisions),
  );
  const [workForceToPassword, setWorkForceToPassword] = useState({});
  const [codeForDashboard, setCodeForDashboard] = useState(officeCode);
  const [fieldStaffDesignations, setFieldStaffDesignations] = useState([]);
  const [feederStatus, setFeederStatus] = useState();

  useEffect(() => {
    const getHierarchicalActionableStats = async () => {
      if (officeCode) {
        let officelength = officeCode.toString().length;
        let hierarchy = null;
        if (officelength == 2 || officelength == 3 || officelength == 4) {
          hierarchy = officelength;
        } else {
          hierarchy = 52;
        }
        let codeToAPI = officeCode == 10 ? 15 : officeCode;
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          officeCode: codeToAPI,
          officeLevel: hierarchy,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        await fetch(
          cfpBaseUrl + "actionables/getActionableCountOfficeWise",
          requestOptions,
        )
          .then((response) => response.json())
          .then((result) => {
            let statsArray = result.data.map((item) => ({
              name:
                item.officeCode == codeToAPI
                  ? "Total"
                  : getName(item.officeCode, subDivisions),
              counter: item.totalCount,
            }));
            setPendings(statsArray);
          })
          .catch(() => { });
      }
    };
    if (roleTypeId == 1) {
      getHierarchicalActionableStats();
    }
  }, [officeCode]);

  useEffect(() => {
    if (officeCode) {
      setCodeForDashboard(officeCode);
    }
  }, [officeCode]);

  useEffect(() => {
    if (codeForDashboard) {
      setOfficeNameForDashboard(officeName(officeCode, subDivisions));
    }
  }, [codeForDashboard]);

  const { performanceValue } = useSelector((state) => state.overallPerformance);

  const { data: result1 } = useSelector((state) => state.feederStatus);

  const [open, setOpen] = React.useState(true);
  const [viewBackdrop, setViewBackdrop] = useState(false);
  const [showComplaintForm, setShowComplaintForm] = useState(false);
  const [showFeederForm, setShowFeederForm] = useState(false);
  const tableref1 = useRef();
  const [showApmsForm, setShowApmsForm] = useState(false);
  const [showApmsSuccessPopup, setShowApmsSuccessPopup] = useState(false);
  const [apmsCompanyCode, setApmsCompanyCode] = useState("15"); // default MEPCO
  const [apmsLoading, setApmsLoading] = useState(false);

  const [showLineManForm, setShowLineManForm] = useState(false);
  const [showWorkforceForm, setShowWorkforceForm] = useState(false);

  const [shift1Fields, setShift1Fields] = useState(
    Array(5).fill({
      name: "",
      designation: "",
      phoneNo: "",
      userId: "",
      isModified: false,
    }),
  );
  const [shift2Fields, setShift2Fields] = useState(
    Array(5).fill({
      name: "",
      designation: "",
      phoneNo: "",
      userId: "",
      isModified: false,
    }),
  );
  const [shift3Fields, setShift3Fields] = useState(
    Array(5).fill({
      name: "",
      designation: "",
      phoneNo: "",
      userId: "",
      isModified: false,
    }),
  );
  const [workForceData, setWorkForceData] = useState([]);
  const [showProfileEditPopup, setShowProfileEditPopup] = useState(false);
  const [showChangePasswordPopup, setShowChangePasswordPopup] = useState(false);
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState([]);

  const {
    pageSize: complaintsPageSize,
    pageNumber: complaintsPageNumber,
    subDivisionCode: complaintsSubDivisionCode,
    dateFrom: complaintsDateFrom,
    dateTo: complaintsDateTo,
  } = useSelector((state) => state.allComplaints);
  const { data: mdmToken } = useSelector((state) => state.authorization);
  const [apiData, setApiData] = useState([]);
  const [latitude, setLatitude] = useState();
  const [longitude, setLongitude] = useState();
  const [selectedTab, setSelectedTab] = useState(0); // Default to the first tab
  const [selectedValueOfTab, setSelectedValueOfTab] = useState(); // Default to the first tab
  const [searchBarrPopupOpen, setSearchBarrPopupOpen] = useState(false);
  const [openDialogOfApplication, setOpenDialogApplication] = useState(false);
  const tabLabels = ["Reference No.", "Application ID", "CNIC", "Name"];
  const [cDateTime, setCDateTime] = useState("");
  const handleDialogOfApplicationOpen = useCallback(() => {
    setOpenDialogApplication(true);
  }, []);
  const handleDialogOfApplicationClose = useCallback(() => {
    setOpenDialogApplication(false);
  }, []);
  const handleTabChange = (event, newValue) => {
    const selectedService = searchFormik.values.iv_application_type;
    const selectedSearchCompany = searchFormik.values.iv_company_code;
    setSelectedTab(newValue);
    searchFormik.resetForm({
      values: {
        ...initialValues,
        iv_application_type: selectedService,
        iv_company_code: selectedSearchCompany,
      },
    });
  };
  const handleOpenSearchBarPopup = () => {
    fetchSearchApplicationTypes(token);
    searchFormik.resetForm({
      values: {
        ...initialValues,
        iv_application_type: normalizeSearchApplicationTypeId(
          getSearchServiceTypeFromPath(location.pathname)
        ),
        iv_company_code:
          String(code) === "10"
            ? String(selectedAdminCompanyCode || "")
            : "",
      },
    });
    setSearchBarrPopupOpen(true);
  };
  const handleCloseSearchBarPopup = () => setSearchBarrPopupOpen(false);
  const [resultSearchedData, setResultSearchedData] = useState([]);
  const [resultSearchedData1, setResultSearchedData1] = useState([]);
  const brandLogo = useDiscoLogo(companyCode);
  const searchFormik = useSearchFormik({
    selectedTab,
    setSelectedValueOfTab,
    setResultSearchedData,
    setResultSearchedData1,
    token,
    handleDialogOfApplicationOpen,
    handleCloseSearchBarPopup,
    initialValues,
    setViewBackdrop,
    companyCode,
    isAdmin: String(code) === "10",
    officeCode: code,
    hierarchy,
  });

  const editWorkForceFormik = useFormik({
    initialValues: workForceInitialValues,
    validationSchema: Yup.object().shape({
      iv_userId: Yup.string().required("UserId is required!"),
      iv_name: yupSafePersonName(
        Yup.string()
          .min(3, "Name should be atleast 3 characters.")
          .max(30, "Name should be less than 30 characters.")
          .required("Please enter lineman name.")
          .matches(/^[A-Za-z. ]*$/, "Only letters and '.' are allowed."),
      ),
      iv_phone: Yup.string()
        .max(11, "Please enter 11 digit phone number.")
        .min(11, "Please enter 11 digit phone number.")
        .required("Please enter valid mobile number.")
        .matches(/^03[0-9]{2}[0-9]{7}$/, "Enter Phone number as 03001234567"),
      iv_designation: Yup.mixed().required("Designation is required!"),
      // iv_shift: Yup.mixed().optional(),
      // iv_password: Yup.string().matches(passwordRegex, "Password must contain at least one uppercase letter, one lowercase letter, one number, one special character, and must be at least 8 characters long").required("Password is required"),
      // iv_confirm_password: Yup.string().oneOf([Yup.ref('iv_password'), null], 'Password and Confirm password must match').required("Confirm password is required"),
      iv_cnic: Yup.string()
        .min(13, "CNIC no. can not less than 13 digits.")
        .max(13, "CNIC no. can not greater than 13 digits.")
        .required("CNIC No. is required")
        .matches(/^[0-9]+$/, "Enter CNIC No. as 3520212345678"),
      iv_employeeCode: Yup.string()
        .min(2, "Employee code must be at least 2 characters.")
        .max(14, "Employee code must be at most 14 characters.")
        .required("Employee code is required")
        .matches(
          /^[0-9]+$/,
          "Employee code must contain only numeric characters.",
        ),
    }),
    onSubmit: async (values, { resetForm }) => {
      const sdCode = workForceToEdit.subDivisionCode
        ? String(workForceToEdit.subDivisionCode)
        : "";

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        userId: workForceToEdit.userId,
        employeeName: values.iv_name,
        employeeMobileNo: values.iv_phone,
        employeeCNIC: values.iv_cnic,
        employeeEmail: "",
        updatedBy: userId,
        toBeUpdatedUserId: values.iv_userId,
        designation: values.iv_designation,
        shiftDetails: editSelectedItems1,
        employeeCode: values.iv_employeeCode,
        companyCode: sdCode.slice(0, 2),
        circleCode: sdCode.slice(0, 3),
        divisionCode: sdCode.slice(0, 4),
        subDivisionCode: sdCode.slice(0, 5),
        // password: values.iv_password,
        hierarchy: hierarchy,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "workForce/updateUser", requestOptions)
        .then(async (response) => {
          if (response.status == 200) {
            return response.json();
          } else {
            let res = await response.json();
            setApiError(res.message);
          }
        })
        .then((result) => {
          if (!result.message.startsWith("Failed to edit employee")) {
            setEditWF(false);
            resetForm();
            getWFData();
            setApiError("");
          }
        })
        .catch(() => { });
    },
  });

  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const userMenuAnchorRef = useRef(null);
  const [openMenuKeys, setOpenMenuKeys] = useState([]);
  const [complaintsError, setComplaintsError] = useState("");
  const [enableFullName, setEnableFullName] = React.useState(false);
  const [enablePhone, setEnablePhone] = React.useState(false);
  const [enableEmail, setEnableEmail] = React.useState(false);
  const [apiError, setApiError] = useState("");
  const [arrear, setArrear] = useState("");
  const [meterStatus, setMeterStatus] = useState("");
  const [showComplaintErrorForm, setShowComplaintErrorForm] = useState(false);
  const [isFormModified, setIsFormModified] = useState(false);
  const [isFormModifiedWorkForce, setIsFormModifiedWorkForce] = useState(false);
  const [sliceRefNo, setSliceRefNo] = useState();
  const [selectedOption, setSelectedOption] = useState("referenceNo");
  const [complaintAttachment, setComplaintAttachment] = useState("");
  const [complaintAttachmentName, setComplaintAttachmentName] = useState("");
  const [complaintAttachmentPreview, setComplaintAttachmentPreview] =
    useState("");
  const [deleteLMWarning, setDeleteLMWarning] = useState(false);
  const offCode = code;
  const [complaintType, setComplaintType] = useState("Technical");

  const [desginationList, setDesginationList] = useState([]);

  const [addWF, setAddWF] = useState(false);
  const [editWF, setEditWF] = useState(false);
  const [workForceToEdit, setWorkForceToEdit] = useState({});
  const [workForceToDelete, setWorkForceToDelete] = useState({});
  const [selectedCompanyCode, setSelectedCompanyCode] = useState(() =>
    getInitialAdminOfficeCode(code, selectedAdminCompanyCode),
  );
  // Fetch subDivisions for code == 10
  useEffect(() => {
    if (String(code) === "10" && selectedAdminCompanyCode) {
      const company = String(selectedAdminCompanyCode);
      setSelectedCompanyCode(company);
      setOfficeCodee(company);
      setOfficeName(getCompanies(company) || "");
    }
  }, [code, selectedAdminCompanyCode]);

  useEffect(() => {
    if (code == 10 && selectedCompanyCode) {
      const fetchSubDivisions = async () => {
        setViewBackdrop(true);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        const formdata = new FormData();
        formdata.append("companyCode", selectedCompanyCode);
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        };
        try {
          const response = await fetch(
            cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
            requestOptions,
          );
          if (response.ok) {
            const result = await response.json();
            if (result.status === "200") {
              setSubDivisions(result.message);
              setApiData(result.message);
              // Populate circles
              const circles = result.message.reduce((acc, curr) => {
                if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                  acc.push({
                    circleCode: curr.circleCode,
                    circleName: curr.circleName,
                    companyCode: curr.companyCode,
                  });
                }
                return acc;
              }, []);
              setFilteredCircles(circles);
            } else {
              setSubDivisions([]);
              setFilteredCircles([]);
            }
          } else {
            throw new Error(`Request failed with status ${response.status}`);
          }
        } catch (error) {
          setSubDivisions([]);
          setFilteredCircles([]);
        } finally {
          setViewBackdrop(false);
        }
      };
      fetchSubDivisions();
    } else if (code != 10) {
      // For code != 10, populate circles from localStorage subDivisions
      const circles = subDivisions.reduce((acc, curr) => {
        if (!acc.some((item) => item.circleCode === curr.circleCode)) {
          acc.push({
            circleCode: curr.circleCode,
            circleName: curr.circleName,
            companyCode: curr.companyCode,
          });
        }
        return acc;
      }, []);
      setFilteredCircles(circles);
    }
  }, [code, selectedCompanyCode, token, cfpBaseUrl]);

  const handleChangeCompany = async (e) => {
    const selectedCompany = e.target.value;
    setSelectedCompanyCode(selectedCompany);
    setWorkForceData([]);
    setOfficeCodee(selectedCompany);
    setOfficeName(getCompanies(selectedCompany) || "");

    if (code == 10 && selectedCompany) {
      persistAdminCompanySelectionToStorage(selectedCompany);
      dispatch(setSelectedAdminCompanyCode(selectedCompany));
      dispatch(updateOC({ officeCode: selectedCompany }));
    }

    if (code == 10 && selectedCompany) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompany);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions,
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            // Reset dropdowns
            setCircleCodee("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setCircleName("");
            setFilteredDivisions([]);
            setFilteredSubDivisions([]);

            // Populate circles
            const circles = result.message.reduce((acc, curr) => {
              if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                acc.push({
                  circleCode: curr.circleCode,
                  circleName: curr.circleName,
                  companyCode: curr.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredCircles(circles);
          } else {
            setSubDivisions([]);
            setFilteredCircles([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
        setFilteredCircles([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (!selectedCompany) {
      // Reset when no company is selected
      setWorkForceData([]);
      setOfficeName("PITC");
      setCircleCodee("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setCircleName("");
      setFilteredDivisions([]);
      setFilteredSubDivisions([]);
      setFilteredCircles([]);
      setSubDivisions([]);
      setApiData([]);
    }
  };

  const handleCircleChange = async (event) => {
    const selectedCircleCode = event.target.value
      ? parseInt(event.target.value)
      : "";
    if (code == 10 && selectedCircleCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("circleCode", selectedCircleCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions,
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCodee(selectedCircleCode);
            setOfficeCodee(selectedCircleCode);
            const circle = filteredCircles.find(
              (circle) => circle.circleCode === selectedCircleCode,
            );
            const circleName = circle?.circleName || "";
            setOfficeName(circleName.concat(" Circle"));
            setCircleName(circleName);
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message
              .filter((item) => item.circleCode === selectedCircleCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (division) => division.divisionCode === item.divisionCode,
                  )
                ) {
                  acc.push({
                    divisionCode: item.divisionCode,
                    divisionName: item.divisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (code == 10 && !selectedCircleCode && selectedCompanyCode) {
      // Handle "All Circle" selection for code == 10
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions,
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCodee("");
            setOfficeCodee(selectedCompanyCode);
            setOfficeName(getCompanies(selectedCompanyCode));
            setCircleName("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode,
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedCircleCode) {
      setCircleCodee(selectedCircleCode);
      setOfficeCodee(selectedCircleCode);
      const circle = filteredCircles.find(
        (circle) => circle.circleCode === selectedCircleCode,
      );
      const circleName = circle?.circleName || "";
      setOfficeName(circleName.concat(" Circle"));
      setCircleName(circleName);
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter((item) => item.circleCode === selectedCircleCode)
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    } else {
      // Handle "All Circle" for code != 10
      setCircleCodee("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      if (roleTypeName == "Technical") {
        if (offCode) {
          setOfficeCodee(offCode == 10 ? 15 : offCode);
          let officeName = getName(
            offCode == 10 ? "15" : offCode.toString(),
            subDivisions,
          );
          setOfficeName(officeName.concat(" Region"));
          setCircleName("");
          const circles = subDivisions.reduce((acc, curr) => {
            if (!acc.some((item) => item.circleCode === curr.circleCode)) {
              acc.push({
                circleCode: curr.circleCode,
                circleName: curr.circleName,
                companyCode: curr.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredCircles(circles);
          const uniqueDivisions = subDivisions.reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode,
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredDivisions(uniqueDivisions);
        }
      } else if (roleTypeName == "Commercial") {
        if (cfcLevelId == 2) {
          if (offCode) {
            setOfficeCodee(offCode.toString().slice(0, 2));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchye(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode,
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        } else if (cfcLevelId == 3) {
          if (offCode) {
            setOfficeCodee(offCode.toString().slice(0, 3));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchye(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode,
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        }
      }
    }
  };

  const handleDivisionChange = async (e) => {
    const selectedDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedDivisionCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("divisionCode", selectedDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions,
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedDivision(selectedDivisionCode);
            setOfficeCodee(selectedDivisionCode);
            const division = filteredDivisions.find(
              (division) => division.divisionCode === selectedDivisionCode,
            );
            const divisionName = division?.divisionName || "";
            setOfficeName(divisionName.concat(" Division"));
            setSelectedSubDivision("");
            const uniqueSubDivisions = result.message
              .filter((item) => item.divisionCode == selectedDivisionCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (sub) => sub.subDivisionCode === item.subDivisionCode,
                  )
                ) {
                  acc.push({
                    subDivisionCode: item.subDivisionCode,
                    subDivisionName: item.subDivisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredSubDivisions(uniqueSubDivisions);
          } else {
            setSubDivisions([]);
            setFilteredSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
        setFilteredSubDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedDivisionCode) {
      setSelectedDivision(selectedDivisionCode);
      setOfficeCodee(selectedDivisionCode);
      const divisionName =
        filteredDivisions.find(
          (division) => division.divisionCode === selectedDivisionCode,
        )?.divisionName || "";
      setOfficeName(divisionName.concat(" Division"));
      setSelectedSubDivision("");
      const uniqueSubDivisions = subDivisions
        .filter((item) => item.divisionCode == selectedDivisionCode)
        .reduce((acc, item) => {
          if (
            !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
          ) {
            acc.push({
              subDivisionCode: item.subDivisionCode,
              subDivisionName: item.subDivisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredSubDivisions(uniqueSubDivisions);
    } else {
      setSelectedDivision("");
      setOfficeCodee(circleCode ? circleCode : offCode);
      let officeName = getName(
        circleCode ? circleCode.toString() : offCode.toString(),
        subDivisions,
      );
      setOfficeName(officeName.concat(" Circle"));
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter(
          (item) => item.circleCode == (circleCode ? circleCode : offCode),
        )
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    }
  };

  const handleSubDivisionChange = async (e) => {
    const selectedSubDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedSubDivisionCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("subDivisionCode", selectedSubDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions,
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedSubDivision(selectedSubDivisionCode);
            setOfficeCodee(selectedSubDivisionCode);
            const subDivision = filteredSubDivisions.find(
              (sub) => sub.subDivisionCode === selectedSubDivisionCode,
            );
            const subDivisionName = subDivision?.subDivisionName || "";
            setOfficeName(subDivisionName.concat(" Sub Division"));
          } else {
            setSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedSubDivisionCode) {
      setSelectedSubDivision(selectedSubDivisionCode);
      setOfficeCodee(selectedSubDivisionCode);
      const subDivisionName =
        filteredSubDivisions.find(
          (sub) => sub.subDivisionCode === selectedSubDivisionCode,
        )?.subDivisionName || "";
      setOfficeName(subDivisionName.concat(" Sub Division"));
    } else {
      setSelectedSubDivision("");
      let officeName = getName(
        selectedDivision ? selectedDivision.toString() : offCode.toString(),
        subDivisions,
      );
      setOfficeName(officeName.concat(" Division"));
      setOfficeCodee(selectedDivision ? selectedDivision : offCode);
    }
  };

  useEffect(() => {
    if (roleTypeName == "Technical") {
      if (offCode) {
        setOfficeCodee(offCode == 10 ? 15 : offCode);
        let offName = getName(
          offCode == 10 ? "15" : offCode.toString(),
          subDivisions,
        );
        setOfficeName(offName);
        setHierarchye(offCode.toString().length);
      }
    } else if (roleTypeName == "Commercial") {
      if (cfcLevelId == 1) {
        if (offCode) {
          if (offCode == 10) {
            setOfficeCodee(15);
            setOfficeName("PITC");
          } else {
            setOfficeCodee(offCode);
            let offName = getName(offCode, subDivisions);
            setOfficeName(offName);
          }

          setHierarchye(offCode.length);
        }
      } else if (cfcLevelId == 2) {
        if (offCode) {
          setOfficeCodee(offCode.toString().slice(0, 2));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchye(cfcLevelId);
        }
      } else if (cfcLevelId == 3) {
        if (offCode) {
          setOfficeCodee(offCode.toString().slice(0, 3));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchye(cfcLevelId);
        }
      } else if (cfcLevelId == 4 || cfcLevelId == 5) {
        if (offCode) {
          setOfficeCodee(offCode.toString().slice(0, 4));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchye(cfcLevelId);
        }
      }
    }
  }, [offCode, cfcLevelId, roleTypeName, cscID]);

  useEffect(() => {
    if (hierarchy) {
      if (hierarchy == 1 || cfcLevelId === 1) {
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 2 || cfcLevelId == 2) {
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 3 || cfcLevelId == 3) {
        setCircleCodee(offCode.slice(0, 3));
        const uniqueDivisions = subDivisions
          .filter((item) => item.circleCode == offCode.slice(0, 3))
          .reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode,
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredDivisions(uniqueDivisions);
      } else if (
        hierarchy == 4 ||
        cfcLevelId == 4 ||
        hierarchy == 5 ||
        cfcLevelId == 5
      ) {
        setSelectedDivision(offCode.slice(0, 4));
        const uniqueSubDivisions = subDivisions
          .filter((item) => item.divisionCode == offCode.slice(0, 4))
          .reduce((acc, item) => {
            if (
              !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
            ) {
              acc.push({
                subDivisionCode: item.subDivisionCode,
                subDivisionName: item.subDivisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredSubDivisions(uniqueSubDivisions);
      }
    }
  }, [hierarchy, cfcLevelId, subDivisions]);
  const handleDeleteLMUser = async () => {
    if (workForceToEdit) {
      try {
        await deleteWFData(workForceToEdit, token);
        setEditWF(false);
        getWFData();
        setApiError("");
      } catch (error) {
      }
    }
  };

  const handleChange1 = (event) => {
    setReferenceNumber("");
    const newValue = event.target.value;
    setSelectedOption(newValue);
    // Set default "Over Voltage" when APMS MSN is selected
    if (newValue === "apmsMsn") {
      setTimeout(() => {
        setTypeId("apms_over_voltage");
        setTypeName("Over Voltage");
      }, 100);
    } else {
      setTypeId("");
      setTypeName("");
    }
  };

  const handleChange2 = (event) => {
    setComplaintType(event.target.value);
    // setReferenceNumber("")
    // setSelectedOption(event.target.value);
  };
  const handleClickFullName = async () => {
    if (!enableFullName) {
      setEnableFullName((prev) => !prev);
    } else {
      nameFormik.handleSubmit();
    }
  };

  const handleClickPhone = async () => {
    if (!enablePhone) {
      setEnablePhone((prev) => !prev);
    } else {
      phoneFormik.handleSubmit();
    }
  };

  const handleClickEmail = async () => {
    if (!enableEmail) {
      setEnableEmail((prev) => !prev);
    } else {
      emailFormik.handleSubmit();
    }
  };

  useEffect(() => {
    if (!token) return;

    let idleId;
    let actionablesTimer;
    const loadVisibleStats = () => {
      dispatch(
        allStatsAPI({
          officeCode: code,
          officeLevel: hierarchy,
          showAllApplicationsFlag: showAllApplicationsFlag,
        }),
      );
      actionablesTimer = window.setTimeout(() => {
        if (roleTypeId == 1) {
          dispatch(actionableNormal({ pageNumber: 1, pageSize: 20 }));
          dispatch(actionableOverdue({ pageNumber: 1, pageSize: 20 }));
        }
      }, 400);
    };

    if (typeof window.requestIdleCallback === "function") {
      idleId = window.requestIdleCallback(loadVisibleStats, { timeout: 800 });
    } else {
      idleId = window.setTimeout(loadVisibleStats, 0);
    }

    return () => {
      if (typeof window.cancelIdleCallback === "function") {
        window.cancelIdleCallback(idleId);
      } else {
        window.clearTimeout(idleId);
      }
      window.clearTimeout(actionablesTimer);
    };
  }, [token, code, hierarchy, showAllApplicationsFlag, roleTypeId, dispatch]);

  // Extract the current page name from the URL
  const currentPage = (location?.pathname || "").split("/")[1];

  const routes = [
    {
      path: "/new-connection-table",
      args: [
        permissionsVariables.generalServices,
        permissionsVariables.newConnection,
      ],
    },
    {
      path: "/reconnection-table",
      args: [
        permissionsVariables.generalServices,
        permissionsVariables.reConnection,
      ],
    },
    {
      path: "/disconnection-table",
      args: [
        permissionsVariables.generalServices,
        permissionsVariables.disconnection,
      ],
    },
    {
      path: "/disconnection-update",
      args: [
        permissionsVariables.generalServices,
        permissionsVariables.disconnection,
      ],
    },
    {
      path: "/bill-correction-table",
      args: [
        permissionsVariables.generalServices,
        permissionsVariables.newConnection,
      ],
    },
    {
      path: "/change-of-attributes-table",
      args: [
        permissionsVariables.generalServices,
        permissionsVariables.changeOfAttributes,
      ],
    },
    {
      path: "/change-of-load-table",
      args: [permissionsVariables.generalServices, "Change of Load"],
    },
    {
      path: "/change-of-tariff-table",
      args: [permissionsVariables.generalServices, "Change of Tariff"],
    },
    {
      path: "/net-metering",
      args: [permissionsVariables.generalServices, "Shift to Net Meter"],
    },
    {
      path: "/meter-change-request-table",
      args: [permissionsVariables.generalServices, permissionsVariables.mco],
    },
    {
      path: "/meter-reading-correction-table",
      serviceName: permissionsVariables.meterReadingCorrection,
      args: [
        permissionsVariables.billingAndCollection,
        permissionsVariables.meterReadingCorrection,
      ],
    },
    {
      path: "/due-date-extension-table",
      args: [permissionsVariables.billingAndCollection, permissionsVariables.dueDateExtension],
    },
    {
      path: "/adjust-last-bill-table",
      args: [permissionsVariables.generalServices, permissionsVariables.adjustLastBill],
    },
    // {
    //   path: "/adjust-last-bill-table",
    //   args: [permissionsVariables.billingAndCollection, permissionsVariables.adjustLastBill],
    // },
    {
      path: "/adjust-last-bill-table",
      args: [permissionsVariables.billingAndCollection, permissionsVariables.adjustLastBill],
    },
    {
      path: "/adjust-last-bill-form",
      args: [permissionsVariables.generalServices, permissionsVariables.adjustLastBill],
    },
    // {
    //   path: "/adjust-last-bill-form",
    //   args: [permissionsVariables.billingAndCollection, permissionsVariables.adjustLastBill],
    // },
    // {
    //   path: "/adjust-last-bill-form",
    //   args: [permissionsVariables.billingAndCollection, permissionsVariables.dueDateExtension],
    // },
    {
      path: "/amend-2636-bill-table",
      args: [permissionsVariables.generalServices, permissionsVariables.partPayment],
    },
    // {
    //   path: "/advance-payment-table",
    //   args: [permissionsVariables.billingAndCollection, "Due Date Extension"],
    // },
    {
      path: "/advance-payment-table",
      args: [permissionsVariables.generalServices, permissionsVariables.advancePayment],
    },
    // {
    //   path: "/advance-payment-form",
    //   args: [permissionsVariables.billingAndCollection, "Due Date Extension"],
    // },
    // {
    //   path: "/advance-payment-form",
    //   args: [permissionsVariables.generalServices, permissionsVariables.partPayment],
    // },
    {
      path: "/advance-payment-update",
      args: [permissionsVariables.billingAndCollection, permissionsVariables.advancePayment],
    },
    {
      path: "/advance-payment-table",
      args: [permissionsVariables.generalServices, permissionsVariables.advancePayment],
    },
    {
      path: "/advance-payment-form",
      args: [permissionsVariables.generalServices, permissionsVariables.advancePayment],
    },
    {
      path: "/advance-payment-update",
      args: [permissionsVariables.generalServices, permissionsVariables.advancePayment],
    },
    {
      path: "/installments-table",
      args: [permissionsVariables.billingAndCollection, permissionsVariables.billInstallments],
    },
    {
      path: "/withdrawal-of-installment-table",
      serviceName: permissionsVariables.withdrawalOfInstallment,
      args: [permissionsVariables.billingAndCollection, permissionsVariables.withdrawalOfInstallment],
    },
    {
      path: "/withdrawal-of-installment-form",
      serviceName: permissionsVariables.withdrawalOfInstallment,
      args: [
        permissionsVariables.billingAndCollection,
        permissionsVariables.withdrawalOfInstallment,
        "Basic Permissions",
        "Create",
      ],
    },
    {
      path: "/set-aside-table",
      args: [permissionsVariables.billingAndCollection, permissionsVariables.setAside],
    },
    {
      path: "/power-complaint-table",
      args: [permissionsVariables.powerComplaints],
    },
    {
      path: "/power-complaint-map",
      args: ["Gis Map"],
    },
    {
      path: "/user-management",
      args: [permissionsVariables.accessManagement, "User Management"],
    },
    {
      path: "/role-management",
      args: [permissionsVariables.accessManagement, "Role Management"],
    },
    {
      path: "/permission-management",
      args: [permissionsVariables.accessManagement, "Permission Management"],
    },
    {
      path: "/company-management",
      args: [permissionsVariables.organizationManagement, "Company Management"],
    },
    {
      path: "/circle-management",
      args: [permissionsVariables.organizationManagement, "Circle Management"],
    },
    {
      path: "/division-management",
      args: [
        permissionsVariables.organizationManagement,
        "Division Management",
      ],
    },
    {
      path: "/support-center-management",
      args: [permissionsVariables.organizationManagement, "CSC Management"],
    },
    {
      path: "/sub-division-management",
      args: [
        permissionsVariables.organizationManagement,
        "Sub Division Management",
      ],
    },
  ];

  const currentPath = location.pathname.replace(/\/$/, "") || "/";
  const isButtonVisible = routes.some((route) => {
    if (route.path !== currentPath && !currentPath.endsWith(route.path)) {
      return false;
    }
    if (
      (route.path === "/role-management" || route.path === "/permission-management") &&
      canManageRolesAndPermissions(code, roleId)
    ) {
      return true;
    }
    if (route.serviceName) {
      return hasServicePermission(permissions, route.serviceName);
    }
    return CheckPermissions(permissions, ...route.args);
  });

  const printApplicationReceipt = async (
    applicationID,
    referenceNumber,
    values,
    typeName,
    description,
  ) => {
    const company = String(referenceNumber || "").slice(2, 4);
    let discoLogo = "";
    let watermarkSrc = "";
    try {
      [discoLogo, watermarkSrc] = await Promise.all([
        loadDiscoLogo(company),
        loadDiscoWatermark(company),
      ]);
    } catch {
      discoLogo = "";
      watermarkSrc = "";
    }
    const doc = new jsPDF({ compressPdf: true });

    // Generate the barcode image using JsBarcode
    const barcodeCanvas = document.createElement("canvas");
    JsBarcode(barcodeCanvas, applicationID);

    // Convert the barcode image to data URL
    const barcodeDataURL = barcodeCanvas.toDataURL("image/png");
    var height = 10;
    var padding = 10;

    doc.addImage(barcodeDataURL, "PNG", 85, 260, 40, 20);
    const logoWidth =
      company === "12" ||
        company === "13" ||
        company === "11" ||
        company === "16" ||
        company === "27" ||
        company === "48" ||
        company === "59"
        ? 25
        : 30;
    const logoHeight =
      company === "12" ||
        company === "13" ||
        company === "11" ||
        company === "16" ||
        company === "27" ||
        company === "48" ||
        company === "59"
        ? 20
        : 10;
    if (discoLogo) {
      doc.addImage(discoLogo, "PNG", 90, 5, logoWidth, logoHeight);
    }

    height = height + 20;

    var increment = 10;
    doc.setFontSize(15);
    doc.setFont("helvetica", "bold");
    doc.text(
      "Receipt of Complaint",
      doc.internal.pageSize.getWidth() / 2,
      height,
      {
        align: "center",
      },
    );
    doc.setFontSize(12);
    increment = 20;
    height = height + increment;
    var leftMargin = 120;
    doc.text("DISCO / Company: ", padding, height);
    doc.text("Sub Division Code & Name:", padding + leftMargin, height);

    doc.setFont("helvetica", "normal");
    increment = 10;
    height = height + increment;
    leftMargin = 120;
    doc.text(companyShortName(company), padding, height);
    doc.text(
      values.iv_con_id_ref_no.slice(2, 7) +
      " / " +
      subdivisionName(values.iv_con_id_ref_no.slice(2, 7), subDivList),
      padding + leftMargin,
      height,
    );

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Tracking ID: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(applicationID.toString(), padding + leftMargin, height);
    leftMargin = 100;
    doc.setFont("helvetica", "bold");

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Applicant Name: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(values.iv_name, padding + leftMargin, height);

    increment = 10;
    height = height + increment;
    leftMargin = 60;
    doc.setFont("helvetica", "bold");
    doc.text("Applicant Mobile No.: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(values.iv_phone_no, padding + leftMargin, height);
    let phone = "";
    doc.text(phone, padding + leftMargin, height);

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Address: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(values.iv_address, padding + leftMargin, height);
    let address = "";
    doc.text(address, padding + leftMargin, height);

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Reference No.: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(referenceNumber, padding + leftMargin, height);

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Complaint Type: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(typeName, padding + leftMargin, height);

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Description: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(description, padding + leftMargin, height);

    const totalPages = doc.internal.getNumberOfPages();

    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      if (watermarkSrc) {
        doc.addImage(
          watermarkSrc,
          "PNG",
          0,
          0,
          doc.internal.pageSize.getWidth(),
          doc.internal.pageSize.getHeight(),
        );
      }
    }

    const pdfBlob = doc.output("blob");
    const pdfDataUrl = URL.createObjectURL(pdfBlob);

    // Open the PDF in a new tab
    window.open(pdfDataUrl, "_blank");
  };

  const powerComplaintsMenu =
    currentPath == "/power-complaint-map" ||
    currentPath == "/power-complaint-pending" ||
    currentPath == "/power-complaint-allocated" ||
    currentPath == "/power-complaint-working" ||
    currentPath == "/power-complaint-onhold" ||
    currentPath == "/power-complaint-escalated" ||
    currentPath == "/power-complaint-resolved" ||
    currentPath == "/power-complaint-detail-report" ||
    currentPath == "/power-complaint-display-complaint";

  const displayComplaintPage =
    currentPath == "/power-complaint-display-complaint";

  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("md"));
  const drawerWidth = isMobile ? 300 : 304;

  const selectedMenuKeys = useMemo(() => {
    const path = location.pathname.toLowerCase();
    const routeSelections = [
      ["/operationalperformance", "OperationalPerformance"],
      ["/landingpage", "OperationalPerformance"],
      ["/homecfc", "CFCDashboard"],
      ["/commercialoperations", "CFCPerformance"],
      ["/homefieldoffice", "FieldOfficeDashboard"],
      ["/eops-updates", "EopsUpdates"],
      ["/new-connection-table", "NewConnection"],
      ["/new-connection-form", "NewConnection"],
      ["/reconnection-table", "Reconnection"],
      ["/reconnection-form", "Reconnection"],
      ["/disconnection-table", "Disconnection"],
      ["/disconnection-form", "Disconnection"],
      ["/disconnection-update", "Disconnection"],
      ["/change-of-attributes-table", "ChangeofAttributes"],
      ["/change-of-attributes-form", "ChangeofAttributes"],
      ["/change-of-load-table", "ChangeOfLoad"],
      ["/change-of-tariff-table", "ChangeOfTariff"],
      ["/meter-change-request-table", "MeterChangeRequest"],
      ["/meter-change-request-form", "MeterChangeRequest"],
      ["/due-date-extension-table", "DueDateExt"],
      ["/due-date-extension-form", "DueDateExt"],
      ["/installments-table", "BillInstallments"],
      ["/installments-form", "BillInstallments"],
      ["/withdrawal-of-installment-table", "WithdrawalOfInstallment"],
      ["/withdrawal-of-installment-form", "WithdrawalOfInstallment"],
      ["/duplicate-bill", "DuplicateBill"],
      ["/cnic-updation", "UpdateTenantCNIC"],
      ["/net-metering", "ShiftToNetMeter"],
      ["/actionables-table", "Actionables"],
      ["/adjust-last-bill-table", "AdjustLastBill"],
      ["/adjust-last-bill-form", "AdjustLastBill"],
      ["/advance-payment", "advancePayment"],
      ["/amend-bill", "amendBill2636"],
      ["/amend-duplicate-bill", "AmendDuplicateBill"],
      ["/bill-correction", "BillCorrection"],
      // ["/meter-reading", "MeterReadingCorrection"],
      ["/part-payment", "PartPayment"],
      ["/set-aside", "SetAside"],
      ["/user-management", "UserManagement"],
      ["/role-management", "RoleManagement"],
      ["/permission-management", "PermissionManagement"],
      ["/company-management", "Company"],
      ["/circle-management", "Circle"],
      ["/division-management", "Division"],
      ["/support-center-management", "CFC"],
      ["/sub-division-management", "SubDivision"],
      ["/power-complaint-map-management", "ComplaintAndControlCenter"],
      ["/pending-escalated-complaints", "TechnicalOperations"],
      ["/apms-dashboard", "APMSDashboard"],
      ["/apms-list", "FeederList"],
      ["/load-shedding", "LoadSheddingSchedule"],
      ["/loadmanagement", "LoadSheddingSchedule"],
      ["/mobile-app-stats", "MobileAppStats"],
      ["/logged-in-users", "LoggedInUsers"],
      ["/lineman-app-user-summary", "LinemanAPPUserSummary"],
      ["/active-user-summary", "LinemanAPPUserSummary"],
      ["/complaint-detailed-history", "ComplaintDetailedHistory"],
      ["/power-complaint-form", "NewComplaint"],
      ["/new-complaint", "NewComplaint"],
      ["/meter-reading-correction-table", "MeterReadingCorrection"],
      ["/feeder-list", "FeederList"],
      ["/feeder-losses", "FeederLossesReport"],
      ["/feeder-length-report", "FeederLengthReport"],
      ["/daily-progress-report-cfc-wise", "DailyProgressReportCfcWise"],
      ["/daily-progress-report", "DailyProgressReport"],
    ];

    const matched = routeSelections.find(
      ([route]) => path === route || path.startsWith(`${route}/`) || path.includes(route),
    );
    if (matched) return [matched[1]];

    const commercialPaths = [
      "bill-correction",
      "meter-reading",
      "amend-",
      "part-payment",
      "advance-payment",
      "set-aside",
      "withdrawal-of-installment",
      "disconnection",
    ];
    const technicalPaths = [
      "power-complaint",
      "lineman",
      "feeder-losses",
      "load-shedding",
      "mobile-app-stats",
      "technicaloperations",
    ];

    if (commercialPaths.some((segment) => path.includes(segment))) {
      return [permissionsVariables.commercialOperations];
    }
    if (technicalPaths.some((segment) => path.includes(segment))) {
      return ["TechnicalOperations"];
    }
    if (
      path.includes("user-management") ||
      path.includes("role-management") ||
      path.includes("permission-management") ||
      path.includes("workforce")
    ) {
      return ["AccessManagement"];
    }
    if (
      path.includes("company-management") ||
      path.includes("circle-management") ||
      path.includes("division-management") ||
      path.includes("support-center") ||
      path.includes("sub-division")
    ) {
      return ["OrganizationManagement"];
    }

    return [];
  }, [location.pathname]);

  const sidebarMenuItems = useMemo(() => {
    if (!isMobile) return filteredItems;

    const itemsWithoutLogout = filteredItems.filter((item) => item.key !== "Logout");
    const signOutItem = {
      key: "Logout",
      label: "",
      icon: IconWithLabel(Logout1, "Sign Out", "red"),
    };

    const eopsIndex = itemsWithoutLogout.findIndex((item) => item.key === "EopsUpdates");
    if (eopsIndex >= 0) {
      return [
        ...itemsWithoutLogout.slice(0, eopsIndex + 1),
        signOutItem,
        ...itemsWithoutLogout.slice(eopsIndex + 1),
      ];
    }

    return [...itemsWithoutLogout, signOutItem];
  }, [filteredItems, isMobile]);

  // const drawerWidth = !powerComplaintsMenu ? 275 : !displayComplaintPage ? 250 : 0;

  const currentDate = new Date();
  const day = currentDate.getDate();
  const month = currentDate.toLocaleString("en-US", { month: "short" }); // Get month in 'Sep' format
  const year = currentDate.getFullYear();
  const weekday = currentDate.toLocaleString("en-US", { weekday: "short" }); // Get current weekday

  const formattedDate = `${day} ${month}, ${weekday}`;

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const pageRoutes = {
    LandingPage: () => navigate("/landingpage"),
    DummyDashboard: () => navigate("/landingpage"),
    CFCDashboard: () => navigate("/homecfc"),
    FieldOfficeDashboard: () =>
      navigate("/homefieldoffice", {
        state: { officeCode: code, hierarchy: hierarchy },
      }),
    CFCPerformance: () =>
      navigate("/commercialOperations", {
        state: { officeCode: code, hierarchy: hierarchy },
      }),
    OperationalPerformance: () =>
      navigate("/operationalperformance", {
        state: { officeCode: code, hierarchy: hierarchy },
      }),
    CommercialOperations: () => {
      if (totalActionablesNormal + totalActionablesOverdue > 0) {
        navigate("/actionables-table");
      } else {
        navigate("/new-connection-table");
      }
    },
    Actionables: () => navigate("/actionables-table"),
    NewConnection: () => navigate("/new-connection-table"),
    DueDateExt: () => navigate("/due-date-extension-table"),
    BillInstallments: () => navigate("/installments-table"),
    WithdrawalOfInstallment: () => navigate("/withdrawal-of-installment-table"),
    SetAside: () => navigate("/set-aside-table"),
    Reconnection: () => navigate("/reconnection-table"),
    Disconnection: () => navigate("/disconnection-table"),
    BillCorrection: () => navigate("/bill-correction-table"),
    MeterReadingCorrection: () => navigate("/meter-reading-correction-table"),
    ChangeOfName: () => navigate("/change-of-attributes-table"),
    ChangeOfLoad: () => navigate("/change-of-load-table"),
    ChangeOfTariff: () => navigate("/change-of-tariff-table"),

    AdjustLastBill: () => navigate("/adjust-last-bill-table"),

    ShiftToNetMeter: () => navigate("/net-metering"),
    UpdateTenantCNIC: () => navigate("/cnic-updation"),
    MeterChangeRequest: () => navigate("/meter-change-request-table"),
    DuplicateBill: () => navigate("/duplicate-bill"),
    AmendDuplicateBill: () => setOpenAmendBillPopup(true),
    AmendBill2636: () => navigate("/amend-2636-bill-table"),
    AdvancePayment: () => navigate("/advance-payment-table"),

    PowerComplaintTable: () => navigate("/power-complaint-form"),
    TechnicalOperations: () => navigate("/pending-escalated-complaints"),
    ComplaintAndControlCenter: () =>
      navigate("/power-complaint-map-management"),
    Home: () => navigate("/power-complaint-map-management"),
    HomeTac: () => navigate("/technicalOperations"),

    CircleHome: () => {
      {
        dispatch(updateHomeButton(true));
      }
    },
    FeederLossesReport: () => navigate("/feeder-losses-report"),
    NewComplaint: () => setShowComplaintForm(true),
    ComplaintDetailedHistory: () => navigate("/complaint-detailed-history"),
    FeederList: () => {
      if (!showFeederList) return;
      setShowFeederForm(true);
    },
    ApmsList: () => {
      setShowApmsForm(true);
      if (hierarchy == 52) {
        getAPMSCoordinates(String(code || "").slice(0, 5));
        return;
      }

      // Company level: keep MEPCO default, allow other companies via Go
      const defaultCompany =
        String(code) === "10"
          ? apmsCompanyCode || "15"
          : String(code || "").slice(0, 2) || "15";
      const companyToLoad =
        defaultCompany && defaultCompany !== "10" ? defaultCompany : "15";
      setApmsCompanyCode(companyToLoad);
      getAPMSCoordinates(companyToLoad);
    },
    APMSDashboard: () => navigate("/apms-dashboard"),
    Linemen: async () => {
      await getWorkForceDesignations();
      if (String(code) === "10") {
        const company =
          officeCodee || selectedCompanyCode || selectedAdminCompanyCode;
        if (company) {
          await getWFData(company);
        } else {
          setWorkForceData([]);
        }
      } else {
        await getWFData();
      }
      setShowWorkforceForm(true);
    },
    MobileAppStats: () => navigate("/mobile-app-stats"),
    LineStaffPerformance: () => navigate("/lineman-staff-performance"),
    LoadSheddingSchedule: () => navigate("/load-shedding-schedule"),
    ComplaintRegister: () => navigate("/power-complaint-detail-report"),
    EscalationComplaints: () => navigate("/escalation-complaints-report"),
    LinemanAPPUserSummary: () => navigate("/lineman-app-user-summary"),
    PendingComplaints: () => navigate("/power-complaint-pending"),
    AllocatedComplaints: () => navigate("/power-complaint-allocated"),
    WorkingComplaints: () => navigate("/power-complaint-working"),
    OnholdComplaints: () => navigate("/power-complaint-onhold"),
    EscalatedComplaints: () => navigate("/power-complaint-escalated"),
    APMSComplaintsSummary: () => navigate("/apms-complaints-summary"),
    APMSEscalatedComplaints: () => navigate("/apms-escalated-complaints"),
    ResolvedComplaints: () => navigate("/power-complaint-resolved"),
    WorkforceManagement: async () => {
      await getWorkForceDesignations();
      if (String(code) === "10") {
        const company =
          officeCodee || selectedCompanyCode || selectedAdminCompanyCode;
        if (company) {
          await getWFData(company);
        } else {
          setWorkForceData([]);
        }
      } else {
        await getWFData();
      }
      setShowWorkforceForm(true);
    },
    UserManagement: () => navigate("/user-management"),
    RoleManagement: () => navigate("/role-management"),
    PermissionManagement: () => navigate("/permission-management"),
    EopsUpdates: () => navigate("/eops-updates"),
    Company: () => navigate("/company-management"),
    Circle: () => navigate("/circle-management"),
    Division: () => navigate("/division-management"),
    CFC: () => navigate("/support-center-management"),
    SubDivision: () => navigate("/sub-division-management"),
    MapHome: () => navigate("/power-complaint-map"),
    NewConnectionReport: () => navigate("/new-connection-summary"),
    NewConnectionPostedToIBSReport: () =>
      navigate("/new-connection-posted-to-ibs-report"),
    NewConnectionSubDivisionWiseApplicationsStatus: () =>
      navigate("new-connection-subdivision-wise-applications-status-report"),
    NewConnectionStatusWiseCountReport: () =>
      navigate("new-connection-status-wise-count-report"),
    NewConnectionCancelApplicationReport: () =>
      navigate("nc-cancel-application-report"),
    ExceededMonthWisePendingRipeReport: () =>
      navigate("exceeded-month-wise-pending-ripe-report"),
    DueDateExtensionReport: () => navigate("/due-date-extension-reports"),
    MeterReadingCorrectionReport: () =>
      navigate("/meter-reading-correction-reports"),
    InstallmentReport: () => navigate("/installments-reports"),
    CashCollectionSummaryReport: () =>
      navigate("/cash-collection-summary-report"),
    BatchWiseAssessment: () => navigate("batch-wise-assessment-report"),
    DeadDefaulterList: () => navigate("/dead-defaulter-report"),
    DailyProgressReport: () => navigate("/daily-progress-report"),
    DailyProgressReportCfcWise: () => navigate("/daily-progress-report-cfc-wise"),
    FeederLossesReport: () => navigate("/feeder-losses-report"),
    DeadDefaulterReport: () => navigate("dead-defaulter-report"),
    ComputedBillingAndCollectionAnalysis: () =>
      navigate("computed-billing-&-collection-analysis-report"),
    WrongReadingTable: () => navigate("wrong-reading-table"),
    LoggedInUsers: () => navigate("logged-in-users"),
    ComplaintsSummary: () => navigate("subdivision-wise-complaints-summary"),
    SubdivisionWiseAPMSComplaintSummary: () =>
      navigate("subdivision-wise-apms-complaint-summary"),
    CADLineComplaintsStats: () => navigate("cad-line-complaints-stats"),
    FeederLengthReport: () => navigate("feeder-length-report"),
    EopsMobileAppUsageSummary: () => navigate("eops-mobile-app-usage-summary"),
    NotLoggedInUserInLast24Hours: () =>
      navigate("not-logged-in-user-in-last-24-hours"),
    EopsUsersStatus: () => navigate("eops-users-status-report"),
    UserComplaintProcessingStatistics: () =>
      navigate("user-complaint-processing-statistics"),
    ComplaintSourceWise: () => navigate("eops-complaint-source-wise"),
    NewConnectionStatusReport: () => navigate("new-connection-status-reports"),
    MeterChangeOrderStatusReport: () =>
      navigate("meter-change-order-status-report"),
    PerformanceEvaluationReport: () => navigate("performance-evaluation-report"),
    CancelApplicationsDueToNonPaymentReport: () =>
      navigate("cancel-applications-due-to-non-payment-report"),
    MdmSyncReport: () => navigate("mdm-sync-report"),
    WorstPerformer: () => navigate("worst-performer-users-report"),
    TopBestAndWorstPerformer: () =>
      navigate("top-best-and-worst-performer-users-report"),

    SrOnEmail: () => navigate("/sr-on-email"),
    COASrOnEmail: () => navigate("/coa-sr-on-email"),
    COASummaryReports: () => navigate("/change-of-attributes-summary-report"),
    COAStatusReports: () => navigate("/change-of-attributes-status-report"),
    ChangeOfAttributesPostedToIBSReport: () =>
      navigate("/change-of-attributes-posted-to-ibs-report"),
    ChangeOfAttributesStatusWiseCountReport: () =>
      navigate("/change-of-attributes-status-wise-count-report"),
    ChangeOfAttributesCancelApplicationReport: () =>
      navigate("coa-cancel-application-report"),
    ReconnectionPostedToIBSReport: () =>
      navigate("/reconnection-posted-to-ibs-report"),
    ReconnectionStatusReport: () =>
      navigate("/reconnection-status-report"),
  };

  const handleItemClick = (nodeId, parentIds = []) => {
    if (pageRoutes[nodeId]) {
      pageRoutes[nodeId]();
    }
    if (isMobile) {
      setOpen(false);
    }
  };

  const Main = styled("main", {
    shouldForwardProp: (prop) => prop !== "open" && prop !== "isMobile",
  })(({ theme, open, isMobile: mobile }) => ({
    flexGrow: 1,
    padding: theme.spacing(0),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    margin: mobile ? 0 : `-${drawerWidth}px`,
    ...(!mobile &&
      open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      margin: 0,
    }),
  }));

  const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== "open" && prop !== "isMobile",
  })(({ theme, open, isMobile: mobile }) => ({
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(!mobile &&
      open && {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: `${drawerWidth}px`,
      transition: theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
  }));

  const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 0),
    ...theme.mixins.toolbar,
    justifyContent: "flex-start",
  }));

  useEffect(() => {
    setOpen(!isMobile);
  }, [isMobile]);

  useEffect(() => {
    if (isMobile) {
      setOpen(false);
    }
  }, [location.pathname, isMobile]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        userMenuAnchorRef.current &&
        !userMenuAnchorRef.current.contains(event.target)
      ) {
        setMenuOpen(false);
      }
    };

    const handleOpenSidebar = () => setOpen(true);
    const handleOpenSidebarMenu = (e) => {
      const detail = e?.detail || {};
      let keys = [];
      if (Array.isArray(detail.keys)) keys = detail.keys;
      else if (detail.keys) keys = [detail.keys];
      else if (detail.key)
        keys = Array.isArray(detail.key) ? detail.key : [detail.key];

      if (keys && keys.length) {
        setOpen(true);
        setOpenMenuKeys(keys);
      }
    };
    const handleOpenSearchPopup = () => handleOpenSearchBarPopup();

    window.addEventListener("openSidebar", handleOpenSidebar);
    window.addEventListener("openSidebarMenu", handleOpenSidebarMenu);
    window.addEventListener("openSearchPopup", handleOpenSearchPopup);

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      window.removeEventListener("openSidebar", handleOpenSidebar);
      window.removeEventListener("openSidebarMenu", handleOpenSidebarMenu);
      window.removeEventListener("openSearchPopup", handleOpenSearchPopup);
    };
  }, []);

  const LineManFormClose = () => {
    if (isFormModified) {
      lmSignUpFormik.handleSubmit(); // Call API only if the form has been modified
    }
    setShowLineManForm(false); // Close the form
  };

  //#region Complaint submission
  const [typeId, setTypeId] = React.useState(1);
  const [typeName, setTypeName] = React.useState(
    complaintType == "Technical" ? "Power Outage" : "Meter Position",
  );
  const [billMonth, setBillMonth] = useState("");

  const [searchBy, setSearchBy] = useState("consumerId");
  const [latitudeOfRefNo, setLatitudeOfRefNo] = useState("");
  const [logitudeOfRefNo, setLogitudeOfRefNo] = useState("");
  const [transformerLat, setTransformerLat] = useState("");
  const [transformerLong, setTransformerLong] = useState("");
  const [transformerSubDivCode, setTransformerSubDivCode] = useState("");
  const [transformerRefNo, setTransformerRefNo] = useState("");
  const [tariff, setTariff] = useState();
  const [meterType, setMeterType] = useState();
  const [meterNo, setMeterNo] = useState();
  const [phase, setPhase] = useState();
  const [referenceNumber, setReferenceNumber] = useState("");

  const [showOldPassword, setShowOldPassword] = React.useState(false);
  const [showNewPassword, setShowNewPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const [feederNo, setFeederNo] = useState();

  const [meterPhase, setMeterPhase] = useState();
  const [meterTypes, setMeterTypes] = useState();

  const handleClickShowOldPassword = () => setShowOldPassword((prev) => !prev);
  const handleClickShowNewPassword = () => setShowNewPassword((prev) => !prev);
  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword((prev) => !prev);
  const { data: geoJsonData } = useSelector((state) => state.geoJson);

  const TypeId = (event) => {
    setTypeId(event.target.value);
    setTypeName(event.target.name);
  };

  useEffect(() => {
    if (geoJsonData && hierarchy == 52) {
      const features = geoJsonData.features;
      if (features) {
        const feederArray = [];
        const feederFeatures = features.filter(
          (feature) =>
            feature.properties["Feeder Code"] != null &&
            feature.properties["Feeder Code"] != "11kV",
        );
        let feederString = "";
        feederFeatures.forEach((feature) => {
          const feederCode = feature.properties["Feeder Code"];
          if (!feederArray.includes(feederCode) && feederCode) {
            feederString.concat(feederCode.toString()).concat(",");
            feederArray.push(feederCode);
          }
        });
        feederString = feederArray.join(",");
        dispatch(fetchFeederStatus(feederString));
      }
    }
  }, [geoJsonData]);

  useEffect(() => {
    if (typeId) {
      const typeName = otherComplaintsArray.find(
        (item) => item.code === typeId,
      );
      if (typeName) {
        setTypeName(typeName.name);
      }
    }
  }, [typeId]);

  const today = new Date(); // Setting a specific date for testing
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  const yesterdayDate = yesterday.toISOString().split("T")[0];

  const errorCloses = () => {
    setComplaintsError("");
    setApiError("");
  };

  const [groupedFeeders, setGroupedFeeders] = useState({});
  const [groupedAPMS, setGroupedAPMS] = useState({});

  const formatApmsCommTime = (raw) => {
    if (!raw || raw === "N/A") return "N/A";
    const parsed = new Date(raw);
    if (Number.isNaN(parsed.getTime())) return String(raw);
    return parsed.toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  };

  useEffect(() => {
    // Subdivision auto-load only. Company level loads on open/Go with company code.
    if (hierarchy == 52) {
      getAPMSCoordinates(String(code || "").slice(0, 5));
    }
  }, [hierarchy, code, mdmToken?.privatekey]);

  const mapApmsRecords = (records = []) =>
    (Array.isArray(records) ? records : []).reduce((acc, record) => {
      const grid = "All Data";
      if (!acc[grid]) {
        acc[grid] = [];
      }
      const currentStatus = [record.i1, record.i2, record.i3].some(
        (currentValue) => currentValue === "0.0",
      )
        ? "ON"
        : record.contactor_status
          ? "ON"
          : "OFF";

      acc[grid].push({
        name: record.name,
        msn: record.msn,
        current_load: record.current_load,
        voltage: `${record.v1} / ${record.v2} / ${record.v3}`,
        current: `${record.i1} / ${record.i2} / ${record.i3}`,
        apms_capacity: record.apms_capacity,
        kva: record.kva,
        status: currentStatus,
        last_communication_time: record.last_communication_time
          ? String(record.last_communication_time).slice(0, 16)
          : "N/A",
      });

      return acc;
    }, {});

  const ensureMdmPrivateKey = async () => {
    if (mdmToken?.privatekey) {
      return mdmToken.privatekey;
    }
    try {
      const authResult = await dispatch(fetchAuth()).unwrap();
      return authResult?.privatekey || null;
    } catch (error) {
      return null;
    }
  };

  const getAPMSCoordinates = async (organizationCode) => {
    const orgCode = String(organizationCode || "").trim();
    if (!orgCode) {
      setGroupedAPMS({});
      return;
    }

    setApmsLoading(true);
    try {
      const privateKey = await ensureMdmPrivateKey();
      if (!privateKey) {
        setGroupedAPMS({});
        return;
      }

      const myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("privatekey", privateKey);

      const formdata = new FormData();
      // Company level uses company code (15/13/14...). Subdivision uses 5-digit code.
      formdata.append("organization_code", orgCode);

      const response = await fetch(
        "https://api.mdm.pitc.com.pk/api/get_apms_status",
        {
          method: "POST",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        },
      );
      const result = await response.json();
      const records = Array.isArray(result?.data)
        ? result.data
        : Array.isArray(result)
          ? result
          : [];
      setGroupedAPMS(mapApmsRecords(records));
    } catch (error) {
      setGroupedAPMS({});
    } finally {
      setApmsLoading(false);
    }
  };

  const handleApmsCompanyGo = async () => {
    const companyCodeToLoad = String(apmsCompanyCode || "15").trim();
    if (!companyCodeToLoad || companyCodeToLoad === "10") {
      setGroupedAPMS({});
      return;
    }
    await getAPMSCoordinates(companyCodeToLoad);
  };

  const apmsCompanyOptions = [
    { value: "15", label: "MEPCO" },
  ];

  const isCompanyLevelApms = hierarchy != 52;

  useEffect(() => {
    if (result1 && result1 && hierarchy == 52) {
      setGroupedFeeders(
        result1.reduce((acc, record) => {
          const grid = record.grid;
          if (!acc[grid]) {
            acc[grid] = [];
          }
          const formattedReportingTime = record.reporting_time.slice(0, 16);

          acc[grid].push({
            last_reporting_time: formattedReportingTime,
            feeder: record.feeder,
            feeder_code: record.feeder_code,
            current: record.current,
            voltage: record.voltage,
            power_factor: record.power_factor,
            active_power_kW: record.active_power_kW,
            current_status: record.current_status,
          });
          return acc;
        }, {}),
      );
    }
  }, [result1]);

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues,
    validationSchema: Yup.object({
      iv_con_id_ref_no: Yup.string().when("iv_search_by", {
        is: "referenceNo",
        then: Yup.string()
          .length(14, "Reference No. must be exactly 14 digits.")
          .required("Enter reference number."),
      }),
      iv_name: yupSafeFormText(
        Yup.string()
          .min(3, "Name should be at least 3 characters.")
          .max(200, "Name should be less than 200 characters.")
          .required("Enter applicant name."),
      ),
      iv_phone_no: Yup.string()
        .length(11, "Enter a valid 11-digit phone number.")
        .required("Enter valid mobile number.")
        .matches(/^03[0-9]{2}[0-9]{7}$/, "Enter phone number as 03001234567"),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);

      // Handle APMS MSN complaint submission
      if (selectedOption === "apmsMsn") {
        // Validation
        if (!typeId) {
          setComplaintsError(
            "Please select a Complaint Type (Critical Alarm / Tripping / Others).",
          );
          setViewBackdrop(false);
          return;
        }
        if (
          !values.iv_con_id_complaint_details ||
          values.iv_con_id_complaint_details.trim() === ""
        ) {
          setComplaintsError("Complaint Detail is required.");
          setViewBackdrop(false);
          return;
        }

        // Determine complaint category based on typeId prefix
        let complaintCategoryName = "Critical Alarm";
        if (typeId.startsWith("trip_")) {
          complaintCategoryName = "Tripping";
        } else if (typeId === "apms_others") {
          complaintCategoryName = "Others";
        }

        const apmsHeaders = new Headers();
        apmsHeaders.append("Authorization", token);
        apmsHeaders.append("Content-Type", "application/json");

        const apmsRaw = JSON.stringify({
          apmsMeterSerialNo: values.iv_con_id_ref_no,
          submittedThrough: "e-Operations",
          transformerName: values.iv_name,
          feederCode: values.iv_phone_no,
          feederName: values.iv_address,
          complaintCategoryName: complaintCategoryName,
          complaintTypeName: typeName,
          transformerLatitude: parseFloat(transformerLat) || 0,
          transformerLongitude: parseFloat(transformerLong) || 0,
          subDivisionCode:
            parseInt(transformerSubDivCode) || parseInt(code) || 0,
          description: values.iv_con_id_complaint_details,
          attachment: complaintAttachment,
        });

        const apmsRequestOptions = {
          method: "POST",
          headers: apmsHeaders,
          body: apmsRaw,
          redirect: "follow",
        };

        try {
          const response = await fetch(
            cfpBaseUrl + "apms/registerAPMSComplaint",
            apmsRequestOptions,
          );
          const result = await response.json();

          if (response.status === 200 || result.status === "200") {
            setViewBackdrop(false);
            setShowApmsSuccessPopup(true);
            setShowComplaintForm(false);
            resetForm();
            setComplaintAttachment("");
            setComplaintAttachmentName("");
            setComplaintAttachmentPreview("");
            setSelectedOption("referenceNo");
            setTypeId("");
            setTypeName("");
            setTransformerLat("");
            setTransformerLong("");
            setTransformerSubDivCode("");
            setTransformerRefNo("");
            // Dispatch event to refresh APMS complaints list
            window.dispatchEvent(new CustomEvent("apmsComplaintSubmitted"));
          } else {
            setViewBackdrop(false);
            setComplaintsError(
              result.message || "Failed to register APMS complaint.",
            );
          }
        } catch (error) {
          setViewBackdrop(false);
          setComplaintsError(
            "Error submitting APMS complaint. Please try again.",
          );
        }
        return;
      }

      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", token);

      let raw = {};
      let apiUrl = "";
      const requestOptionss = {
        method: "GET",
        redirect: "follow",
      };

      fetch(
        "https://cp.pitc.com.pk:8071/api/BasicInfo/GetInfo?refno=" +
        referenceNumber,
        requestOptionss,
      )
        .then((response) => response.json())
        .then((result) => {
          if (complaintType == "Technical") {
            raw = JSON.stringify({
              RefNo: referenceNumber,
              Name: values.iv_name,
              Mobile: values.iv_phone_no,
              CNIC: "1234567890123",
              Address: values.iv_address,
              NearByFamousPlace: values.iv_address,
              Province: "punjab",
              Status: "Pending",
              ComplaintNature: "Line Complaints",
              Source: "e-Operations Technical",
              ComplaintType: typeName,
              ComplaintDescription: values.iv_con_id_complaint_details,
              attachment: complaintAttachment,
              Latitude: result.Table[0].GPSLATI ? result.Table[0].GPSLATI : "",
              Longitude: result.Table[0].GPSLONG ? result.Table[0].GPSLONG : "",
              FeederCode: feederNo,
              ComplaintNatureId: 1,
              ComplaintTypeId: typeId,
            });

            apiUrl = `${cfpBaseUrl}lineComplaints/registerLineComplain`;
          } else {
            raw = JSON.stringify({
              RefNo: referenceNumber,
              Name: values.iv_name,
              Mobile: values.iv_phone_no,
              CNIC: "1234567890123",
              Address: values.iv_address,
              NearByFamousPlace: values.iv_address,
              Province: "punjab",
              Status: "Pending",
              ComplaintNature: "Non Line Complaints",
              Source: "e-Operations Technical",
              ComplaintType: typeName,
              ComplaintDescription: values.iv_con_id_complaint_details,
              attachment: complaintAttachment,
              Latitude: result.Table[0].GPSLATI ? result.Table[0].GPSLATI : "",
              Longitude: longitude ? longitude : "",
              FeederCode: feederNo,
              ComplaintNatureId: 2,
              ComplaintTypeId: typeId,
            });

            apiUrl = `${cfpBaseUrl}nonLineComplaints/registerNonLineComplaint`;
          }
          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
          };

          fetch(apiUrl, requestOptions)
            .then((response) => response.json())
            .then(async (result) => {
              if (result.status === "200") {
                setViewBackdrop(false);

                const requestOptions = {
                  method: "GET",
                  redirect: "follow",
                };

                fetch(
                  "https://cp.pitc.com.pk:8071/api/BasicInfo/GetInfo?refno=" +
                  referenceNumber,
                  requestOptions,
                )
                  .then((response) => response.text())
                  .then(() => { })
                  .catch(() => { });
                printApplicationReceipt(
                  complaintType == "Technical"
                    ? result.EOpsTrackingId
                    : result.CCMSTicketNo,
                  referenceNumber,
                  values,
                  typeName,
                  values.iv_con_id_complaint_details,
                );
                dispatch(
                  fetchPaginatedAllComplaints({
                    pageSize: complaintsPageSize,
                    pageNumber: complaintsPageNumber,
                    subDivisionCode: code,
                    dateFrom: convertDateYYYYMMDD(yesterdayDate),
                    dateTo: convertDateYYYYMMDD(new Date()),
                    roleTypeId: roleTypeId,
                  }),
                );
                setShowComplaintForm(false);
                resetForm();
                setComplaintAttachment("");
                setComplaintAttachmentName("");
                setComplaintAttachmentPreview("");
              } else {
                setViewBackdrop(false);
                if (
                  result.message ===
                  "Complaint already exist against given Ref No in Same Date."
                ) {
                  setComplaintsError(
                    "Complaint already exist against given Ref No in Same Date.",
                  );
                } else {
                  setComplaintsError(result.message);
                }
              }
            })
            .catch(() => { });
        })
        .catch(() => { });
    },
  });

  const nameFormik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      iv_full_name: yupSafePersonName(
        Yup.string()
          .min(3, "Name should be atleast 3 characters.")
          .max(30, "Name should be less than 30 characters.")
          .required("Enter name."),
      ),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);
      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        const formdata = new FormData();
        formdata.append("userName", userId);
        formdata.append("fullName", values.iv_full_name);

        const requestOptions = {
          method: "PUT",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        };

        await fetch(
          cfpBaseUrl + "customerFaciliationPortal/updateUserProfileName",
          requestOptions,
        )
          .then((response) => response.json())
          .then((result) => {
            if (result.status === "200") {
              dispatch(updateName(values.iv_full_name));
              setEnableFullName(false);
            } else {
              setApiError(result.Message);
            }
          })
          .catch((error) => {
            setApiError("Unable to update name!");
          });
      } catch (e) {
        setApiError("Unable to update name!");
      }
      setViewBackdrop(false);
    },
  });

  useEffect(() => {
    const updateDateTime = () => {
      const now = new Date();

      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");

      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");

      const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}`;
      setCDateTime(formattedDateTime);
    };

    updateDateTime();
    const interval = setInterval(updateDateTime, 60000);

    return () => clearInterval(interval);
  }, []);

  const phoneFormik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      iv_user_phone_no: Yup.string()
        .max(11, "Enter 11 digit phone number.")
        .min(11, "Enter 11 digit phone number.")
        .required("Enter valid mobile number.")
        .matches(/^03[0-9]{2}[0-9]{7}$/, "Enter Phone number as 03001234567"),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);
      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        const formdata = new FormData();
        formdata.append("userName", userId);
        formdata.append("phoneNo", values.iv_user_phone_no);

        const requestOptions = {
          method: "PUT",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        };

        await fetch(
          cfpBaseUrl + "customerFaciliationPortal/updateUserProfilePhone",
          requestOptions,
        )
          .then((response) => response.json())
          .then((result) => {
            if (result.status === "200") {
              dispatch(updatePhone(values.iv_user_phone_no));
              setEnablePhone(false);
            } else {
              setApiError(result.Message);
            }
          })
          .catch((error) => {
            setApiError("Unable to update phone!");
          });
      } catch (e) {
        setApiError("Unable to update phone!");
      }
      setViewBackdrop(false);
    },
  });

  const emailFormik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      iv_user_email: Yup.string()
        .email("Enter valid email!")
        .required("Email is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);
      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        const formdata = new FormData();
        formdata.append("userName", userId);
        formdata.append("email", values.iv_user_email);

        const requestOptions = {
          method: "PUT",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        };

        await fetch(
          cfpBaseUrl + "customerFaciliationPortal/updateUserProfileEmail",
          requestOptions,
        )
          .then((response) => response.json())
          .then((result) => {
            if (result.status === "200") {
              dispatch(updateEmail(values.iv_user_email));
              setEnableEmail(false);
            } else {
              setApiError(result.Message);
            }
          })
          .catch((error) => {
            setApiError("Unable to update phone!");
          });
      } catch (e) {
        setApiError("Unable to update phone!");
      }
      setViewBackdrop(false);
    },
  });

  const complaintFormClose = () => {
    setMeterStatus("");
    setArrear("");
    values.iv_address = "";
    values.iv_complaint_type = "";
    values.iv_con_id_ref_no = "";
    values.iv_consumer_id = "";
    values.iv_phone_no = "";
    setComplaintAttachment("");
    setComplaintAttachmentName("");
    setComplaintAttachmentPreview("");
    setTypeId("");
    setShowComplaintForm(false);
  };

  const handleComplaintAttachmentUpload = (event) => {
    const file = event.target.files?.[0];
    if (!file) {
      return;
    }

    const maxSizeInBytes = 2 * 1024 * 1024;
    if (file.size > maxSizeInBytes) {
      setComplaintsError("Attachment size must be 2MB or less.");
      setComplaintAttachment("");
      setComplaintAttachmentName("");
      setComplaintAttachmentPreview("");
      event.target.value = "";
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      const base64Content =
        typeof reader.result === "string"
          ? reader.result.split(",")[1] || ""
          : "";
      setComplaintAttachment(base64Content);
      setComplaintAttachmentName(file.name);
      setComplaintAttachmentPreview(
        file.type?.startsWith("image/") && typeof reader.result === "string"
          ? reader.result
          : "",
      );
      setComplaintsError("");
    };
    reader.onerror = () => {
      setComplaintsError("Unable to read attachment file.");
      setComplaintAttachment("");
      setComplaintAttachmentName("");
      setComplaintAttachmentPreview("");
    };
    reader.readAsDataURL(file);
    event.target.value = "";
  };

  const errorCloses1 = () => {
    setArrear("");
    setApiError("");
  };

  // useEffect(async() => {
  //   let codeToGeoJSON = code
  //   if(hierarchy == 52){
  //     dispatch(fetchGeoJson({ subDivisionCode: codeToGeoJSON, roleTypeId: roleTypeId }))
  //   }else {
  //     const codeto = codeToGeoJSON.slice(0, 2);
  //     await Promise.all([
  //       dispatch(fetchGeoJson({ subDivisionCode: codeto, roleTypeId })),
  //       dispatch(fetchDivisionGeoJson({ subDivisionCode: codeto, roleTypeId }))
  //     ]);

  //   }

  // }, [])
  // useEffect(() => {
  //   const fetchData = async () => {
  //     let codeToGeoJSON = code;

  //     if (hierarchy === 52) {
  //       dispatch(fetchGeoJson({ subDivisionCode: codeToGeoJSON, roleTypeId }));
  //     } else {
  //       const codeto = codeToGeoJSON.slice(0, 2);

  //       await Promise.all([
  //         dispatch(fetchGeoJson({ subDivisionCode: codeto, roleTypeId })),
  //         dispatch(fetchDivisionGeoJson({ subDivisionCode: codeto, roleTypeId }))
  //       ]);
  //     }
  //   };

  //   fetchData();
  // }, []);

  useEffect(() => {
    if (!token || !code) return;
    const pathname = location?.pathname || "";
    const onGisPage =
      pathname.includes("power-complaint-map") ||
      pathname.includes("complaint-map");
    if (!onGisPage && !showFeederForm) return;

    const fetchData = async () => {
      let codeToGeoJSON = code;

      if (hierarchy === 52) {
        await dispatch(
          fetchGeoJson({ subDivisionCode: codeToGeoJSON, roleTypeId }),
        );
      } else {
        const codeto = codeToGeoJSON.slice(0, 2);

        await Promise.all([
          dispatch(
            fetchGeoJson({
              subDivisionCode: hierarchy == 1 ? "15" : codeto,
              roleTypeId,
            }),
          ),
          dispatch(
            fetchDivisionGeoJson({
              subDivisionCode: hierarchy == 1 ? "15" : codeto,
              roleTypeId,
            }),
          ),
        ]);
      }
    };

    fetchData();
  }, [token, code, hierarchy, roleTypeId, location.pathname, showFeederForm, dispatch]);

  // const profilePictureFormik = useFormik({
  //   initialValues,
  //   validationSchema: Yup.object({
  //     iv_profile_picture: Yup.mixed()
  //       .test('fileType', 'Only JPEG and PNG images are allowed', (value) => {
  //         if (typeof value === 'string') return true;
  //         if (!value) return true;
  //         return value && (value.type === 'image/jpeg' || value.type === 'image/png');
  //       })
  //       .test('fileSize', 'File size must be less than 3MB', (value) => {
  //         if (typeof value === 'string') return true;
  //         if (!value) return true;
  //         return value && value.size <= 3 * 1024 * 1024; // Check if size is less than 3MB
  //       })
  //       .optional(),
  //   }),
  //   onSubmit: async (values, { resetForm }) => {
  //     setViewBackdrop(true);
  //     try {

  //       const myHeaders = new Headers();
  //       myHeaders.append("Authorization", token);

  //       const formdata = new FormData();
  //       formdata.append("userName", userId);
  //       formdata.append("profilePicture", values.iv_profile_picture);

  //       const requestOptions = {
  //         method: "PUT",
  //         headers: myHeaders,
  //         body: formdata,
  //         redirect: "follow"
  //       };

  //       await fetch(cfpBaseUrl + "customerFaciliationPortal/updateUserProfileImage", requestOptions)
  //         .then((response) => response.json())
  //         .then((result) => {
  //           if (result.stats === "200") {
  //             // dispatch(updateProfilePicture())
  //           }
  //         })
  //         .catch((error) => {
  //           setApiError('Unable to update profile picture.')
  //         });
  //     }
  //     catch (e) {
  //       setApiError('Unable to update profile picture.')
  //     }
  //     setViewBackdrop(false);
  //   },
  // });
  const profilePictureFormik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      iv_profile_picture: Yup.mixed()
        .test("fileType", "Only JPEG and PNG images are allowed", (value) => {
          if (typeof value === "string") return true;
          if (!value) return true;
          return (
            value && (value.type === "image/jpeg" || value.type === "image/png")
          );
        })
        .test("fileSize", "File size must be less than 3MB", (value) => {
          if (typeof value === "string") return true;
          if (!value) return true;
          return value && value.size <= 3 * 1024 * 1024;
        })
        .optional(),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);

      try {
        if (typeof values.iv_profile_picture === "string") {
          setViewBackdrop(false);
          return;
        }

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        const formdata = new FormData();
        formdata.append("userName", userId);
        formdata.append("profilePicture", values.iv_profile_picture);

        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/updateUserProfileImage",
          {
            method: "PUT",
            headers: myHeaders,
            body: formdata,
            redirect: "follow",
          },
        );

        const result = await response.json();

        if (result.status === "200") {
          const reader = new FileReader();
          reader.onloadend = () => {
            dispatch(updateProfilePicture(reader.result));
          };
          reader.readAsDataURL(values.iv_profile_picture);
        } else {
          setApiError("Unable to update profile picture.");
        }
      } catch (error) {
        setApiError("Unable to update profile picture.");
      }

      setViewBackdrop(false);
    },
  });

  const passwordChangeFormik = useFormik({
    initialValues: {
      iv_old_password: "",
      iv_new_password: "",
      iv_confirm_password: "",
    },
    validationSchema: Yup.object({
      iv_old_password: Yup.string().required("Old password is required"),
      iv_new_password: Yup.string()
        .required("Password is required")
        .matches(
          passwordRegex,
          "Password must contain at least one uppercase letter, one lowercase letter, one number, one special character, and must be at least 8 characters long",
        ),
      iv_confirm_password: Yup.string()
        .required("Confirm password is required")
        .oneOf(
          [Yup.ref("iv_new_password")],
          "Password and Confirm password must match",
        ),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      const formdata = new FormData();
      formdata.append("userName", userId);
      formdata.append("newPassword", values.iv_new_password);
      formdata.append("currentPassword", values.iv_old_password);

      var requestOptions = {
        method: "PUT",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(
        cfpBaseUrl + "customerFaciliationPortal/updateUserPassword",
        requestOptions,
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            resetForm();
            window.location.reload();
          } else if (result.status === "400") {
            setApiError(result.message);
          }
        })
        .catch(() => { });
      setViewBackdrop(false);
    },
  });

  const resolveWorkforceOfficeCode = (officeCodeParam) => {
    if (officeCodeParam) {
      return officeCodeParam;
    }
    if (String(code) !== "10") {
      return offCode;
    }
    return resolveApiOfficeCode(
      code,
      roleId,
      officeCodee || selectedCompanyCode,
      selectedAdminCompanyCode,
    );
  };

  const getWFData = async (officeCodeParam) => {
    const effectiveCode = resolveWorkforceOfficeCode(officeCodeParam);

    if (
      String(code) === "10" &&
      (!effectiveCode ||
        (String(effectiveCode) === "10" &&
          !selectedCompanyCode &&
          !officeCodeParam &&
          !selectedAdminCompanyCode))
    ) {
      setWorkForceData([]);
      return;
    }

    setViewBackdrop(true);
    let wfData = await getWorkforceData(token, effectiveCode);
    const filteredData = wfData.filter(
      (item) => item.designation !== 1135 && item.designation !== 1177,
    );
    setWorkForceData(filteredData);
    setViewBackdrop(false);
  };
  useEffect(() => {
    if (String(code) !== "10") {
      getWFData(code);
    }
  }, []);
  const getWorkForceDesignations = async () => {
    let fieldStaffDesignations = await getFieldStaffDesignations(token);

    setFieldStaffDesignations(fieldStaffDesignations);
  };

  const deleteLmData = async (name) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", wmsPrivateToken);
    const formdata = new FormData();
    formdata.append("UserId", name);
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    setViewBackdrop(true);
    await fetch(
      wfsBaseUrl + "api/UserInfo/DeleteEOpsLMUserById",
      requestOptions,
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.Status == "200") {
          setApiError(result.Message);
          setViewBackdrop(false);
        } else {
          setApiError(result.Message);
          setViewBackdrop(false);
        }
      })
      .catch(() => { });
  };

  const lmSignUpFormik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      iv_lm_user_name: Yup.string().optional("Name is required"),
      iv_designation: Yup.string().optional("Designation is required"),
      iv_lm_phone_no: Yup.string().optional("Phone No. is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);
      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", wmsPrivateToken);
        myHeaders.append("Content-Type", "application/json");

        const userData = [];

        shift1Fields.forEach((field, index) => {
          if (field.isModified && field.name && field.phoneNo) {
            // Ensure the field is modified and valid
            userData.push({
              UserFullName: field.name,
              PhoneNo: field.phoneNo,
              CompanyCode: hierarchy == 52 ? code.toString().slice(0, 2) : "15",
              CircleCode: hierarchy == 52 ? code.toString().slice(0, 3) : "151",
              DivisionCode:
                hierarchy == 52 ? code.toString().slice(0, 4) : "1517",
              SubDivisionCode: hierarchy == 52 ? code : "15171",
              ShiftId: "1",
              Designation: field.designation,
            });
          }
        });

        shift2Fields.forEach((field, index) => {
          if (field.isModified && field.name && field.phoneNo) {
            // Ensure the field is modified and valid
            userData.push({
              UserFullName: field.name,
              PhoneNo: field.phoneNo,
              CompanyCode: hierarchy == 52 ? code.toString().slice(0, 2) : "15",
              CircleCode: hierarchy == 52 ? code.toString().slice(0, 3) : "151",
              DivisionCode:
                hierarchy == 52 ? code.toString().slice(0, 4) : "1517",
              SubDivisionCode: hierarchy == 52 ? code : "15171",
              ShiftId: "2",
              Designation: field.designation,
            });
          }
        });
        shift3Fields.forEach((field, index) => {
          if (field.isModified && field.name && field.phoneNo) {
            // Ensure the field is modified and valid
            userData.push({
              UserFullName: field.name,
              PhoneNo: field.phoneNo,
              CompanyCode: hierarchy == 52 ? code.toString().slice(0, 2) : "15",
              CircleCode: hierarchy == 52 ? code.toString().slice(0, 3) : "151",
              DivisionCode:
                hierarchy == 52 ? code.toString().slice(0, 4) : "1517",
              SubDivisionCode: hierarchy == 52 ? code : "15171",
              ShiftId: "3",
              Designation: field.designation,
            });
          }
        });

        if (userData.length > 0) {
          const requestBody = JSON.stringify(userData);
          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: requestBody,
            redirect: "follow",
          };

          await fetch(wfsBaseUrl + "api/UserInfo/EOpsLMSignUp", requestOptions)
            .then((response) => response.json())
            .then((result) => {
              if (result.status === "200") {
              } else {
                setApiError(result.Message);
              }
            })
            .catch((error) => {
              setApiError(error);
            });
        }
      } catch (e) {
        setApiError(e);
      }
      setViewBackdrop(false);
    },
  });

  const workForceAddFormik = useFormik({
    initialValues: workForceInitialValues,
    validationSchema: Yup.object().shape({
      iv_name: yupSafePersonName(
        Yup.string()
          .min(3, "Name should be atleast 3 characters.")
          .max(30, "Name should be less than 30 characters.")
          .required("Please enter lineman name.")
          .matches(/^[A-Za-z. ]*$/, "Only letters and '.' are allowed."),
      ),
      iv_designation: Yup.mixed().required("Designation is required!"),
      iv_shift: Yup.mixed().optional(),
      iv_phone: Yup.string()
        .max(11, "Please enter 11 digit phone number.")
        .min(11, "Please enter 11 digit phone number.")
        .required("Please enter valid mobile number.")
        .matches(/^03[0-9]{2}[0-9]{7}$/, "Enter Phone number as 03001234567"),
      iv_userId: Yup.string().required("User Id is required"),
      iv_password: Yup.string()
        .matches(
          passwordRegex,
          "Password must contain at least one uppercase letter, one lowercase letter, one number, one special character, and must be at least 8 characters long",
        )
        .required("Password is required"),
      iv_confirm_password: Yup.string()
        .oneOf(
          [Yup.ref("iv_password"), null],
          "Password and Confirm password must match",
        )
        .required("Confirm password is required"),
      iv_cnic: Yup.string()
        .min(13, "CNIC no. can not less than 13 digits.")
        .max(13, "CNIC no. can not greater than 13 digits.")
        .required("CNIC No. is required")
        .matches(/^[0-9]+$/, "Enter CNIC No. as 3520212345678"),
      iv_employeeCode: Yup.string()
        .min(2, "Employee code must be at least 2 characters.")
        .max(14, "Employee code must be at most 14 characters.")
        .required("Employee code is required")
        .matches(
          /^[0-9]+$/,
          "Employee code must contain only numeric characters.",
        ),
      iv_subDivision: Yup.string().required("Sub-Division is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);
      try {
        let newWFArray = {
          employeeName: values.iv_name,
          employeeMobileNo: values.iv_phone,
          employeeDesignationId: values.iv_designation,
          createdBy: userId,
          companyCode: values.iv_subDivision.slice(0, 2),
          circleCode: values.iv_subDivision.slice(0, 3),
          divisionCode: values.iv_subDivision.slice(0, 4),
          subDivisionCode: values.iv_subDivision.slice(0, 5),
          hierarchy: hierarchy == 52 ? hierarchy : 52,
          employeeCode: values.iv_employeeCode,
          password: values.iv_password,
          userId: values.iv_userId,
          shiftDetails: addSelectedItems1,
          employeeCNIC: values.iv_cnic,
          // employeeCode : values.iv_employeeCode
        };
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify(newWFArray);

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        await fetch(cfpBaseUrl + "workForce/addNewEmployeeInfo", requestOptions)
          .then(async (response) => {
            if (response.status == 200) {
              window.location.reload();
              return response.json();
            } else {
              let res = await response.json();
              setApiError(res.message);
            }
          })
          .then((result) => {
            if (!result.message.startsWith("Failed to add employee")) {
              setAddWF(false);
              resetForm();
              getWFData();
              setApiError("");
            }
          })
          .catch(() => { });
      } catch (e) {
        setApiError(e);
      }
      setViewBackdrop(false);
    },
  });

  useEffect(() => {
    if (!addWF && !editWF) {
      workForceAddFormik.values.iv_userId = "";
      workForceAddFormik.values.iv_name = "";
      workForceAddFormik.values.iv_phone = "";
      workForceAddFormik.values.iv_designation = "";
      workForceAddFormik.values.iv_password = "";
      workForceAddFormik.values.iv_cnic = "";
      workForceAddFormik.values.iv_employeeCode = "";
      workForceAddFormik.values.iv_userId = "";
      editWorkForceFormik.values.iv_name = "";
      editWorkForceFormik.values.iv_phone = "";
      editWorkForceFormik.values.iv_designation = "";
      editWorkForceFormik.values.iv_password = "";
      editWorkForceFormik.values.iv_cnic = "";
      editWorkForceFormik.values.iv_userId = "";
    }
  }, [addWF, editWF]);

  const getCoordinates = async (refNo) => {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    await fetch(cpBaseUrl + "?refno=" + refNo, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.tblStatus[0].status) {
          setLatitudeOfRefNo(result.Table[0].GPSLATI);
          setLogitudeOfRefNo(result.Table[0].GPSLONG);
        }
      });
  };

  useEffect(() => {
    const fetchTransformerInfo = async (msnNumber) => {
      setViewBackdrop(true);
      try {
        const requestOptions = {
          method: "GET",
          redirect: "follow",
        };

        const response = await fetch(
          `https://ibs-dashboard-data-api.pitc.com.pk/api/v1/common?apiName=eops_transformer_info&P_TRANSF_MTR_NO=${msnNumber}`,
          requestOptions,
        );
        const result = await response.json();

        if (result.rows && result.rows.length > 0) {
          const transformerData = result.rows[0];
          setFieldValue("iv_name", transformerData.TR_LOCATION || "");
          setFieldValue("iv_address", transformerData.FDRNAME || "");
          setFieldValue("iv_phone_no", transformerData.FEEDERCODE || "");
          setTransformerLat(transformerData.TRANS_LOC_LATITUDE || "");
          setTransformerLong(transformerData.TRANS_LOC_LONGITUDE || "");
          setTransformerSubDivCode(transformerData.SDIV_CODE || code || "");
          setTransformerRefNo(transformerData.TRANS_REF_NO || "");
          setComplaintsError("");
        } else {
          setComplaintsError("No transformer data found for this MSN.");
          setFieldValue("iv_name", "");
          setFieldValue("iv_address", "");
          setFieldValue("iv_phone_no", "");
        }
      } catch (error) {
        setComplaintsError("Error fetching transformer information.");
      }
      setViewBackdrop(false);
    };

    const callBillAPI = async () => {
      if (
        values.iv_con_id_ref_no.length === 10 &&
        selectedOption == "consumerId"
      ) {
        referenceApi(); // function to fetch current information on behalf of reference number
      } else if (
        values.iv_con_id_ref_no.length === 14 &&
        selectedOption == "referenceNo"
      ) {
        referenceApi(); // function to fetch current information on behalf of reference number
      } else if (
        values.iv_con_id_ref_no.length === 12 &&
        selectedOption == "apmsMsn"
      ) {
        fetchTransformerInfo(values.iv_con_id_ref_no); // function to fetch transformer info by MSN
      } else {
        setComplaintsError("");
        setPhase();
        setMeterNo();
        setMeterType();
        setTariff();
        setTypeId(1);
        values.iv_consumer_id = "";
        values.iv_name = "";
        values.iv_phone_no = "";
        values.iv_address = "";
        setReferenceNumber();
        return;
      }
    };

    callBillAPI();
  }, [values.iv_con_id_ref_no, selectedOption]);
  //#endregion

  const feederFormClose = () => {
    setShowFeederForm(false);
  };

  const apmsFormClose = () => {
    setShowApmsForm(false);
    setApmsLoading(false);
  };

  const openProfileEditPopup = () => {
    nameFormik.values.iv_full_name = name;
    phoneFormik.values.iv_user_phone_no = phoneNo;
    emailFormik.values.iv_user_email = email;
    profilePictureFormik.values.iv_profile_picture = profilePicture;
    setShowProfileEditPopup(true);
  };

  useEffect(() => {
    if (!showProfileEditPopup) {
      nameFormik.values.iv_full_name = "";
      phoneFormik.values.iv_user_phone_no = "";
      emailFormik.values.iv_user_email = "";
      profilePictureFormik.values.iv_profile_picture = "";
    }
  }, [showProfileEditPopup]);

  useEffect(() => {
    const handleOpenProfileEditFromDashboard = () => {
      openProfileEditPopup();
    };

    window.addEventListener(
      "open-profile-edit-popup",
      handleOpenProfileEditFromDashboard,
    );

    return () => {
      window.removeEventListener(
        "open-profile-edit-popup",
        handleOpenProfileEditFromDashboard,
      );
    };
  }, [name, phoneNo, email, profilePicture]);

  const referenceApi = async () => {
    setViewBackdrop(true);
    let apiResponse = await dBillAPI(token, values.iv_con_id_ref_no);
    if (apiResponse.status) {
      setMeterNo(apiResponse.metersInfo[0].mtrNo);
      setMeterType(apiResponse.basicInfo.meterType);
      setFeederNo(apiResponse.basicInfo.feederCode);

      setMeterType(apiResponse.basicInfo.meterType);
      setMeterPhase(apiResponse.basicInfo.phase);
      setPhase(apiResponse.basicInfo.phase);
      setTariff(apiResponse.basicInfo.tariffDescription);
      setArrear(apiResponse.basicInfo.arrear);
      setMeterStatus(apiResponse.basicInfo.meter1Status);

      setSliceRefNo(
        apiResponse.basicInfo.refNo.replace(/\s+/g, "").slice(2, 7),
      );

      setReferenceNumber(
        apiResponse.basicInfo.refNo.replace(/ /g, "").slice(0, 14),
      );
      setViewBackdrop(false);

      setBillMonth(apiResponse.basicInfo.billMonth.slice(0, 10));
      values.iv_name = apiResponse.basicInfo.consumerName;
      values.iv_phone_no =
        apiResponse.basicInfo.consumerContactNo.toString().length == 12 &&
          apiResponse.basicInfo.consumerContactNo.toString().startsWith("92")
          ? "0".concat(
            apiResponse.basicInfo.consumerContactNo.toString().slice(2, 12),
          )
          : apiResponse.basicInfo.consumerContactNo;
      values.iv_address =
        apiResponse.basicInfo.consumerAddress1 +
        " " +
        apiResponse.basicInfo.consumerAddress2;
      getCoordinates(
        apiResponse.basicInfo.refNo.replace(/ /g, "").slice(0, 14),
      );

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        code: [apiResponse.basicInfo.feederCode],
        disco_code: apiResponse.basicInfo.refNo.trim().slice(2, 5) + "000",

        // "disco_code":  apiResponse.basicInfo.refNo.slice(2,5) + '000'
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "lineComplaints/GetFeederStatus", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          const currentStatus =
            result?.[0]?.response?.data?.[0]?.current_status || "N/A";
          setFeederStatus(currentStatus);
          // if (currentStatus === 'OFF') {
          //   setShowComplaintErrorForm(true)
          // }
        })
        .catch(() => { });

      {
        (apiResponse.basicInfo.arrear < 0 ||
          feederStatus === "OFF" ||
          apiResponse.basicInfo.meter1Status == "P.DISC" ||
          apiResponse.basicInfo.meter1Status == "T.DISC") &&
          setShowComplaintErrorForm(true);
      }
    } else if (apiResponse.status == false) {
      setComplaintsError("No Data Found against this Reference No.");
    } else {
      setComplaintsError("Reference No. not found!");
    }
    setViewBackdrop(false);
  };

  const complaintErrorFormClose = () => {
    setShowComplaintErrorForm(false);
  };

  const handleAddField = (shift, setShiftFields) => {
    setShiftFields([
      ...shift,
      { name: "", designation: "", phoneNo: "", userId: "", isModified: false },
    ]);
  };

  function getCurrentDateFormatted(date) {
    const day = String(date.getDate()).padStart(2, "0");
    const options = { month: "short" };
    const month = date.toLocaleString("en-US", options);
    const year = String(date.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
  }

  const DownloadFeederListPdf = async (print) => {
    let discoLogo = "";
    let eopsPng = "";
    try {
      [discoLogo, eopsPng] = await Promise.all([
        loadDiscoLogo(companyCode),
        loadEopsPng(),
      ]);
    } catch {
      discoLogo = "";
      eopsPng = "";
    }
    return new Promise((resolve, reject) => {
      const title = officeName(officeCode, subDivisions);
      let dateToPrint = getCurrentDateFormatted(new Date());
      const pdf = new jsPDF("landscape", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const logoWidth =
        companyCode === "12" ||
          companyCode === "13" ||
          companyCode === "11" ||
          companyCode === "16" ||
          companyCode === "27" ||
          companyCode === "48" ||
          companyCode === "59"
          ? 25
          : 30;
      const logoHeight =
        companyCode === "12" ||
          companyCode === "13" ||
          companyCode === "11" ||
          companyCode === "16" ||
          companyCode === "27" ||
          companyCode === "48" ||
          companyCode === "59"
          ? 20
          : 10;
      if (discoLogo) {
        pdf.addImage(discoLogo, "PNG", 15, 5, logoWidth, logoHeight);
      }

      const eOpsLogoWidth = 20;
      const eOpsLogoHeight = 8;
      const eOpsLogoXPosition =
        companyCode === "12" ||
          companyCode === "13" ||
          companyCode === "11" ||
          companyCode === "16" ||
          companyCode === "27" ||
          companyCode === "48" ||
          companyCode === "59"
          ? 43
          : 17;
      if (eopsPng) pdf.addImage(
        eopsPng,
        "PNG",
        eOpsLogoXPosition,
        companyCode === "12" ||
          companyCode === "13" ||
          companyCode === "11" ||
          companyCode === "16" ||
          companyCode === "27" ||
          companyCode === "48" ||
          companyCode === "59"
          ? 12
          : 17,
        eOpsLogoWidth,
        eOpsLogoHeight,
      );

      pdf.setFontSize(12);
      pdf.text(getCompanies(companyCode), pageWidth / 2, 12, {
        align: "center",
      });
      pdf.text("Feeder List", pageWidth / 2, 18, { align: "center" });
      pdf.setFontSize(10);
      pdf.text(
        `Feeder List for ${title} of ${dateToPrint} `,
        pageWidth / 2,
        25,
        { align: "center" },
      );

      // Add the user details
      pdf.setFontSize(10);
      pdf.text(convertDatewithTime(new Date()), pageWidth - 65, 12);
      pdf.text("Name: " + name, pageWidth - 65, 17);
      pdf.text("Designation: " + roleName, pageWidth - 65, 22);

      const headers = [
        { content: "Feeder", styles: { halign: "center" } },
        { content: "Feeder Code", styles: { halign: "center" } },
        { content: "Current (Amps)", styles: { halign: "center" } },
        { content: "Voltage (kV)", styles: { halign: "center" } },
        { content: "P.F (%)", styles: { halign: "center" } },
        { content: "Load (MW)", styles: { halign: "center" } },
        { content: "Status", styles: { halign: "center" } },
        { content: "Last Reporting Time", styles: { halign: "center" } },
      ];

      let bodyData = [];
      let dataAvailable = false;

      Object.keys(groupedFeeders).forEach((gridName) => {
        bodyData.push([
          {
            content: gridName.replace(/132 KV\s*/, "132 KV - "),
            colSpan: 8,
            styles: {
              halign: "start",
              fontSize: 10,
              fontStyle: "bold",
              fillColor: [240, 248, 255],
            },
          },
        ]);

        groupedFeeders[gridName].forEach((feeder) => {
          dataAvailable = true;
          const currentStatus = feeder.current > 3 ? "ON" : "OFF";
          bodyData.push([
            { content: feeder.feeder || "-", styles: { halign: "center" } },
            {
              content: feeder.feeder_code || "-",
              styles: { halign: "center" },
            },
            {
              content: feeder.current > 3 ? Math.abs(feeder.current) : "-",
              styles: { halign: "center" },
            },
            { content: Math.abs(feeder.voltage), styles: { halign: "center" } },
            {
              content:
                currentStatus === "ON" ? Math.abs(feeder.power_factor) : "-",
              styles: { halign: "center" },
            },
            {
              content:
                currentStatus === "ON" ? Math.abs(feeder.active_power_kW) : "-",
              styles: { halign: "center" },
            },
            {
              content: currentStatus,
              styles: {
                halign: "center",
                fontStyle: currentStatus === "ON" ? "bold" : "normal",
              },
            },
            {
              content: feeder.last_reporting_time || "-",
              styles: { halign: "center" },
            },
          ]);
        });
      });

      if (!dataAvailable) {
        bodyData.push([
          {
            content: "No Data Found",
            colSpan: 8,
            styles: {
              halign: "center",
              fontSize: 12,
              fontStyle: "bold",
              fillColor: [255, 255, 255],
              textColor: [255, 0, 0],
            },
          },
        ]);
      }

      pdf.autoTable({
        startY: 28,
        head: [headers],
        body: bodyData,
        styles: { cellPadding: 3, fontSize: 8, halign: "center" },
        tableWidth: "wrap",
        theme: "striped",
        columnStyles: {
          0: { cellWidth: 40 },
          1: { cellWidth: 40 },
          2: { cellWidth: 30 },
          3: { cellWidth: 30 },
          4: { cellWidth: 30 },
          5: { cellWidth: 30 },
          6: { cellWidth: 30 },
          7: { cellWidth: 40 },
        },
      });

      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        const pageNumberText = `Page ${i} of ${totalPages}`;
        pdf.setFontSize(10);
        pdf.text(pageNumberText, pageWidth - 45, pageHeight - 10);
      }

      if (print) {
        pdf.save("Feeder-List.pdf");
        resolve(pdf);
      } else {
        resolve(pdf);
      }
    });
  };

  const exportFeederListToExcel = () => {
    const dateToPrint = new Date().toISOString().split("T")[0]; // Get formatted date

    // Prepare data array
    const data = [];
    data.push(["Feeder Information"]); // Add a heading
    data.push([]); // Add an empty row for spacing

    Object.keys(groupedFeeders).forEach((gridName) => {
      data.push([`${gridName.replace(/132 KV\s*/, "132 KV - ")}`]); // Add grid name as a header
      data.push([
        "Feeder",
        "Feeder Code",
        "Current (Amps)",
        "Voltage (kV)",
        "P.F (%)",
        "Load (MW)",
        "Status",
        "Last Reporting Time",
      ]); // Add column headers

      groupedFeeders[gridName].forEach((feeder) => {
        const currentStatus = feeder.current > 3 ? "ON" : "OFF";
        data.push([
          feeder.feeder,
          feeder.feeder_code,
          feeder.current > 3 ? Math.abs(feeder.current) : "-",
          Math.abs(feeder.voltage),
          currentStatus === "ON" ? Math.abs(feeder.power_factor) : "-",
          currentStatus === "ON" ? Math.abs(feeder.active_power_kW) : "-",
          currentStatus,
          feeder.last_reporting_time,
        ]);
      });
      data.push([]); // Add an empty row for spacing
    });

    // Convert data array to worksheet
    const ws = XLSX.utils.aoa_to_sheet(data);

    // Create a new workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Feeder Data");

    // Write the workbook and save it as a file
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const filename = `${dateToPrint} - Feeder-List.xlsx`;
    saveAs(new Blob([wbout]), filename);
  };

  const printFeederListPDF = async () => {
    let pdf = await DownloadFeederListPdf(false);
    const pdfUrl = pdf.output("bloburl");

    // Create an iframe
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.top = "0";
    iframe.style.left = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    // Create a cancel button
    const cancelButton = document.createElement("button");
    cancelButton.textContent = "Cancel";
    cancelButton.style.position = "fixed";
    cancelButton.style.top = "20px";
    cancelButton.style.right = "20px";
    cancelButton.style.padding = "10px 20px";
    cancelButton.style.backgroundColor = "#ff4d4d";
    cancelButton.style.color = "white";
    cancelButton.style.border = "none";
    cancelButton.style.borderRadius = "5px";
    cancelButton.style.cursor = "pointer";
    document.body.appendChild(cancelButton);

    // Print the PDF when the iframe loads
    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    };

    // Remove iframe and cancel button when cancel button is clicked
    cancelButton.addEventListener("click", () => {
      if (iframe.parentNode) {
        document.body.removeChild(iframe);
      }
      if (cancelButton.parentNode) {
        document.body.removeChild(cancelButton);
      }
    });
  };

  const DownloadAPMSPdf = async (print) => {
    let discoLogo = "";
    let eopsPng = "";
    try {
      [discoLogo, eopsPng] = await Promise.all([
        loadDiscoLogo(companyCode),
        loadEopsPng(),
      ]);
    } catch {
      discoLogo = "";
      eopsPng = "";
    }
    return new Promise((resolve, reject) => {
      const title = officeName(officeCode, subDivisions);
      let dateToPrint = getCurrentDateFormatted(new Date());

      const pdf = new jsPDF("landscape", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const logoWidth =
        companyCode === "12" ||
          companyCode === "13" ||
          companyCode === "11" ||
          companyCode === "16" ||
          companyCode === "27" ||
          companyCode === "48" ||
          companyCode === "59"
          ? 25
          : 30;
      const logoHeight =
        companyCode === "12" ||
          companyCode === "13" ||
          companyCode === "11" ||
          companyCode === "16" ||
          companyCode === "27" ||
          companyCode === "48" ||
          companyCode === "59"
          ? 20
          : 10;
      if (discoLogo) {
        pdf.addImage(discoLogo, "PNG", 15, 5, logoWidth, logoHeight);
      }

      const eOpsLogoWidth = 20;
      const eOpsLogoHeight = 8;
      const eOpsLogoXPosition =
        companyCode === "12" ||
          companyCode === "13" ||
          companyCode === "11" ||
          companyCode === "16" ||
          companyCode === "27" ||
          companyCode === "48" ||
          companyCode === "59"
          ? 43
          : 17;
      if (eopsPng) pdf.addImage(
        eopsPng,
        "PNG",
        eOpsLogoXPosition,
        companyCode === "12" ||
          companyCode === "13" ||
          companyCode === "11" ||
          companyCode === "16" ||
          companyCode === "27" ||
          companyCode === "48" ||
          companyCode === "59"
          ? 12
          : 17,
        eOpsLogoWidth,
        eOpsLogoHeight,
      );

      pdf.setFontSize(12);
      pdf.text(getCompanies(companyCode), pageWidth / 2, 12, {
        align: "center",
      });
      pdf.text("APMS Information", pageWidth / 2, 18, { align: "center" });
      pdf.setFontSize(10);
      pdf.text(`APMS List for ${title} of ${dateToPrint} `, pageWidth / 2, 25, {
        align: "center",
      });

      // Add the user details
      pdf.setFontSize(10);
      pdf.text(convertDatewithTime(new Date()), pageWidth - 65, 12);
      pdf.text("Name: " + name, pageWidth - 65, 17);
      pdf.text("Designation: " + roleName, pageWidth - 65, 22);

      // Table headers
      const headers = [
        { content: "Sr #", styles: { halign: "center" } },
        { content: "Capacity (kVA)", styles: { halign: "center" } },
        { content: "Location", styles: { halign: "center" } },
        { content: "MSN", styles: { halign: "center" } },
        { content: "Current (Amps)", styles: { halign: "center" } },
        { content: "Voltage (kV)", styles: { halign: "center" } },
        { content: "Status", styles: { halign: "center" } },
        { content: "Last Communication Time", styles: { halign: "center" } },
      ];

      let bodyData = [];
      let dataAvailable = false;
      let srNo = 0;

      // Loop through `groupedAPMS` object
      Object.keys(groupedAPMS).forEach((gridName) => {
        const feeders = groupedAPMS[gridName]
          ? Object.values(groupedAPMS[gridName])
          : [];
        feeders.forEach((feeder) => {
          dataAvailable = true;
          srNo += 1;
          const {
            apms_capacity = "N/A",
            name = "N/A",
            msn = "N/A",
            current = "N/A",
            voltage = "N/A",
            status = "N/A",
            last_communication_time = "N/A",
          } = feeder;

          const statusColor = status === "ON" ? "green" : "red";

          bodyData.push([
            { content: String(srNo), styles: { halign: "center" } },
            { content: `${apms_capacity} kVA`, styles: { halign: "center" } },
            { content: name, styles: { halign: "center" } },
            { content: msn, styles: { halign: "center" } },
            { content: current, styles: { halign: "center" } },
            { content: voltage, styles: { halign: "center" } },
            {
              content: status,
              styles: { halign: "center", textColor: statusColor },
            },
            { content: last_communication_time, styles: { halign: "center" } },
          ]);
        });
      });

      // If no data, add a row indicating this
      if (!dataAvailable) {
        bodyData.push([
          {
            content: "No Data Found",
            colSpan: 8,
            styles: {
              halign: "center",
              fontSize: 12,
              fontStyle: "bold",
              fillColor: [255, 255, 255],
              textColor: [255, 0, 0],
            },
          },
        ]);
      }

      // Generate table with custom column width for Location and MSN
      pdf.autoTable({
        startY: 28,
        head: [headers],
        body: bodyData,
        styles: { cellPadding: 3, fontSize: 8, halign: "center" },
        tableWidth: "wrap",
        theme: "striped",
        columnStyles: {
          0: { cellWidth: 14 },
          1: { cellWidth: 28 },
          2: { cellWidth: 72 },
          3: { cellWidth: 28 },
          4: { cellWidth: 28 },
          5: { cellWidth: 26 },
          6: { cellWidth: 22 },
          7: { cellWidth: 34 },
        },
      });

      // Add footer for page numbers
      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        const pageNumberText = `Page ${i} of ${totalPages}`;
        pdf.setFontSize(10);
        pdf.text(pageNumberText, pageWidth - 45, pageHeight - 10);
      }

      // Save the PDF
      if (print) {
        pdf.save("APMS-List.pdf");
        resolve(pdf);
      } else {
        resolve(pdf);
      }
    });
  };

  const exportAPMSDataToExcel = () => {
    // Get the current date for the filename
    const dateToPrint = new Date().toISOString().split("T")[0];

    // Prepare data array for Excel
    const data = [];
    data.push(["APMS Feeder Information"]); // Add a heading
    data.push([]); // Add an empty row for spacing

    // Iterate through groupedAPMS object
    let excelSr = 0;
    Object.keys(groupedAPMS).forEach((gridName) => {
      // Add grid name as a section header
      data.push([
        "Sr #",
        "Capacity (kVA)",
        "Location",
        "Msn",
        "Current (Amps)",
        "Voltage (kV)",
        "Status",
        "Last Communication Time",
      ]); // Add column headers

      groupedAPMS[gridName].forEach((feeder) => {
        const {
          apms_capacity = "N/A",
          name = "N/A",
          msn = "N/A",
          current = "N/A",
          voltage = "N/A",
          status = "N/A",
          last_communication_time = "N/A",
        } = feeder;

        excelSr += 1;
        data.push([
          excelSr,
          `${apms_capacity} kVA`,
          name,
          msn,
          current,
          voltage,
          status,
          last_communication_time,
        ]);
      });

      data.push([]); // Add an empty row for spacing
    });

    // Convert data array to worksheet
    const ws = XLSX.utils.aoa_to_sheet(data);

    // Create a new workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "APMS Data");

    // Write the workbook and save it as a file
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const filename = `${dateToPrint} - APMS-List.xlsx`;
    saveAs(new Blob([wbout]), filename);
  };
  const printAPMSPDF = async () => {
    let pdf = await DownloadAPMSPdf(false);
    const pdfUrl = pdf.output("bloburl");

    // Create an iframe
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.top = "0";
    iframe.style.left = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    // Create a cancel button
    const cancelButton = document.createElement("button");
    cancelButton.textContent = "Cancel";
    cancelButton.style.position = "fixed";
    cancelButton.style.top = "20px";
    cancelButton.style.right = "20px";
    cancelButton.style.padding = "10px 20px";
    cancelButton.style.backgroundColor = "#ff4d4d";
    cancelButton.style.color = "white";
    cancelButton.style.border = "none";
    cancelButton.style.borderRadius = "5px";
    cancelButton.style.cursor = "pointer";
    document.body.appendChild(cancelButton);

    // Print the PDF when the iframe loads
    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    };

    // Remove iframe and cancel button when cancel button is clicked
    cancelButton.addEventListener("click", () => {
      if (iframe.parentNode) {
        document.body.removeChild(iframe);
      }
      if (cancelButton.parentNode) {
        document.body.removeChild(cancelButton);
      }
    });
  };

  const handleFieldChange = (
    index,
    field,
    value,
    shiftFields,
    setShiftFields,
  ) => {
    const updatedFields = [...shiftFields];
    updatedFields[index] = {
      ...updatedFields[index],
      [field]: value,
      isModified: true, // Mark this field as modified
    };
    setShiftFields(updatedFields);
    setIsFormModified(true); // Mark the form as modified
  };

  const handleFieldChangeWorkForce = (
    index,
    field,
    value,
    workforceData,
    setWorkForceData,
  ) => {
    const updatedFields = [...workforceData];
    updatedFields[index] = {
      ...updatedFields[index],
      [field]: value,
      isModified: true, // Mark this field as modified
    };

    setWorkForceData(updatedFields);
    setIsFormModifiedWorkForce(true); // Mark the form as modified
  };

  const handleDeleteField = (index, shift, setShiftFields) => {
    const newFields = shift.filter((_, i) => i !== index);
    setShiftFields(newFields);
  };

  const openNewTabAndRefocus = () => {
    setTimeout(() => {
      window.open("/power-complaint-display-complaint", "_blank");
      window.open("/power-complaint-map", "_top");
    }, 0);
  };

  const renderFields = (shiftFields, setShiftFields) =>
    shiftFields.map((field, index) => (
      <Grid
        container
        spacing={2}
        key={index}
        sx={{ marginBottom: "10px", alignItems: "center" }}
      >
        <Grid item lg={4}>
          <TextField
            type="text"
            onBlur={handleBlur}
            value={field.name}
            className="textInputField"
            onChange={(e) =>
              handleFieldChange(
                index,
                "name",
                e.target.value,
                shiftFields,
                setShiftFields,
              )
            }
            fullWidth
            sx={{ backgroundColor: "lightgray", fontSize: "5px" }}
          />
        </Grid>
        <Box className="from-Error">
          {errors.iv_lm_user_name && touched.iv_lm_user_name
            ? errors.iv_lm_user_name
            : null}
        </Box>
        <Grid item xs={3} sx={{ paddingRight: "20px" }}>
          <Select
            autoWidth={false}
            autoFocus
            value={
              field.designation ? field.designation : values.iv_designation
            }
            onChange={(e) =>
              handleFieldChange(
                index,
                "designation",
                e.target.value,
                shiftFields,
                setShiftFields,
              )
            }
            onBlur={handleBlur}
            style={{ color: "black" }}
            placeholder="Designation"
            className="connectionTypeDropDownList"
            name="iv_designation"
            id="iv_designation"
          >
            <MenuItem value="">Select Type</MenuItem>
            <MenuItem value="Ls">LS</MenuItem>
            <MenuItem value="Lm">LM</MenuItem>
            <MenuItem value="Alm">ALM</MenuItem>
          </Select>
          <Box className="from-Error">
            {errors.iv_designation && touched.iv_designation
              ? errors.iv_designation
              : null}
          </Box>
        </Grid>
        <Grid item lg={4}>
          <TextField
            value={field.phoneNo}
            type="text"
            // value={values.iv_name}
            onBlur={handleBlur}
            className="textInputField"
            onChange={(e) =>
              handleFieldChange(
                index,
                "phoneNo",
                e.target.value,
                shiftFields,
                setShiftFields,
              )
            }
            fullWidth
            sx={{ backgroundColor: "lightgray", fontSize: "5px" }}
            inputProps={{ maxLength: 11, autoComplete: "off" }}
          />
        </Grid>
        <Box className="from-Error">
          {errors.iv_lm_phone_no && touched.iv_lm_phone_no
            ? errors.iv_lm_phone_no
            : null}
        </Box>
        {shiftFields.length > 5 && (
          <Grid
            item
            lg={1}
            sx={{ display: "flex", justifyContent: "center" }}
            onClick={() => deleteLmData(field.userId)}
          >
            <IconButton
              onClick={() =>
                handleDeleteField(index, shiftFields, setShiftFields)
              }
              sx={{ backgroundColor: "lightgray", color: "red" }}
            >
              <DeleteIcon />
            </IconButton>
          </Grid>
        )}
      </Grid>
    ));

  const getCompanies = (code) => {
    switch (code) {
      case "10":
        return "Power Information Technology Company";
      case "11":
        return "Lahore Electric Supply Company";
      case "12":
        return "Gujranwala Electric Power Company";
      case "13":
        return "Faisalabad Electric Supply Company";
      case "14":
        return "Islamabad Electric Supply Company";
      case "15":
        return "Multan Electric Power Company";
      case "26":
        return "Peshawar Electric Supply Company";
      case "38":
        return "Sukkur Electric Power Company";
      case "37":
        return "Hyderabad Electric Supply Company";
      case "48":
        return "Quetta Electric Supply Company";
      case "59":
        return "Tribal Electric Supply Company";
    }
  };
  const DownloadLinemanPdf = async (print) => {
    let discoLogo = "";
    let eopsPng = "";
    try {
      [discoLogo, eopsPng] = await Promise.all([
        loadDiscoLogo(companyCode),
        loadEopsPng(),
      ]);
    } catch {
      discoLogo = "";
      eopsPng = "";
    }
    return new Promise((resolve, reject) => {
      let dateToPrint = getCurrentDateFormatted(new Date());

      // ✅ Shift Mapping
      const shiftMapping = {
        1: "M",
        2: "E",
        3: "N",
      };

      // Define header structure
      const headers = [
        [
          { content: "Name" },
          { content: "SubDiv Code" },
          { content: "Designation" },
          { content: "Employee Code" },
          { content: "Shift" },
          { content: "Phone No." },
          { content: "CNIC" },
          { content: "UserId" },
        ],
      ];

      // Define data rows based on workForceData
      const body = [];

      if (filteredWorkforce && filteredWorkforce.length > 0) {
        filteredWorkforce.forEach((employee) => {
          // ✅ Find Designation Name
          const desg = desginationList.find(
            (d) => d.employeeDesignationId === employee.designation,
          );
          const designationName = desg
            ? desg.employeeDesignationName
            : employee.designation;

          // ✅ Convert shift numbers → letters
          let shiftValue = employee.shift;
          if (shiftValue) {
            shiftValue = shiftValue
              .toString()
              .split(",")
              .map((s) => shiftMapping[s.trim()] || s)
              .join(",");
          }
          body.push([
            employee.name || "-",
            employee.subDivisionCode || "-",
            designationName || "-",
            employee.employeeCode || "-",
            shiftValue || "-",
            employee.phoneNo || "-",
            employee.cnic || "-",
            employee.userId || "-",
          ]);
        });
      } else {
        body.push([
          {
            content: "No Data Found",
            colSpan: 12,
            styles: {
              halign: "center",
              fontSize: 10,
              fontStyle: "bold",
              fillColor: [255, 255, 255],
              textColor: [255, 0, 0],
            },
          },
        ]);
      }

      // Initialize PDF
      const pdf = new jsPDF("landscape", "mm", "a4", { compressPdf: true });
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const logoWidth =
        companyCode === "12" ||
          companyCode === "13" ||
          companyCode === "11" ||
          companyCode === "26" ||
          companyCode === "38" ||
          companyCode === "48" ||
          companyCode === "59"
          ? 25
          : 30;
      const logoHeight =
        companyCode === "12" ||
          companyCode === "13" ||
          companyCode === "11" ||
          companyCode === "26" ||
          companyCode === "38" ||
          companyCode === "48" ||
          companyCode === "59"
          ? 20
          : 10;
      if (discoLogo) {
        pdf.addImage(discoLogo, "PNG", 15, 5, logoWidth, logoHeight);
      }

      const eOpsLogoWidth = 20;
      const eOpsLogoHeight = 8;
      const eOpsLogoXPosition =
        companyCode === "12" ||
          companyCode === "13" ||
          companyCode === "11" ||
          companyCode === "26" ||
          companyCode === "38" ||
          companyCode === "48" ||
          companyCode === "59"
          ? 43
          : 17;
      if (eopsPng) pdf.addImage(
        eopsPng,
        "PNG",
        eOpsLogoXPosition,
        companyCode === "12" ||
          companyCode === "13" ||
          companyCode === "11" ||
          companyCode === "26" ||
          companyCode === "38" ||
          companyCode === "48" ||
          companyCode === "59"
          ? 12
          : 17,
        eOpsLogoWidth,
        eOpsLogoHeight,
      );

      pdf.setFontSize(10);
      pdf.text(convertDatewithTime(new Date()), pageWidth - 50, 12);
      pdf.text("Name: " + name, pageWidth - 50, 17);
      pdf.text("Designation: " + roleName, pageWidth - 50, 22);

      pdf.setFontSize(12);
      pdf.text(getCompanies(companyCode), pageWidth / 2, 12, {
        align: "center",
      });
      pdf.text(`Work Force Management List`, pageWidth / 2, 18, {
        align: "center",
      });
      pdf.setFontSize(10);
      pdf.text(
        `Work Force List for ${officeNamee} of ${dateToPrint}`,
        pageWidth / 2,
        25,
        { align: "center" },
      );

      // ✅ Generate table in PDF
      pdf.autoTable({
        startY: 28,
        head: headers,
        body: body,
        styles: {
          cellPadding: 1,
          fontSize: 8,
          halign: "center",
          lineWidth: 0.25,
          lineColor: "white",
        },
        margin: { top: 2 },
        theme: "striped",
        headStyles: { valign: "middle" },
        bodyStyles: {
          halign: "center",
        },
        columnStyles: {
          0: { halign: "left" },
        },
      });

      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        const pageNumberText = `Page ${i} of ${totalPages}`;
        pdf.setFontSize(10);
        pdf.text(pageNumberText, pageWidth - 45, pageHeight - 10);
      }

      if (print) {
        pdf.save(`${officeNamee}-${dateToPrint}-Work-Force-List.pdf`);
      } else {
        resolve(pdf);
      }
    });
  };

  useEffect(() => {
    const getDesgination = async () => {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const raw = "";
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      fetch(
        cfpBaseUrl + "workForce/getListOfSubDivisionDesignations",
        requestOptions,
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.message == "Data Found.") {
            setDesginationList(result.data);
          }
        })
        .catch(() => { });
    };
    getDesgination();
  }, []);

  const exportLinemanToExcel = (fileName = "Workforce_Data") => {
    let dateToPrint = getCurrentDateFormatted(new Date());

    const shiftMapping = {
      1: "M",
      2: "E",
      3: "N",
    };

    const filteredData = filteredWorkforce.map(
      ({ password, designation, shift, ...rest }) => {
        const desg = desginationList.find(
          (d) => d.employeeDesignationId === designation,
        );

        // ✅ Convert shift numbers → letters
        let shiftValue = shift;
        if (shift) {
          shiftValue = shift
            .toString()
            .split(",")
            .map((s) => shiftMapping[s.trim()] || s)
            .join(",");
        }

        return {
          ...rest,
          designation: desg ? desg.employeeDesignationName : designation,
          shift: shiftValue, // ✅ replace with converted value
        };
      },
    );

    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    const fullFileName = `${officeNamee}-${dateToPrint}-Work-Force-List.xlsx`;
    XLSX.writeFile(workbook, fullFileName);
  };

  const printLinemanPDF = async () => {
    let pdf = await DownloadLinemanPdf(false);
    const pdfUrl = pdf.output("bloburl");

    // Create an iframe
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.top = "0";
    iframe.style.left = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    // Create a cancel button
    const cancelButton = document.createElement("button");
    cancelButton.textContent = "Cancel";
    cancelButton.style.position = "fixed";
    cancelButton.style.top = "20px";
    cancelButton.style.right = "20px";
    cancelButton.style.padding = "10px 20px";
    cancelButton.style.backgroundColor = "#ff4d4d";
    cancelButton.style.color = "white";
    cancelButton.style.border = "none";
    cancelButton.style.borderRadius = "5px";
    cancelButton.style.cursor = "pointer";
    document.body.appendChild(cancelButton);

    // Print the PDF when the iframe loads
    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    };

    // Remove iframe and cancel button when cancel button is clicked
    cancelButton.addEventListener("click", () => {
      if (iframe.parentNode) {
        document.body.removeChild(iframe);
      }
      if (cancelButton.parentNode) {
        document.body.removeChild(cancelButton);
      }
    });
  };

  // const excelWorkForce = () => {
  //   const worksheet = XLSX.utils.json_to_sheet(workForceData);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  //   // Write the workbook and download it
  //   XLSX.writeFile(workbook, "Workforce Data.xlsx");

  // }

  // const printWorkForce = () => {
  //   const worksheet = XLSX.utils.json_to_sheet(workForceData);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  //   XLSX.writeFile(workbook, "Workforce Data.xlsx");
  // }

  const handleEditWF = (WFData) => {
    if (WFData) {
      setWorkForceToEdit(WFData);
      editWorkForceFormik.values.iv_name = WFData.name;
      editWorkForceFormik.values.iv_designation = WFData.designation;

      const shiftIdsArray = WFData.shift
        ? WFData.shift.split(",").map(Number)
        : [];
      setEditSelectedItems(shiftIdsArray);

      const shiftIdsArrays = WFData.shift
        ? WFData.shift.split(",").map(Number)
        : [];

      const formattedShiftIds = shiftIdsArrays.map((id) => ({ shiftId: id }));
      setEditSelectedItems1(formattedShiftIds);

      editWorkForceFormik.values.iv_shift = WFData.shift;
      editWorkForceFormik.values.iv_phone = WFData.phoneNo;
      editWorkForceFormik.values.iv_cnic = WFData.cnic;
      editWorkForceFormik.values.iv_employeeCode = WFData.employeeCode;
      editWorkForceFormik.values.iv_userId = WFData.userId;
      editWorkForceFormik.values.iv_password = WFData.password;
      editWorkForceFormik.values.iv_confirm_password = WFData.password;
      setEditWF(true);
    }
  };
  const passwordChangeWorkForceFormik = useFormik({
    initialValues: workForceInitialValues,
    validationSchema: Yup.object().shape({
      iv_userId: Yup.string().required("UserId is required!"),
      iv_remarks: Yup.string().required("Remarks is required!"),
      iv_password: Yup.string()
        .matches(
          passwordRegex,
          "Password must contain at least one uppercase letter, one lowercase letter, one number, one special character, and must be at least 8 characters long",
        )
        .required("Password is required"),
      iv_confirm_password: Yup.string()
        .oneOf(
          [Yup.ref("iv_password"), null],
          "Password and Confirm password must match",
        )
        .required("Confirm password is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        userId: values.iv_userId,
        remarks: values.iv_remarks,
        password: values.iv_password,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(
        cfpBaseUrl + "customerFaciliationPortal/changePasswordofUser",
        requestOptions,
      )
        .then(async (response) => {
          if (response.status == 200) {
            setPasswordWF(false);
            resetForm();
            getWFData();
            setApiError("");
            return response.json();
          } else {
            let res = await response.json();
            setApiError(res.message);
          }
        })
        .catch(() => { });
    },
  });
  const handleDeleteWF = (WFData) => {
    if (WFData) {
      setWorkForceToDelete(WFData);
      setDeleteLMWarning(true);
    }
  };

  const renderFieldsWorkforce = (workforceData, setWorkforceData) => {
    const canUpdateWorkforce = CheckPermissions(
      permissions,
      permissionsVariables.accessManagement,
      "Workforce Management",
      "Update",
    );

    return (
      <div className="wfm-table-scroll">
        <table className="wfm-staff-table">
          <thead>
            <tr>
              <th className="wfm-col-index">#</th>
              <th>Name</th>
              <th>Designation</th>
              <th>Phone</th>
              {canUpdateWorkforce ? (
                <th className="wfm-col-actions-h">Actions</th>
              ) : null}
            </tr>
          </thead>
          <tbody>
            {workforceData.map((field, index) => (
              <tr
                key={index}
                className={field.isModified ? "wfm-row--editing" : undefined}
              >
                <td className="wfm-col-index">{index + 1}</td>
                <td>
                  <input
                    type="text"
                    className="wfm-input textInputField"
                    onBlur={workForceAddFormik.handleBlur}
                    disabled={!field.isModified}
                    name={`workForceData[${index}].name`}
                    onChange={(e) => {
                      handleFieldChangeWorkForce(
                        index,
                        "name",
                        e.target.value,
                        workforceData,
                        setWorkforceData,
                      );
                      workForceAddFormik.setFieldValue(
                        `workForceData[${index}].name`,
                        e.target.value,
                      );
                    }}
                    value={field.name}
                  />
                  <span className="wfm-field-error from-Error">
                    {workForceAddFormik.errors.workForceData?.[index]?.name &&
                      workForceAddFormik.touched.workForceData?.[index]?.name
                      ? workForceAddFormik.errors.workForceData[index].name
                      : null}
                  </span>
                </td>
                <td>
                  <select
                    value={field.designation || ""}
                    disabled={!field.isModified}
                    onChange={(e) => {
                      handleFieldChangeWorkForce(
                        index,
                        "designation",
                        e.target.value,
                        workforceData,
                        setWorkforceData,
                      );
                      workForceAddFormik.setFieldValue(
                        `workForceData[${index}].designation`,
                        e.target.value,
                      );
                    }}
                    onBlur={workForceAddFormik.handleBlur}
                    className="wfm-select connectionTypeDropDownList"
                    name={`workForceData[${index}].designation`}
                  >
                    <option value="">Select Type</option>
                    {fieldStaffDesignations.map((item, idx) => (
                      <option value={item.employeeDesignationId} key={idx}>
                        {item.employeeDesignationName}
                      </option>
                    ))}
                  </select>
                  <span className="wfm-field-error from-Error">
                    {workForceAddFormik.errors.workForceData?.[index]
                      ?.designation &&
                      workForceAddFormik.touched.workForceData?.[index]
                        ?.designation
                      ? workForceAddFormik.errors.workForceData[index]
                        .designation
                      : null}
                  </span>
                </td>
                <td>
                  <input
                    value={field.phoneNo}
                    type="text"
                    onBlur={workForceAddFormik.handleBlur}
                    disabled={!field.isModified}
                    className="wfm-input textInputField"
                    onChange={(e) => {
                      handleFieldChangeWorkForce(
                        index,
                        "phoneNo",
                        e.target.value,
                        workforceData,
                        setWorkforceData,
                      );
                      workForceAddFormik.setFieldValue(
                        `workForceData[${index}].phoneNo`,
                        e.target.value,
                      );
                    }}
                    name={`workForceData[${index}].phoneNo`}
                  />
                  <span className="wfm-field-error from-Error">
                    {workForceAddFormik.errors.workForceData?.[index]?.phoneNo &&
                      workForceAddFormik.touched.workForceData?.[index]?.phoneNo
                      ? workForceAddFormik.errors.workForceData[index].phoneNo
                      : null}
                  </span>
                </td>
                {canUpdateWorkforce ? (
                  <td className="wfm-col-actions">
                    {!field.isModified ? (
                      <div className="wfm-actions">
                        <button
                          type="button"
                          className="wfm-action-btn"
                          onClick={() => handleEditWF(field)}
                          title="Change User Information"
                        >
                          <img
                            src={pencilIcon}
                            alt="edit"
                            width={17.5}
                            height={17.5}
                          />
                        </button>
                        <button
                          type="button"
                          className="wfm-action-btn"
                          onClick={() => handleEditPasswordWF(field)}
                          title="Change Password"
                        >
                          <img
                            src={passwordKey}
                            alt="password"
                            width={17.5}
                            height={17.5}
                          />
                        </button>
                      </div>
                    ) : null}
                  </td>
                ) : null}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  const filteredWorkforce = workForceData.filter(
    (item) =>
      item.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.phoneNo?.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const callLogoutAPI = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        keepalive: true,
      };

      await fetch(
        cfpBaseUrl + "customerFaciliationPortal/logOut",
        requestOptions,
      )
        .then((response) => response.json())
        .then(() => { })
        .catch(() => { });
    } catch (e) { }
  };

  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((prev) => !prev);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const [error1, setError1] = useState("");
  // const [success, setSuccess] = useState("");

  // Formik Hook
  const amendBill = useFormik({
    initialValues: {
      iv_application_id: "",
    },
    validationSchema: Yup.object({
      iv_application_id: Yup.string()
        .matches(
          /^[A-Za-z]{2}-\d{15}$/,
          "Invalid Application ID format (e.g. DE-131312509030009)",
        )
        .required("Application ID is required"),
    }),
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      setViewBackdrop(true);
      setError1("");
      setSuccess("");

      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: values.iv_application_id,
        });

        const response = await fetch(
          cfpBaseUrl + "installments/amendDuplicateBill",
          {
            method: "POST",
            headers: myHeaders,
            body: raw,
          },
        );

        const result = await response.json();

        if (result.status === "200" || result.status === 200) {
          setSuccess(result.message || "Bill amended successfully!");

          // Auto open bill
          const billUrl = `https://bill.pitc.com.pk/pitc/route_access/${result.refNo}`;
          window.open(billUrl, "_blank");
        } else {
          setError1(result.message || "Failed to process request.");
        }
      } catch (err) {
        setError1("Network error. Please try again.");
      } finally {
        setSubmitting(false);
        setViewBackdrop(false);
      }
    },
  });

  const errorClosesPopup = () => {
    setError1("");
    setSuccess("");
  };

  return (
    <>
      {/* Main Top bar and Side bar */}
      <Box className="side-bar">
        <AppBar
          className="app-bar"
          open={!displayComplaintPage ? open : !open}
          isMobile={isMobile}
          sx={{
            paddingLeft: open ? "0%" : isMobile ? 0 : "1%",
            paddingRight: isMobile ? "8px" : "12px",
            width: isMobile ? "100%" : undefined,
            maxWidth: isMobile ? "100vw" : "100%",
            overflow: "visible",
            boxSizing: "border-box",
          }}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              mr: isMobile ? 0.5 : 2,
              ml: isMobile ? 0.25 : undefined,
              flexShrink: 0,
              ...(open && !isMobile && { display: "none" }),
              ...(isMobile && { display: open ? "none" : "inline-flex" }),
            }}
            className="icon-button"
          >
            <MenuIcon className="menu-icon" />
          </IconButton>
          <div
            className={`navbar${isMobile ? " navbar--mobile" : ""}`}
            style={{
              padding: !powerComplaintsMenu
                ? isMobile
                  ? "8px 0 8px 0"
                  : "8px 0 8px 10px"
                : "0px 0 0px 10px",
            }}
          >
            <div className="navbar__brand-row">
              <div className="navbar__brand-inner">
                <a
                  href="/landingpage"
                  className="navbar__logo-link">
                  <img
                    src={brandLogo || pitcLogo}
                    alt="Logo"
                    className="navbar__logo"
                    height={isMobile ? 34 : 40}
                  />
                </a>
                {
                  <div className="navbar__title-wrap">
                    <h1 className="navbar__company-title">
                      {
                        // <span style={{ fontFamily: "Times", textAlign: 'end', color: '#505050', }}>
                        //   {/* {
                        //     roleTypeId == 2 &&
                        //     <>
                        //       {officeNameForDashboard}
                        //     </>
                        //   }
                        //   {
                        //     (roleTypeId == 1 && cscID) &&
                        //     <>
                        //       {cscID && cscID != "Power Information Technology Company" && cscID}
                        //     </>
                        //   }
                        //   {
                        //     (roleTypeId == 1 && !cscID) &&
                        //     <>
                        //       {officeNameForDashboard}
                        //     </>
                        //   } */}

                        //   {(hierarchy == 1 || hierarchy == 2) ? getCompanies(code.slice(0, 2)) : officeName(officeCode, subDivisions) }

                        // </span>
                        <span className="navbar__company-title-text">
                          {roleTypeId == 1 && hierarchy == 1 && (
                            <>{getCompanies(code.slice(0, 2))}</>
                          )}
                          {(roleTypeId == 2 || roleTypeId == 1) &&
                            hierarchy == 2 && <>{officeNameForDashboard}</>}

                          {(roleTypeId == 2 || roleTypeId == 1) &&
                            hierarchy == 3 && <>{officeNameForDashboard}</>}
                          {roleTypeId == 2 && hierarchy == 52 && (
                            <>{officeNameForDashboard}</>
                          )}
                          {roleTypeId == 2 && hierarchy == 4 && (
                            <>{officeNameForDashboard}</>
                          )}
                          {roleTypeId == 1 && hierarchy == 4 && (
                            <>{officeNameForDashboard}</>
                          )}
                          {/* {roleTypeId == 1 && !cscID && (
                            <>{officeNameForDashboard}</>
                          )} */}
                        </span>
                      }
                    </h1>
                  </div>
                }
                {!isMobile && !isButtonVisible &&
                  !powerComplaintsMenu &&
                  performanceValue != 0 && (
                    <div
                      className="navbar__header-extras"
                      style={{
                        marginLeft: "20px",
                        backgroundColor:
                          performanceValue > 0 ? "#e11b3c" : "#019760",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        borderRadius: "5px",
                        color: "white",
                        fontSize: "12px",
                        padding: "5px",
                      }}
                    >
                      <div>
                        OverAll <br />
                        Performance
                      </div>
                      <div
                        style={{
                          width: "20%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={
                            performanceValue > 0
                              ? trendingDownIcn
                              : trendingUpIcn
                          }
                          alt="trending"
                          style={{ height: "20%" }}
                        />
                      </div>
                      <p style={{ fontSize: "18px" }}>
                        {performanceValue ? Math.abs(performanceValue) : ""}%
                      </p>
                    </div>
                  )}
                {!isMobile && !powerComplaintsMenu &&
                  !isButtonVisible &&
                  totalActionablesNormal + totalActionablesOverdue > 0 && (
                    <div
                      className="navbar__header-extras navbar__header-extras--actionables"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "5px 10px",
                        borderRadius: "5px",
                        backgroundColor: "#E11B3C",
                        cursor: "pointer",
                        color: "white",
                        width: "auto",
                        minWidth: "150px",
                        position: "relative",
                      }}
                      onClick={() => navigate("/actionables-table")}
                    >
                      <div style={{ position: "relative" }}>
                        <img
                          src={bell}
                          alt="bell"
                          height={40}
                          style={{
                            animation: "blink 1s infinite",
                            transform: `rotate(${15}deg)`,
                          }}
                        />
                      </div>
                      <div
                        style={{
                          marginLeft: "5px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "20px",
                            fontWeight: "bold",
                            marginRight: "15px",
                          }}
                        >
                          {totalActionablesNormal + totalActionablesOverdue}
                        </span>
                        <p style={{ marginLeft: "5px", fontSize: "14px" }}>
                          Actions
                          <br />
                          Required
                        </p>
                      </div>
                    </div>
                  )}
              </div>
            </div>
            <div className="navbar__tools-row">
              {(() => {
                const showHeaderSearch =
                  !powerComplaintsMenu &&
                  !(roleTypeId === "2" && [1148, 1135, 1122].includes(roleId));
                return (
                  <div className="navbar-header-actions">
                    <div className="navbar-header-actions__add-slot">
                      <AddButton
                        permissions={permissions}
                        isButtonVisible={isButtonVisible}
                      />
                    </div>
                    {showHeaderSearch && (
                      <div className="navbar-header-actions__search-slot navbar__tools-search">
                        <IconButton
                          className="navbar-search-btn"
                          aria-label="Search"
                          onClick={handleOpenSearchBarPopup}
                        >
                          <SearchIcon />
                        </IconButton>
                      </div>
                    )}
                    <div className="navbar-header-actions__theme-slot">
                      {renderNavbarThemeToggle()}
                    </div>
                  </div>
                );
              })()}

              {!isMobile && <div className="navbar__tools-divider" aria-hidden="true" />}

              {/* User profile menu (all pages, including complaint management) */}
              {!isMobile && (
                <div className="navbar__user-menu" ref={userMenuAnchorRef}>
                  <div
                    className="navbar__user"
                    role="button"
                    tabIndex={0}
                    aria-haspopup="menu"
                    aria-expanded={menuOpen}
                    onClick={() => setMenuOpen((prev) => !prev)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        setMenuOpen((prev) => !prev);
                      }
                    }}
                  >
                    <div className="navbar__user-text">
                      <p className="navbar__user-name">{name}</p>
                      <p className="navbar__user-role">{roleName}</p>
                    </div>
                    <div className="navbar__user-media">
                      <img
                        src={
                          typeof profilePicture === "string"
                            ? profilePicture
                            : profilePicture
                              ? URL.createObjectURL(profilePicture)
                              : UserIconImage
                        }
                        alt="avatar"
                        className="navbar__user-avatar"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = UserIconImage;
                        }}
                      />
                      <KeyboardArrowDownIcon className="navbar__user-chevron" />
                    </div>
                  </div>

                  {menuOpen && (
                    <div className="items navbar__user-dropdown">
                      <div className="item">
                        <div className="menu" ref={menuRef}>
                          <div className="menu-item" onClick={openProfileEditPopup}>
                            <div style={{ width: "30px" }}>
                              <img src={Profile1} alt="Profile" height={25} />
                            </div>
                            <h4>Profile</h4>
                          </div>
                          <div
                            className="menu-item"
                            onClick={() => setShowChangePasswordPopup(true)}
                          >
                            <div style={{ width: "30px" }}>
                              <img src={Key1} alt="Key" height={25} />
                            </div>
                            <h4>Change Password</h4>
                          </div>
                          <div
                            className="menu-item"
                            onClick={() =>
                              window.open(
                                cfpBaseUrl + "E-Operations%20User%20Manual.pdf",
                                "_blank",
                              )
                            }
                          >
                            <div style={{ width: "30px" }}>
                              <img src={PDF1} alt="User Manual" height={25} />
                            </div>
                            <h4>User Manual</h4>
                          </div>

                          <div
                            className="menu-item"
                            onClick={() => {
                              navigate("/eops-updates");
                              setMenuOpen(false);
                            }}
                          >
                            <div
                              style={{
                                width: "30px",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <UpdateIcon sx={{ color: "#0b5cad", fontSize: 25 }} />
                            </div>
                            <h4>Changelog</h4>
                          </div>
                          <hr style={{ margin: "10px 0px" }} />
                          <div
                            className="menu-item"
                            onClick={() => {
                              setMenuOpen(false);
                              handleLogout();
                            }}
                          >
                            <div style={{ width: "30px" }}>
                              <img src={Logout1} alt="Logout" height={25} />
                            </div>
                            <h4>Logout</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </AppBar>
        <Drawer
          className="sidebar-drawer"
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
              height: "100%",
              maxHeight: "100dvh",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
              boxShadow: "none",
            },
            "& .sidebar-drawer-content": {
              display: "flex",
              flexDirection: "column",
              flex: "1 1 auto",
              height: "100%",
              minHeight: 0,
            },
            "& .sidebar-drawer-menu": {
              flex: "1 1 auto",
              minHeight: 0,
              overflowY: "auto",
              overflowX: "hidden",
              WebkitOverflowScrolling: "touch",
            },
          }}
          variant={isMobile ? "temporary" : "persistent"}
          anchor="left"
          open={!displayComplaintPage ? open : !open}
          onClose={handleDrawerClose}
          ModalProps={{
            keepMounted: true,
            sx: isMobile
              ? { backgroundColor: "rgba(0, 0, 0, 0.45)" }
              : undefined,
          }}
          PaperProps={
            isMobile
              ? {
                sx: {
                  height: "100dvh",
                  minHeight: "100dvh",
                  maxHeight: "100dvh",
                  top: 0,
                },
              }
              : undefined
          }
        >
          <div className="sidebar-drawer-content">
            <DrawerHeader className="header sidebar-drawer-header">
              <Typography className="menu-title">
                <div
                  id="eops-sidebar-logo"
                  className="eops-sidebar-logo-wrap"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    navigate("/landingpage", {
                      state: { playLogoIntro: true },
                    })
                  }
                >
                  <img
                    src={EOps}
                    alt="Logo"
                    className="eops-sidebar-logo eops-sidebar-logo--light"
                  />
                  <img
                    src={EOpsDark}
                    alt="Logo"
                    className="eops-sidebar-logo eops-sidebar-logo--dark"
                  />
                </div>
              </Typography>
              <div className="sidebar-drawer-header__actions">
                <IconButton onClick={handleDrawerClose} className="icon-button">
                  <ChevronLeftIcon className="menu-icon" />
                </IconButton>
              </div>
            </DrawerHeader>
            <div className="sidebar-drawer-menu">
              <SidebarNavMenu
                className="sidebar-nav-menu tacItemCircle"
                popupClassName="sidebar-submenu-popup tacItemCircle"
                selectedKeys={selectedMenuKeys}
                openKeys={openMenuKeys}
                onOpenChange={(keys) => setOpenMenuKeys(keys)}
                onClick={({ key }) => {
                  if (key === "Logout") {
                    if (isMobile) handleDrawerClose();
                    handleLogout();
                  }
                }}
                mode={isMobile ? "inline" : mode}
                theme="light"
                items={sidebarMenuItems || []}
                triggerSubMenuAction="click"
                inlineIndent={14}
              />
            </div>
            <div className="sidebar-drawer-footer">
              <img src={pitcLogo} alt="PITC" height={isMobile ? 40 : 46} />
              <span className="sidebar-drawer-footer__text">
                Powered by PITC @{new Date().getFullYear()}
              </span>
            </div>
          </div>
        </Drawer>
        <Main open={open} isMobile={isMobile}>
          <DrawerHeader />
        </Main>
      </Box>

      <p className="font-load">F</p>
      <p className="font-load-digital">F</p>

      {/* Feeders Management */}
      <Dialog
        open={showFeederForm}
        onClose={() => feederFormClose()}
        maxWidth="lg"
        fullWidth
        className="complaint-alert-popups feeder-info-dialog"
        PaperProps={{ className: "feeder-info-dialog__paper" }}
      >
        <Box className="feeder-info-dialog__header">
          <span className="feeder-info-dialog__title">Feeder Information</span>
          <Box className="feeder-info-dialog__actions">
            <button
              type="button"
              className="feeder-info-dialog__action-btn"
              onClick={DownloadFeederListPdf}
              aria-label="Download PDF"
            >
              <img src={pdf} alt="" style={{ ...internalIconStyles, height: "100%" }} />
            </button>
            <button
              type="button"
              className="feeder-info-dialog__action-btn"
              onClick={exportFeederListToExcel}
              aria-label="Export Excel"
            >
              <img src={excel} alt="" style={{ ...internalIconStyles, height: "100%" }} />
            </button>
            <button
              type="button"
              className="feeder-info-dialog__action-btn"
              onClick={printFeederListPDF}
              aria-label="Print"
            >
              <img src={print} alt="" style={{ ...internalIconStyles, height: "100%" }} />
            </button>
            <button
              type="button"
              className="feeder-info-dialog__close-btn"
              onClick={() => setShowFeederForm(false)}
              aria-label="Close"
            >
              <img src={closeIconWhite} alt="" width={22} height={22} />
            </button>
          </Box>
        </Box>
        <DialogContent className="dialog-content feeder-info-dialog__content">
          <Box className="feeder-info-dialog__body" ref={tableref1}>
            {Object.keys(groupedFeeders).length === 0 ? (
              <Box className="feeder-info-dialog__empty">No Data Found</Box>
            ) : (
              Object.keys(groupedFeeders).map((gridName) => (
                <Box key={gridName} className="feeder-info-section">
                  <h3 className="feeder-info-section__title">
                    {gridName.replace(/132 KV\s*/, "132 KV - ")}
                  </h3>
                  <Box className="feeder-info-table" role="table">
                    <Box className="feeder-info-table__header" role="row">
                      <span role="columnheader" className="feeder-info-table__cell--center">Sr #</span>
                      <span role="columnheader">Feeder</span>
                      <span role="columnheader" className="feeder-info-table__cell--center">Feeder Code</span>
                      <span role="columnheader" className="feeder-info-table__cell--center">Current (Amps)</span>
                      <span role="columnheader" className="feeder-info-table__cell--center">Voltage (kV)</span>
                      <span role="columnheader" className="feeder-info-table__cell--center">P.F (%)</span>
                      <span role="columnheader" className="feeder-info-table__cell--center">Load (MW)</span>
                      <span role="columnheader" className="feeder-info-table__cell--center">Status</span>
                      <span role="columnheader" className="feeder-info-table__cell--center">Last Reporting Time</span>
                    </Box>
                    {groupedFeeders[gridName].map((feeder, index) => {
                      const currentStatus = feeder.current > 3 ? "ON" : "OFF";
                      const lastReportingTime = new Date(feeder.last_reporting_time);
                      const currentDateTime = new Date(cDateTime);
                      const timeDifference = currentDateTime - lastReportingTime;
                      const halfHourInMs = 30 * 60 * 1000;
                      const isStale = timeDifference > halfHourInMs;
                      const isOn = currentStatus === "ON" && !isStale;

                      return (
                        <Box
                          key={`${gridName}-${index}`}
                          className={`feeder-info-table__row${isStale ? " feeder-info-table__row--stale" : ""}`}
                          role="row"
                        >
                          <span className="feeder-info-table__cell feeder-info-table__cell--center feeder-info-table__cell--sr">
                            {index + 1}
                          </span>
                          <span
                            className={`feeder-info-table__cell feeder-info-table__cell--feeder${!isOn && !isStale ? " feeder-info-table__cell--off" : ""
                              }`}
                          >
                            {feeder.feeder}
                          </span>
                          <span className="feeder-info-table__cell feeder-info-table__cell--center feeder-info-table__cell--metric">
                            {feeder.feeder_code}
                          </span>
                          <span className="feeder-info-table__cell feeder-info-table__cell--center feeder-info-table__cell--metric">
                            {feeder.current > 3 && !isStale ? Math.abs(feeder.current) : "-"}
                          </span>
                          <span className="feeder-info-table__cell feeder-info-table__cell--center feeder-info-table__cell--metric">
                            {Math.abs(feeder.voltage)}
                          </span>
                          <span className="feeder-info-table__cell feeder-info-table__cell--center feeder-info-table__cell--metric">
                            {isOn ? Math.abs(feeder.power_factor) : "-"}
                          </span>
                          <span className="feeder-info-table__cell feeder-info-table__cell--center feeder-info-table__cell--metric">
                            {isOn ? Math.abs(feeder.active_power_kW) : "-"}
                          </span>
                          <span className="feeder-info-table__cell feeder-info-table__cell--center">
                            <span
                              className={`feeder-info-table__status feeder-info-table__status--${isStale ? "stale" : isOn ? "on" : "off"
                                }`}
                            >
                              {isStale ? "-" : currentStatus}
                            </span>
                          </span>
                          <span className="feeder-info-table__cell feeder-info-table__cell--center feeder-info-table__cell--time">
                            {feeder.last_reporting_time}
                          </span>
                        </Box>
                      );
                    })}
                  </Box>
                </Box>
              ))
            )}
          </Box>
        </DialogContent>
      </Dialog>
      {/* APMS MANAGMENT */}
      <Dialog
        open={showApmsForm}
        onClose={apmsFormClose}
        maxWidth="lg"
        fullWidth
        className="complaint-alert-popups apms-info-dialog"
        PaperProps={{ className: "apms-info-dialog__paper" }}
      >
        <Box className="apms-info-dialog__header">
          <span className="apms-info-dialog__title">APMS Information</span>
          <Box className="apms-info-dialog__actions">
            <button
              type="button"
              className="apms-info-dialog__action-btn"
              onClick={DownloadAPMSPdf}
              aria-label="Download PDF"
            >
              <img src={pdf} alt="" style={{ ...internalIconStyles, height: "100%" }} />
            </button>
            <button
              type="button"
              className="apms-info-dialog__action-btn"
              onClick={exportAPMSDataToExcel}
              aria-label="Export Excel"
            >
              <img src={excel} alt="" style={{ ...internalIconStyles, height: "100%" }} />
            </button>
            <button
              type="button"
              className="apms-info-dialog__action-btn"
              onClick={printAPMSPDF}
              aria-label="Print"
            >
              <img src={print} alt="" style={{ ...internalIconStyles, height: "100%" }} />
            </button>
            <button
              type="button"
              className="apms-info-dialog__close-btn"
              onClick={apmsFormClose}
              aria-label="Close"
            >
              <img src={closeIconWhite} alt="" width={22} height={22} />
            </button>
          </Box>
        </Box>
        <DialogContent className="dialog-content apms-info-dialog__content">
          <Box className="apms-info-dialog__body">
            {isCompanyLevelApms && (
              <Box className="apms-info-dialog__filters">
                <Box className="apms-info-dialog__filter-field">
                  <Typography className="apms-info-dialog__filter-label">
                    Company
                  </Typography>
                  <select
                    className="apms-info-dialog__filter-select"
                    value={apmsCompanyCode || "15"}
                    onChange={(e) => {
                      setApmsCompanyCode(e.target.value);
                      setGroupedAPMS({});
                    }}
                    disabled={String(code) !== "10"}
                  >
                    {apmsCompanyOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </Box>
                <Button
                  type="button"
                  variant="contained"
                  className="apms-info-dialog__go-btn"
                  onClick={handleApmsCompanyGo}
                  disabled={!apmsCompanyCode || apmsLoading}
                >
                  {apmsLoading ? (
                    <AppLoader size={18} />
                  ) : (
                    "Go"
                  )}
                </Button>
              </Box>
            )}
            <Box className="apms-info-table" role="table">
              <Box className="apms-info-table__header" role="row">
                <span role="columnheader" className="apms-info-table__cell--center">
                  Sr #
                </span>
                <span role="columnheader">Capacity</span>
                <span role="columnheader">Location</span>
                <span role="columnheader">Msn</span>
                <span role="columnheader" className="apms-info-table__cell--center">
                  Current (Amps)
                </span>
                <span role="columnheader" className="apms-info-table__cell--center">
                  Voltage (kV)
                </span>
                <span role="columnheader" className="apms-info-table__cell--center">
                  Status
                </span>
                <span role="columnheader" className="apms-info-table__cell--center">
                  Last Communication Time
                </span>
              </Box>
              <Box className="apms-info-table__scroll">
                {apmsLoading ? (
                  <Box className="apms-info-table__loading">
                    <AppLoader size={36} />
                    <span className="apms-info-table__loading-text">
                      Fetching APMS data...
                    </span>
                  </Box>
                ) : Object.keys(groupedAPMS).length === 0 ? (
                  <Box className="apms-info-table__empty">No Data Found</Box>
                ) : (
                  Object.keys(groupedAPMS)
                    .flatMap((gridName) =>
                      (groupedAPMS[gridName] || []).map((feeder) => ({
                        ...feeder,
                        __gridName: gridName,
                      })),
                    )
                    .map((feeder, index) => {
                      const {
                        name = "N/A",
                        msn = "N/A",
                        voltage = "N/A",
                        current = "N/A",
                        apms_capacity = "N/A",
                        status = "N/A",
                        last_communication_time = "N/A",
                        __gridName: gridName,
                      } = feeder;
                      const isOn = status === "ON";
                      return (
                        <Box
                          key={`${gridName}-${msn}-${index}`}
                          className="apms-info-table__row"
                          role="row"
                        >
                          <span className="apms-info-table__cell apms-info-table__cell--center apms-info-table__cell--sr">
                            {index + 1}
                          </span>
                          <span className="apms-info-table__cell apms-info-table__cell--capacity">
                            {apms_capacity} kVA
                          </span>
                          <span className="apms-info-table__cell apms-info-table__cell--location">
                            {name}
                          </span>
                          <span className="apms-info-table__cell apms-info-table__cell--msn">
                            {msn}
                          </span>
                          <span className="apms-info-table__cell apms-info-table__cell--metric apms-info-table__cell--center">
                            {current}
                          </span>
                          <span className="apms-info-table__cell apms-info-table__cell--metric apms-info-table__cell--center">
                            {voltage}
                          </span>
                          <span className="apms-info-table__cell apms-info-table__cell--center">
                            <span
                              className={`apms-info-table__status apms-info-table__status--${isOn ? "on" : "off"
                                }`}
                            >
                              {status}
                            </span>
                          </span>
                          <span className="apms-info-table__cell apms-info-table__cell--time apms-info-table__cell--center">
                            {formatApmsCommTime(last_communication_time)}
                          </span>
                        </Box>
                      );
                    })
                )}
              </Box>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Complaint Submission Form  */}
      <Dialog
        open={showComplaintForm}
        onClose={() => complaintFormClose()}
        fullWidth
        maxWidth="lg"
        className="complaint-alert-popups new-complaint-dialog"
      >
        <DialogTitle
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          className="dialog-title"
        >
          <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 1 }}>
            <span className="new-complaint-dialog__heading">New Complaint</span>
            {meterNo && sliceRefNo != code && (
              <Box
                sx={{
                  backgroundColor: "rgba(0,0,0,0.85)",
                  color: "#ffeb3b",
                  px: 1.5,
                  py: 0.75,
                  borderRadius: "6px",
                  fontSize: "12px",
                }}
              >
                for{" "}
                <strong>
                  {subdivisionName(referenceNumber.slice(2, 7), subDivisions)} Sub
                  Division
                </strong>
              </Box>
            )}
          </Box>
          <CloseIcon
            id="clearPopup"
            onClick={() => complaintFormClose()}
            sx={{ color: "white", cursor: "pointer", flexShrink: 0 }}
          />
        </DialogTitle>
        <DialogContent className="dialog-content" style={{ width: "auto" }}>
          <DialogContentText className="dialog-content-text">
            <form className="complaintform complaintform--modern">
              <Box className="complaintform__shell">
                <Box className="complaintform__section complaintform__section--customer">
                  <Box className="complaintform__section-head complaintform__section-head--stacked">
                    <span className="complaintform__card-title">Customer</span>
                    <Box className="complaintform__toolbar complaintform__toolbar--stacked">
                      <RadioGroup
                        row
                        value={complaintType}
                        onChange={handleChange2}
                        className="complaintform__pill-group"
                      >
                        <FormControlLabel
                          value="Technical"
                          control={<Radio color="primary" size="small" />}
                          label="Technical"
                        />
                        <FormControlLabel
                          value="Commercial"
                          control={<Radio color="primary" size="small" />}
                          label="Commercial"
                        />
                      </RadioGroup>
                      <RadioGroup
                        row
                        value={selectedOption}
                        onChange={handleChange1}
                        className="complaintform__pill-group complaintform__pill-group--search"
                      >
                        <FormControlLabel
                          value="referenceNo"
                          control={<Radio color="primary" size="small" />}
                          label="Reference No."
                        />
                        <FormControlLabel
                          value="consumerId"
                          control={<Radio color="primary" size="small" />}
                          label="Consumer Id."
                        />
                        {complaintType === "Technical" && (
                          <FormControlLabel
                            value="apmsMsn"
                            control={<Radio color="primary" size="small" />}
                            label="APMS MSN"
                          />
                        )}
                      </RadioGroup>
                    </Box>
                  </Box>
                  <Grid container spacing={1.5}>
                    <Grid item xs={12} sm={6} md={3}>
                      <Typography className="fieldLabel">
                        {selectedOption === "consumerId"
                          ? "Consumer Id."
                          : selectedOption === "apmsMsn"
                            ? "APMS MSN"
                            : "Reference No."}
                      </Typography>
                      <TextField
                        type="double"
                        name="iv_con_id_ref_no"
                        value={values.iv_con_id_ref_no}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="textInputField"
                        inputProps={{ maxLength: 14 }}
                        autoComplete="off"
                        fullWidth
                        size="small"
                      />
                      <Box className="from-Error">
                        {errors.iv_con_id_ref_no && touched.iv_con_id_ref_no
                          ? errors.iv_con_id_ref_no
                          : null}
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <Typography className="fieldLabel">
                        {selectedOption === "apmsMsn" ? "Transformer Name" : "Name"}
                      </Typography>
                      <TextField
                        type="text"
                        name="iv_name"
                        sanitize={selectedOption === "apmsMsn" ? "text" : "name"}
                        value={values.iv_name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="textInputField"
                        disabled={selectedOption === "apmsMsn"}
                        fullWidth
                        size="small"
                        style={{
                          backgroundColor:
                            selectedOption === "apmsMsn" ? "#f3f4f6" : "#fff",
                        }}
                      />
                      <Box className="from-Error">
                        {errors.iv_name && touched.iv_name ? errors.iv_name : null}
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <Typography className="fieldLabel">
                        {selectedOption === "apmsMsn" ? "Feeder Name" : "Address"}
                      </Typography>
                      <TextField
                        type="text"
                        name="iv_address"
                        value={values.iv_address}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled={selectedOption === "apmsMsn"}
                        style={{
                          backgroundColor:
                            selectedOption === "apmsMsn" ? "#f3f4f6" : "#fff",
                        }}
                        className="textInputField"
                        fullWidth
                        size="small"
                      />
                      <Box className="from-Error">
                        {errors.iv_address && touched.iv_address
                          ? errors.iv_address
                          : null}
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <Typography className="fieldLabel">
                        {selectedOption === "apmsMsn" ? "Feeder Code" : "Phone No. (03XX1234567)"}
                      </Typography>
                      <TextField
                        type="text"
                        name="iv_phone_no"
                        value={values.iv_phone_no}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="textInputField"
                        disabled={selectedOption === "apmsMsn"}
                        fullWidth
                        size="small"
                        style={{
                          backgroundColor:
                            selectedOption === "apmsMsn" ? "#f3f4f6" : "#fff",
                        }}
                        inputProps={{
                          maxLength: selectedOption === "apmsMsn" ? 20 : 11,
                        }}
                      />
                      <Box className="from-Error">
                        {errors.iv_phone_no &&
                          touched.iv_phone_no &&
                          selectedOption !== "apmsMsn"
                          ? errors.iv_phone_no
                          : null}
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
                <Box className="complaintform__section complaintform__section--category">
                  {/* APMS MSN Complaint Types */}
                  {selectedOption === "apmsMsn" ? (
                    <Grid
                      container
                      className="container1 complaintform__category-card complaintform__apms-card"
                    >
                      <Grid item xs={12} className="complaintform__apms-section">
                        <Typography className="complaintform__section-title">
                          Critical Alarm
                        </Typography>
                        <FormControl sx={{ width: "100%" }}>
                          <RadioGroup
                            row
                            value={typeId}
                            onChange={TypeId}
                            className="complaintform__apms-radio-group"
                          >
                            <Grid container className="complaintform__category-grid">
                              <Grid item xs={12} sm={6} lg={3}>
                                <FormControlLabel
                                  value="apms_over_voltage"
                                  control={<Radio size="small" />}
                                  label="Over Voltage"
                                  name="Over Voltage"
                                  labelPlacement="end"
                                  className="complaintsButton"
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={3}>
                                <FormControlLabel
                                  value="apms_under_voltage"
                                  control={<Radio size="small" />}
                                  label="Under Voltage"
                                  name="Under Voltage"
                                  labelPlacement="end"
                                  className="complaintsButton"
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={3}>
                                <FormControlLabel
                                  value="apms_phase_over_current"
                                  control={<Radio size="small" />}
                                  label="Phase Over Current"
                                  name="Phase Over Current"
                                  labelPlacement="end"
                                  className="complaintsButton"
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={3}>
                                <FormControlLabel
                                  value="apms_overload"
                                  control={<Radio size="small" />}
                                  label="Overload"
                                  name="Overload"
                                  labelPlacement="end"
                                  className="complaintsButton"
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={3}>
                                <FormControlLabel
                                  value="apms_high_apparent_power"
                                  control={<Radio size="small" />}
                                  label="High Apparent Power"
                                  name="High Apparent Power"
                                  labelPlacement="end"
                                  className="complaintsButton"
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={3}>
                                <FormControlLabel
                                  value="apms_voltage_unbalance"
                                  control={<Radio size="small" />}
                                  label="Voltage Unbalance"
                                  name="Voltage Unbalance"
                                  labelPlacement="end"
                                  className="complaintsButton"
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={3}>
                                <FormControlLabel
                                  value="apms_current_unbalance"
                                  control={<Radio size="small" />}
                                  label="Current Unbalance"
                                  name="Current Unbalance"
                                  labelPlacement="end"
                                  className="complaintsButton"
                                />
                              </Grid>
                              {/* <Grid item lg={3}>
                            <FormControlLabel
                              value="apms_phase_failure"
                              control={<Radio size="small" />}
                              label="Phase Failure / Missing Phase"
                              name="Phase Failure / Missing Phase"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid> */}
                              {/* <Grid item lg={3}>
                            <FormControlLabel
                              value="apms_short_circuit"
                              control={<Radio size="small" />}
                              label="Short Circuit"
                              name="Short Circuit"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} lg={3}>
                            <FormControlLabel
                              value="apms_residual_current"
                              control={<Radio size="small" />}
                              label="Residual Current"
                              name="Residual Current"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid> */}
                            </Grid>
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} className="complaintform__apms-section">
                        <Typography className="complaintform__section-title">
                          Tripping
                        </Typography>
                        <FormControl sx={{ width: "100%" }}>
                          <RadioGroup
                            row
                            value={typeId}
                            onChange={TypeId}
                            className="complaintform__apms-radio-group"
                          >
                            <Grid container className="complaintform__category-grid">
                              <Grid item xs={12} sm={6} lg={3}>
                                <FormControlLabel
                                  value="trip_over_voltage"
                                  control={<Radio size="small" />}
                                  label="Over Voltage"
                                  name="Trip Over Voltage"
                                  labelPlacement="end"
                                  className="complaintsButton"
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={3}>
                                <FormControlLabel
                                  value="trip_under_voltage"
                                  control={<Radio size="small" />}
                                  label="Under Voltage"
                                  name="Trip Under Voltage"
                                  labelPlacement="end"
                                  className="complaintsButton"
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={3}>
                                <FormControlLabel
                                  value="trip_phase_over_current"
                                  control={<Radio size="small" />}
                                  label="Phase Over Current"
                                  name="Trip Phase Over Current"
                                  labelPlacement="end"
                                  className="complaintsButton"
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={3}>
                                <FormControlLabel
                                  value="trip_overload"
                                  control={<Radio size="small" />}
                                  label="Overload"
                                  name="Trip Overload"
                                  labelPlacement="end"
                                  className="complaintsButton"
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={3}>
                                <FormControlLabel
                                  value="trip_phase_failure"
                                  control={<Radio size="small" />}
                                  label="Phase Failure / Missing Phase"
                                  name="Trip Phase Failure"
                                  labelPlacement="end"
                                  className="complaintsButton"
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={3}>
                                <FormControlLabel
                                  value="trip_short_circuit"
                                  control={<Radio size="small" />}
                                  label="Short Circuit"
                                  name="Short Circuit"
                                  labelPlacement="end"
                                  className="complaintsButton"
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={3}>
                                <FormControlLabel
                                  value="trip_residual_current"
                                  control={<Radio size="small" />}
                                  label="Residual Current"
                                  name="Trip Residual Current"
                                  labelPlacement="end"
                                  className="complaintsButton"
                                />
                              </Grid>
                            </Grid>
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} className="complaintform__apms-section">
                        <Typography className="complaintform__section-title">
                          Others
                        </Typography>
                        <FormControl sx={{ width: "100%" }}>
                          <RadioGroup
                            row
                            value={typeId}
                            onChange={TypeId}
                            className="complaintform__apms-radio-group"
                          >
                            <Grid container className="complaintform__category-grid">
                              <Grid item xs={12} sm={6} lg={3}>
                                <FormControlLabel
                                  value="apms_others"
                                  control={<Radio size="small" />}
                                  label="Others"
                                  name="Others"
                                  labelPlacement="end"
                                  className="complaintsButton"
                                />
                              </Grid>
                            </Grid>
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    </Grid>
                  ) : complaintType == "Technical" ? (
                    <Grid
                      container
                      className="container1 complaintform__category-card"
                      spacing={0}
                    >
                      <Grid item xs={12}>
                        <Typography className="complaintform__card-title">
                          Complaint Category
                        </Typography>
                        <FormControl sx={{ width: "100%" }}>
                          <RadioGroup
                            row
                            value={typeId}
                            onChange={TypeId}
                            className="complaintform__category-radio-group"
                          >
                            <Grid container className="complaintform__category-grid">
                              <Grid item xs={12} sm={6} lg={3}>
                                <FormControlLabel
                                  value={powerOutage}
                                  control={<Radio size="small" />}
                                  label="Power Outage "
                                  name="Power Outage"
                                  labelPlacement="end"
                                  className="complaintsButton"
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={3}>
                                <FormControlLabel
                                  value={damagedMeter}
                                  control={<Radio size="small" />}
                                  label="Damaged Meter"
                                  name="Damaged Meter"
                                  labelPlacement="end"
                                  className="complaintsButton"
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={3}>
                                <FormControlLabel
                                  value={electricFire}
                                  name="Electric Fire"
                                  control={<Radio size="small" />}
                                  label="Electric Fire"
                                  labelPlacement="end"
                                  className="complaintsButton"
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={3}>
                                <FormControlLabel
                                  value={fluctuation}
                                  name="Fluctuation"
                                  control={<Radio size="small" />}
                                  label="Fluctuation"
                                  labelPlacement="end"
                                  className="complaintsButton"
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={3}>
                                <FormControlLabel
                                  value={lineFault}
                                  name="Line Fault"
                                  control={<Radio size="small" />}
                                  label="Line Fault"
                                  labelPlacement="end"
                                  className="complaintsButton"
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={3}>
                                <FormControlLabel
                                  value={lowVoltageShortTerm}
                                  name="Low/ High Voltage - Short Term"
                                  control={<Radio size="small" />}
                                  label="Low/ High Voltage - Short Term"
                                  labelPlacement="end"
                                  className="complaintsButton"
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={3}>
                                <FormControlLabel
                                  value={lowVoltageLongTerm}
                                  name="Low/ High  - Long Term"
                                  control={<Radio size="small" />}
                                  label="Low/ High Voltage - Long Term"
                                  labelPlacement="end"
                                  className="complaintsButton"
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={3}>
                                <FormControlLabel
                                  value={others}
                                  name="others"
                                  control={<Radio size="small" />}
                                  label="Others"
                                  labelPlacement="end"
                                  className="complaintsButton"
                                />
                              </Grid>
                            </Grid>
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      {(typeId == 1000 ||
                        typeId == 8 ||
                        typeId == 9 ||
                        typeId == 10 ||
                        typeId == 11 ||
                        typeId == 12 ||
                        typeId == 13 ||
                        typeId == 14 ||
                        typeId == 15 ||
                        typeId == 16 ||
                        typeId == 17 ||
                        typeId == 18 ||
                        typeId == 19) && (
                          <Grid item xs={12} sx={{ paddingRight: "20px" }}>
                            <Typography className="fieldLabel">
                              {" "}
                              Select Complaint Type
                            </Typography>
                            <Select
                              autoWidth={false}
                              autoFocus
                              value={typeId}
                              onChange={TypeId}
                              onBlur={handleBlur}
                              displayEmpty
                              style={{ color: "black" }}
                              className="connectionTypeDropDownList"
                              id="iv_complaint_type"
                            >
                              <MenuItem value="">Select Type</MenuItem>
                              {otherComplaintsArray.map((item, index) => {
                                return (
                                  <MenuItem value={item.code} key={index}>
                                    {item.name}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                            <Box className="from-Error">
                              {errors.iv_complaint_type && touched.iv_complaint_type
                                ? errors.iv_complaint_type
                                : null}
                            </Box>
                          </Grid>
                        )}
                    </Grid>
                  ) : (
                    <Grid
                      container
                      className="container1 complaintform__category-card"
                      spacing={0}
                    >
                      <Grid item xs={12}>
                        <Typography className="complaintform__card-title">
                          Complaint Category
                        </Typography>
                        <FormControl sx={{ width: "100%" }}>
                          <RadioGroup
                            row
                            value={typeId}
                            onChange={TypeId}
                            className="complaintform__category-radio-group"
                          >
                            <Grid container className="complaintform__category-grid">
                              <Grid item xs={12} sm={6} lg={3}>
                                <FormControlLabel
                                  value={MeterPosition}
                                  control={<Radio size="small" />}
                                  label="Meter Position"
                                  name="Meter Position"
                                  labelPlacement="end"
                                  className="complaintsButton"
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={3}>
                                <FormControlLabel
                                  value={DetectionBill}
                                  control={<Radio size="small" />}
                                  label="Detection Bill"
                                  name="Detection Bill"
                                  labelPlacement="end"
                                  className="complaintsButton"
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={3}>
                                <FormControlLabel
                                  value={DelayedBillingNewConnection}
                                  name="Delayed Billing (New Connection)"
                                  control={<Radio size="small" />}
                                  label="Delayed Billing (New Connection)"
                                  labelPlacement="end"
                                  className="complaintsButton"
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={3}>
                                <FormControlLabel
                                  value={NonDeliveryofBill}
                                  name="Late/Non-Delivery of Bill"
                                  control={<Radio size="small" />}
                                  label="Late/Non-Delivery of Bill"
                                  labelPlacement="end"
                                  className="complaintsButton"
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={3}>
                                <FormControlLabel
                                  value={ElectricityTheft}
                                  name=" Electricity Theft"
                                  control={<Radio size="small" />}
                                  label=" Electricity Theft"
                                  labelPlacement="end"
                                  className="complaintsButton"
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={3}>
                                <FormControlLabel
                                  value={InstalledTransformerMeterWireTheft}
                                  name="Installed Transformer"
                                  control={<Radio size="small" />}
                                  label="Installed Transformer"
                                  labelPlacement="end"
                                  className="complaintsButton"
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={3}>
                                <FormControlLabel
                                  value={BulkDistributionTheft}
                                  name="Bulk Distribution Theft"
                                  control={<Radio size="small" />}
                                  label="Bulk Distribution Theft"
                                  labelPlacement="end"
                                  className="complaintsButton"
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={3}>
                                <FormControlLabel
                                  value={others}
                                  name="others"
                                  control={<Radio size="small" />}
                                  label="Others"
                                  labelPlacement="end"
                                  className="complaintsButton"
                                />
                              </Grid>
                            </Grid>
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      {((typeId >= 27 && typeId <= 52) || typeId == 1000) && (
                        <Grid item xs={12} sx={{ paddingRight: "20px" }}>
                          <Typography className="fieldLabel">
                            {" "}
                            Select Complaint Type
                          </Typography>
                          <Select
                            autoWidth={false}
                            autoFocus
                            value={typeId}
                            onChange={TypeId}
                            onBlur={handleBlur}
                            displayEmpty
                            style={{ color: "black" }}
                            className="connectionTypeDropDownList"
                            id="iv_complaint_type"
                          >
                            <MenuItem value="">Select Type</MenuItem>
                            {otherComplaintsArrayCommerical.map((item, index) => {
                              return (
                                <MenuItem value={item.code} key={index}>
                                  {item.name}
                                </MenuItem>
                              );
                            })}
                          </Select>
                          <Box className="from-Error">
                            {errors.iv_complaint_type && touched.iv_complaint_type
                              ? errors.iv_complaint_type
                              : null}
                          </Box>
                        </Grid>
                      )}
                    </Grid>
                  )}
                </Box>

                <Box className="complaintform__section complaintform__section--footer">
                  <Grid container className="complaintform__bottom-panel" spacing={1.5}>
                    <Grid item xs={12} md={7}>
                      <Typography className="fieldLabel">Complaint Detail</Typography>
                      <TextField
                        name="iv_con_id_complaint_details"
                        value={values.iv_con_id_complaint_details}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="textInputField"
                        autoComplete="off"
                        fullWidth
                        size="small"
                        multiline
                        minRows={2}
                        maxRows={3}
                        placeholder="Describe the complaint..."
                      />
                    </Grid>
                    <Grid item xs={12} md={5}>
                      <Typography className="fieldLabel">Attachment</Typography>
                      <Box className="complaintform__upload-zone">
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            flexWrap: "wrap",
                          }}
                        >
                          <Button
                            variant="contained"
                            component="label"
                            size="small"
                            sx={{
                              textTransform: "none",
                              borderRadius: "8px",
                              backgroundColor: complaintAttachmentName
                                ? "#2e7d32"
                                : "#006ad1",
                              "&:hover": {
                                backgroundColor: complaintAttachmentName
                                  ? "#256628"
                                  : "#0057ad",
                              },
                            }}
                          >
                            {complaintAttachmentName
                              ? "Replace File"
                              : "Upload File"}
                            <input
                              type="file"
                              hidden
                              onChange={handleComplaintAttachmentUpload}
                            />
                          </Button>
                          <Typography
                            sx={{
                              fontSize: "12px",
                              color: "#6b7280",
                              lineHeight: 1.3,
                            }}
                          >
                            Max file size: 2MB
                          </Typography>
                        </Box>

                        {complaintAttachmentName && (
                          <Box
                            sx={{
                              marginTop: "10px",
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            {complaintAttachmentPreview ? (
                              <Box
                                component="img"
                                src={complaintAttachmentPreview}
                                alt="Complaint Attachment Preview"
                                sx={{
                                  width: "72px",
                                  height: "72px",
                                  borderRadius: "8px",
                                  border: "1px solid #d1d5db",
                                  objectFit: "cover",
                                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.12)",
                                }}
                              />
                            ) : (
                              <Box
                                sx={{
                                  width: "72px",
                                  height: "72px",
                                  borderRadius: "8px",
                                  border: "1px solid #d1d5db",
                                  backgroundColor: "#eef2f7",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: "#5b6472",
                                  fontSize: "11px",
                                }}
                              >
                                File
                              </Box>
                            )}
                            <Typography
                              sx={{
                                fontSize: "12px",
                                color: "#1f2937",
                                wordBreak: "break-all",
                              }}
                            >
                              {complaintAttachmentName}
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Box>

              {complaintsError && (
                <Box className="complaintform__errors">
                  <Error
                    error={complaintsError}
                    onClose={() => errorCloses()}
                    backgroundColor="#FFC0CB"
                    textColor="#bb0303"
                    iconColor="#bb0303"
                  />
                </Box>
              )}
            </form>
          </DialogContentText>
        </DialogContent>

        <DialogActions className="new-complaint-dialog__actions">
          <Button
            variant="contained"
            className={
              // Regular complaint (Reference No or Consumer ID)
              (((values.iv_con_id_ref_no.length === 10 ||
                values.iv_con_id_ref_no.length === 14) &&
                values.iv_name != "" &&
                values.iv_phone_no.length === 11 &&
                typeId != "") ||
                // APMS MSN complaint
                (selectedOption === "apmsMsn" &&
                  values.iv_con_id_ref_no.length === 12 &&
                  values.iv_name != "" &&
                  values.iv_phone_no != "" &&
                  typeId != "")) === false
                ? "disabled-button new-complaint-dialog__submit"
                : "button new-complaint-dialog__submit"
            }
            component="label"
            sx={{ width: "auto", minWidth: 140 }}
            disabled={
              // Regular complaint (Reference No or Consumer ID)
              (((values.iv_con_id_ref_no.length === 10 ||
                values.iv_con_id_ref_no.length === 14) &&
                values.iv_name != "" &&
                values.iv_phone_no.length === 11 &&
                typeId != "") ||
                // APMS MSN complaint
                (selectedOption === "apmsMsn" &&
                  values.iv_con_id_ref_no.length === 12 &&
                  values.iv_name != "" &&
                  values.iv_phone_no != "" &&
                  typeId != "")) === false
            }
            type="submit"
            onClick={async () => {
              if (selectedOption === "apmsMsn") {
                // Handle APMS MSN submission with API call

                if (!typeId) {
                  setComplaintsError(
                    "Please select a Complaint Type (Critical Alarm / Tripping / Others).",
                  );
                  return;
                }
                if (
                  !values.iv_con_id_complaint_details ||
                  values.iv_con_id_complaint_details.trim() === ""
                ) {
                  setComplaintsError("Complaint Detail is required.");
                  return;
                }

                setViewBackdrop(true);

                // Determine complaint category based on typeId prefix
                let complaintCategoryName = "Critical Alarm";
                if (typeId.startsWith("trip_")) {
                  complaintCategoryName = "Tripping";
                } else if (typeId === "apms_others") {
                  complaintCategoryName = "Others";
                }

                const apmsHeaders = new Headers();
                apmsHeaders.append("Authorization", token);
                apmsHeaders.append("Content-Type", "application/json");

                const apmsRaw = JSON.stringify({
                  apmsMeterSerialNo: values.iv_con_id_ref_no,
                  submittedThrough: "e-Operations",
                  transformerName: values.iv_name,
                  feederCode: values.iv_phone_no,
                  feederName: values.iv_address,
                  complaintCategoryName: complaintCategoryName,
                  complaintTypeName: typeName,
                  transformerLatitude: parseFloat(transformerLat) || 0,
                  transformerLongitude: parseFloat(transformerLong) || 0,
                  subDivisionCode:
                    parseInt(transformerSubDivCode) || parseInt(code) || 0,
                  description: values.iv_con_id_complaint_details,
                  attachment: complaintAttachment,
                  referenceNo: transformerRefNo || "", // Include transformer reference number if available
                });


                const apmsRequestOptions = {
                  method: "POST",
                  headers: apmsHeaders,
                  body: apmsRaw,
                  redirect: "follow",
                };

                try {
                  const response = await fetch(
                    cfpBaseUrl + "apms/registerAPMSComplaint",
                    apmsRequestOptions,
                  );
                  const result = await response.json();

                  if (response.status === 200 || result.status === "200") {
                    setViewBackdrop(false);
                    setShowApmsSuccessPopup(true);
                    setShowComplaintForm(false);
                    setSelectedOption("referenceNo");
                    setTypeId("");
                    setTypeName("");
                    setTransformerLat("");
                    setTransformerLong("");
                    setTransformerSubDivCode("");
                    setTransformerRefNo("");
                    setFieldValue("iv_con_id_ref_no", "");
                    setFieldValue("iv_name", "");
                    setFieldValue("iv_address", "");
                    setFieldValue("iv_phone_no", "");
                    setFieldValue("iv_con_id_complaint_details", "");
                    setComplaintAttachment("");
                    setComplaintAttachmentName("");
                    setComplaintAttachmentPreview("");
                    // Dispatch event to refresh APMS complaints list
                    window.dispatchEvent(
                      new CustomEvent("apmsComplaintSubmitted"),
                    );
                  } else {
                    setViewBackdrop(false);
                    setComplaintsError(
                      result.message || "Failed to register APMS complaint.",
                    );
                  }
                } catch (error) {
                  setViewBackdrop(false);
                  setComplaintsError(
                    "Error submitting APMS complaint. Please try again.",
                  );
                }
              } else {
                handleSubmit();
              }
            }}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      {/* Arear Checking Popup */}
      <Dialog
        open={showComplaintErrorForm}
        onClose={() => complaintErrorFormClose()}
        maxWidth="sm"
        className="complaint-error-alert-popups"
        PaperProps={{
          sx: {
            width: "390px", // Custom width
            height: "160px", // Custom width
            backgroundColor: "#363940", // You can also set the background color here
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            backgroundColor: "#363940",
          }}
        >
          <img src={InfoImage} height={30} />
          <CloseIcon
            id="clearPopup"
            onClick={() => complaintErrorFormClose()}
            sx={{ color: "white", cursor: "pointer" }}
          />
        </DialogTitle>
        <DialogContent className="dialog-content">
          <div
            style={{ cursor: "pointer", padding: 5, color: "white" }}
            onClick={() => errorCloses1()}
          >
            {(arrear < 0 || arrear > 0) && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                <p style={{ fontSize: 17, fontWeight: "500" }}>
                  Arrear exists.
                </p>
              </div>
            )}
            {feederStatus === "OFF" && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                <p style={{ fontSize: 17, fontWeight: "500" }}>
                  Feeder Status : OFF.
                </p>
              </div>
            )}
            {meterStatus.toUpperCase() == "P.DISC" && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                <p style={{ fontSize: 17, fontWeight: "500" }}>
                  Meter is permanently disconnected.
                </p>
              </div>
            )}
            {meterStatus.toUpperCase() == "T.DISC" && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                <p style={{ fontSize: 17, fontWeight: "500" }}>
                  Meter is permanently disconnected.
                </p>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>

      {/* APMS Success Popup */}
      <Dialog
        open={showApmsSuccessPopup}
        onClose={() => setShowApmsSuccessPopup(false)}
        maxWidth="sm"
        PaperProps={{
          sx: {
            width: "400px",
            borderRadius: "12px",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#4CAF50",
            color: "white",
          }}
        >
          <span style={{ fontWeight: 600 }}>Success</span>
          <CloseIcon
            onClick={() => setShowApmsSuccessPopup(false)}
            sx={{ color: "white", cursor: "pointer" }}
          />
        </DialogTitle>
        <DialogContent sx={{ padding: "30px", textAlign: "center" }}>
          <div style={{ fontSize: "48px", marginBottom: "15px" }}>✓</div>
          <p style={{ fontSize: "16px", fontWeight: "500", color: "#333" }}>
            APMS complaint is submitted successfully
          </p>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", paddingBottom: "20px" }}>
          <Button
            variant="contained"
            onClick={() => setShowApmsSuccessPopup(false)}
            sx={{
              backgroundColor: "#4CAF50",
              "&:hover": { backgroundColor: "#45a049" },
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      {/* Workforce Management for Commerical Services*/}
      <Dialog
        open={showWorkforceForm}
        onClose={() => {
          setShowWorkforceForm(false);
          setSearchTerm("");
        }}
        maxWidth="lg"
        fullWidth
        className="lineman-alert-popups wfm-dialog"
        PaperProps={{
          sx: {
            borderRadius: 2,
            overflow: "hidden",
            maxHeight: "92vh",
            boxShadow: "0 16px 48px rgba(0, 52, 120, 0.18)",
          },
        }}
      >
        <DialogTitle
          component="div"
          className="dialog-title wfm-dialog__title"
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography
            component="h2"
            sx={{
              fontSize: "1.125rem",
              fontWeight: 700,
              lineHeight: 1.3,
              color: "inherit",
            }}
          >
            Work Force Management
            <Typography
              component="span"
              sx={{
                fontSize: "0.95rem",
                fontWeight: 500,
                opacity: 0.92,
                ml: 1,
              }}
            >
              ({officeNamee})
            </Typography>
          </Typography>

          <Box className="wfm-header-actions">
            {CheckPermissions(
              permissions,
              permissionsVariables.accessManagement,
              "Workforce Management",
              "Create ",
            ) && (
                <IconButton
                  type="button"
                  className="wfm-toolbar-btn wfm-toolbar-btn--add"
                  onClick={() => setAddWF(true)}
                  aria-label="Add workforce member"
                  size="small"
                >
                  <AddIcon sx={{ fontSize: 20 }} />
                </IconButton>
              )}

            {workForceData.length > 0 ? (
              <>
                <IconButton
                  type="button"
                  className="wfm-toolbar-btn wfm-toolbar-btn--pdf"
                  onClick={() => DownloadLinemanPdf(true)}
                  aria-label="Export PDF"
                  size="small"
                >
                  <Box
                    component="img"
                    src={pdf}
                    alt="PDF"
                    sx={{ width: 22, height: 22 }}
                  />
                </IconButton>
                <IconButton
                  type="button"
                  className="wfm-toolbar-btn wfm-toolbar-btn--excel"
                  onClick={exportLinemanToExcel}
                  aria-label="Export Excel"
                  size="small"
                >
                  <Box
                    component="img"
                    src={excel}
                    alt="Excel"
                    sx={{ width: 22, height: 22 }}
                  />
                </IconButton>
                <IconButton
                  type="button"
                  className="wfm-toolbar-btn wfm-toolbar-btn--print"
                  onClick={printLinemanPDF}
                  aria-label="Print"
                  size="small"
                >
                  <Box
                    component="img"
                    src={print}
                    alt="Print"
                    sx={{ width: 22, height: 22 }}
                  />
                </IconButton>
              </>
            ) : null}
            <IconButton
              id="clearPopup"
              onClick={() => {
                setShowWorkforceForm(false);
                setSearchTerm("");
              }}
              aria-label="Close"
              size="small"
              sx={{
                color: "common.white",
                ml: 0.5,
                "&:hover": { bgcolor: "rgba(255,255,255,0.14)" },
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent
          className="dialog-content wfm-dialog__content"
          sx={{ overflow: "hidden", p: 0 }}
        >
          <Box className="wfm-filter-bar filter-fields">
            <Box className="wfm-filter-fields">
              {code == 10 && (
                <div className="field-container wfm-filter-field">
                  <Typography className="field-label">Company</Typography>
                  <select
                    className="dropdown-field wfm-filter-select"
                    value={selectedCompanyCode}
                    onChange={handleChangeCompany}
                  >
                    <option value="">Select Company</option>
                    <option value="10">PITC</option>
                    {getDiscoCompanyNativeOptions(selectedCompanyCode, false, false)}
                  </select>
                </div>
              )}

              {hierarchy <= 2 && (
                <div className="field-container wfm-filter-field">
                  <Typography className="field-label">Circle</Typography>
                  <select
                    className="dropdown-field wfm-filter-select"
                    value={circleCodee || ""}
                    onChange={handleCircleChange}
                  >
                    <option value="">All Circle</option>
                    {filteredCircles.map((circle) => (
                      <option key={circle.circleCode} value={circle.circleCode}>
                        {circle.circleName}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              {hierarchy <= 3 && (
                <div className="field-container wfm-filter-field">
                  <Typography className="field-label">Division</Typography>
                  <select
                    className="dropdown-field wfm-filter-select"
                    value={selectedDivision || ""}
                    onChange={handleDivisionChange}
                    disabled={!circleCode}
                  >
                    <option value="">All Division</option>
                    {filteredDivisions.map((division) => (
                      <option
                        key={division.divisionCode}
                        value={division.divisionCode}
                      >
                        {division.divisionName}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              {hierarchy <= 4 && (
                <div className="field-container wfm-filter-field">
                  <Typography className="field-label">Sub-Division</Typography>
                  <select
                    className="dropdown-field wfm-filter-select"
                    value={selectedSubDivision || ""}
                    onChange={handleSubDivisionChange}
                    disabled={!selectedDivision}
                  >
                    <option value="">All Sub-Division</option>
                    {filteredSubDivisions.map((subDivision) => (
                      <option
                        key={subDivision.subDivisionCode}
                        value={subDivision.subDivisionCode}
                      >
                        {subDivision.subDivisionName}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              {hierarchy !== 52 ? (
                <Button
                  variant="contained"
                  className="wfm-go-btn"
                  onClick={() => getWFData(officeCodee)}
                  sx={{ alignSelf: "flex-end", minWidth: 72 }}
                >
                  Go
                </Button>
              ) : null}
            </Box>

            <Box className="wfm-search">
              <SearchIcon className="wfm-search__icon" />
              <input
                type="text"
                className="wfm-search__input"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search Name / Phone"
                maxLength={20}
              />
            </Box>
          </Box>

          <Box className="wfm-body" sx={{ px: 2, pb: 2, pt: 0 }}>
            <form className="linemanAlertForm wfm-staff-form">
              {filteredWorkforce.length ? (
                renderFieldsWorkforce(filteredWorkforce, setWorkForceData)
              ) : (
                <Typography className="wfm-empty-message">
                  No Field staff found!
                </Typography>
              )}
            </form>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Profile Edit Popup */}
      <Dialog
        open={showProfileEditPopup}
        onClose={() => setShowProfileEditPopup(false)}
        fullWidth
        maxWidth="sm"
        className="alert-popups"
        aria-labelledby="user-profile-dialog-title"
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: "hidden",
            maxWidth: 560,
            width: "100%",
            boxShadow: "0 16px 48px rgba(0, 52, 120, 0.18)",
          },
        }}
      >
        <DialogTitle
          id="user-profile-dialog-title"
          component="div"
          className="dialog-title"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
            py: 2,
            px: 2.5,
            background: "linear-gradient(135deg, #006ad1 0%, #004d99 100%)",
            color: "common.white",
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
            User Profile
          </Typography>
          <IconButton
            id="clearPopup"
            onClick={() => setShowProfileEditPopup(false)}
            size="small"
            aria-label="Close profile"
            sx={{
              color: "common.white",
              "&:hover": { bgcolor: "rgba(255,255,255,0.14)" },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          className="dialog-content"
          sx={{ p: 0, bgcolor: "#f0f4f9" }}
        >
          <Box sx={{ p: { xs: 2, sm: 2.5 } }}>
            <form className="complaintform">
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  mb: 2,
                }}
              >
                <Box sx={{ position: "relative", width: 124, height: 124 }}>
                  <Box
                    component="img"
                    src={
                      typeof profilePictureFormik.values.iv_profile_picture ===
                        "string"
                        ? profilePictureFormik.values.iv_profile_picture
                        : profilePictureFormik.values.iv_profile_picture
                          ? URL.createObjectURL(
                            profilePictureFormik.values.iv_profile_picture,
                          )
                          : UserIconImage
                    }
                    alt="Profile"
                    onError={(e) => {
                      e.target.src = UserIconImage;
                    }}
                    sx={{
                      width: 124,
                      height: 124,
                      objectFit: "cover",
                      borderRadius: "50%",
                      border: "4px solid #fff",
                      boxShadow:
                        "0 0 0 3px #006ad1, 0 10px 28px rgba(0, 106, 209, 0.28)",
                    }}
                  />
                  <Box
                    component="label"
                    htmlFor="sidebar-profile-photo-input"
                    sx={{
                      position: "absolute",
                      right: -2,
                      bottom: -2,
                      width: 44,
                      height: 44,
                      borderRadius: "50%",
                      bgcolor: "#006ad1",
                      color: "common.white",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      border: "3px solid #fff",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                      transition: "transform 0.15s, background-color 0.15s",
                      "&:hover": {
                        bgcolor: "#0056a8",
                        transform: "scale(1.05)",
                      },
                    }}
                  >
                    <DriveFolderUploadIcon sx={{ fontSize: 22 }} />
                  </Box>
                  <input
                    type="file"
                    id="sidebar-profile-photo-input"
                    accept={imageExtensions}
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        const isValidFileType =
                          file.type === "image/jpeg" ||
                          file.type === "image/png";
                        const isValidFileSize = file.size <= 3 * 1024 * 1024;

                        if (!isValidFileType) {
                          alert("Only JPEG and PNG images are allowed");
                          return;
                        }

                        if (!isValidFileSize) {
                          alert("File size must be less than 3MB");
                          return;
                        }

                        profilePictureFormik.setFieldValue(
                          "iv_profile_picture",
                          file,
                          true,
                        );
                        setTimeout(() => {
                          profilePictureFormik.handleSubmit();
                        }, 100);
                      }
                    }}
                    style={{ display: "none" }}
                  />
                </Box>
                <Typography variant="caption" color="text.secondary" sx={{ mt: 1.5, display: "block" }}>
                  JPEG or PNG · max 3 MB
                </Typography>
                {profilePictureFormik.errors.iv_profile_picture && (
                  <Typography
                    variant="caption"
                    color="error"
                    sx={{ mt: 0.5, textAlign: "center" }}
                  >
                    {profilePictureFormik.errors.iv_profile_picture}
                  </Typography>
                )}
              </Box>

              <Box
                sx={{
                  bgcolor: "common.white",
                  borderRadius: 2,
                  p: { xs: 1.5, sm: 2 },
                  boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{
                    color: "#006ad1",
                    fontWeight: 700,
                    letterSpacing: "0.04em",
                    textTransform: "uppercase",
                    fontSize: "0.72rem",
                  }}
                >
                  User information
                </Typography>
                <Divider sx={{ my: 1.25 }} />
                <Grid container spacing={1.5}>
                  <Grid item xs={12}>
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ fontWeight: 600, display: "block", mb: 0.35 }}
                    >
                      Full name
                    </Typography>
                    <TextField
                      type="text"
                      autoComplete="off"
                      disabled
                      fullWidth
                      size="small"
                      variant="outlined"
                      onChange={nameFormik.handleChange}
                      name="iv_full_name"
                      value={nameFormik.values.iv_full_name}
                      title={nameFormik.values.iv_full_name}
                      onBlur={nameFormik.handleBlur}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 1.5,
                          bgcolor: "grey.50",
                        },
                        "& .MuiInputBase-input": {
                          fontSize: "0.8125rem",
                          py: 1,
                          overflow: "visible",
                          textOverflow: "clip",
                          whiteSpace: "nowrap",
                        },
                      }}
                    />
                    {nameFormik.errors.iv_full_name &&
                      nameFormik.touched.iv_full_name ? (
                      <Typography variant="caption" color="error" sx={{ mt: 0.5, display: "block" }}>
                        {nameFormik.errors.iv_full_name}
                      </Typography>
                    ) : null}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ fontWeight: 600, display: "block", mb: 0.35 }}
                    >
                      Username
                    </Typography>
                    <TextField
                      type="text"
                      autoComplete="off"
                      name="iv_user_name"
                      value={userId}
                      title={userId || ""}
                      disabled
                      fullWidth
                      size="small"
                      variant="outlined"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 1.5,
                          bgcolor: "grey.50",
                        },
                        "& .MuiInputBase-input": {
                          fontSize: "0.8125rem",
                          py: 1,
                          overflow: "visible",
                          textOverflow: "clip",
                          whiteSpace: "nowrap",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ fontWeight: 600, display: "block", mb: 0.35 }}
                    >
                      Phone no.
                    </Typography>
                    <TextField
                      type="text"
                      maxLength="11"
                      autoComplete="off"
                      disabled
                      fullWidth
                      size="small"
                      variant="outlined"
                      onChange={phoneFormik.handleChange}
                      inputProps={{ maxLength: 11 }}
                      name="iv_user_phone_no"
                      value={phoneFormik.values.iv_user_phone_no}
                      title={phoneFormik.values.iv_user_phone_no}
                      onBlur={phoneFormik.handleBlur}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 1.5,
                          bgcolor: "grey.50",
                        },
                        "& .MuiInputBase-input": {
                          fontSize: "0.8125rem",
                          py: 1,
                          overflow: "visible",
                          textOverflow: "clip",
                          whiteSpace: "nowrap",
                        },
                      }}
                    />
                    {phoneFormik.errors.iv_user_phone_no &&
                      phoneFormik.touched.iv_user_phone_no ? (
                      <Typography variant="caption" color="error" sx={{ mt: 0.5, display: "block" }}>
                        {phoneFormik.errors.iv_user_phone_no}
                      </Typography>
                    ) : null}
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ fontWeight: 600, display: "block", mb: 0.35 }}
                    >
                      CNIC no.
                    </Typography>
                    <TextField
                      type="text"
                      maxLength="13"
                      autoComplete="off"
                      name="cnic"
                      disabled
                      fullWidth
                      size="small"
                      variant="outlined"
                      inputProps={{ maxLength: 13 }}
                      value={cnic}
                      title={cnic || ""}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 1.5,
                          bgcolor: "grey.50",
                        },
                        "& .MuiInputBase-input": {
                          fontSize: "0.8125rem",
                          py: 1,
                          overflow: "visible",
                          textOverflow: "clip",
                          whiteSpace: "nowrap",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ fontWeight: 600, display: "block", mb: 0.35 }}
                    >
                      Email address
                    </Typography>
                    <TextField
                      type="text"
                      autoComplete="off"
                      disabled
                      fullWidth
                      size="small"
                      variant="outlined"
                      onChange={emailFormik.handleChange}
                      name="iv_user_email"
                      value={emailFormik.values.iv_user_email}
                      title={emailFormik.values.iv_user_email}
                      onBlur={emailFormik.handleBlur}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 1.5,
                          bgcolor: "grey.50",
                        },
                        "& .MuiInputBase-input": {
                          fontSize: "0.8125rem",
                          py: 1,
                          overflow: "auto",
                          textOverflow: "clip",
                          whiteSpace: "nowrap",
                        },
                      }}
                    />
                    {emailFormik.errors.iv_user_email &&
                      emailFormik.touched.iv_user_email ? (
                      <Typography variant="caption" color="error" sx={{ mt: 0.5, display: "block" }}>
                        {emailFormik.errors.iv_user_email}
                      </Typography>
                    ) : null}
                  </Grid>
                  {/* {(apiError || error) && (
                    <Grid item xs={12} sx={{ mt: 0.5 }}>
                      <Error
                        error={error || apiError}
                        onClose={() => errorCloses()}
                        backgroundColor="#FFC0CB"
                        textColor="#bb0303"
                        iconColor="#bb0303"
                      />
                    </Grid>
                  )} */}
                </Grid>
              </Box>
            </form>
          </Box>
        </DialogContent>
        <DialogActions sx={{ bgcolor: "#f0f4f9", py: 1, minHeight: 8 }} />
      </Dialog>

      {/* Reconnection report is opened as a full page route now */}

      {/* Change Password */}
      <Dialog
        open={showChangePasswordPopup}
        onClose={() => {
          setShowChangePasswordPopup(false);
          passwordChangeFormik.resetForm();
        }}
        fullWidth
        maxWidth="xs"
        aria-labelledby="change-password-dialog-title"
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: "hidden",
            maxWidth: 440,
            width: "100%",
            boxShadow: "0 16px 48px rgba(0, 52, 120, 0.18)",
          },
        }}
      >
        <DialogTitle
          id="change-password-dialog-title"
          component="div"
          className="user-mgmt-modal-header"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
            Change Password
          </Typography>
          <IconButton
            id="clearPopup"
            size="small"
            aria-label="Close"
            onClick={() => {
              setShowChangePasswordPopup(false);
              passwordChangeFormik.resetForm();
            }}
            sx={{
              color: "common.white",
              "&:hover": { bgcolor: "rgba(255,255,255,0.14)" },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            bgcolor: "#ffffff",
            pt: 8,
            pb: 2.5,
            px: 2.5,
          }}
        >
          <DialogContentText component="div" sx={{ m: 0 }}>
            <form
              noValidate
              className="complaintform"
              onSubmit={passwordChangeFormik.handleSubmit}
              style={{ marginTop: 0 }}
            >
              <Grid container spacing={2.5}>
                <Grid item xs={12}>
                  <Typography
                    variant="body2"
                    sx={{ mt: 2, mb: 0.75, fontWeight: 600, color: "text.secondary" }}
                  >
                    Current Password
                  </Typography>
                  <TextField
                    type={showOldPassword ? "text" : "password"}
                    autoComplete="off"
                    fullWidth
                    size="small"
                    variant="outlined"
                    onChange={passwordChangeFormik.handleChange}
                    name="iv_old_password"
                    value={passwordChangeFormik.values.iv_old_password}
                    onBlur={passwordChangeFormik.handleBlur}
                    error={Boolean(
                      passwordChangeFormik.errors.iv_old_password &&
                      (passwordChangeFormik.touched.iv_old_password ||
                        passwordChangeFormik.submitCount > 0),
                    )}
                    helperText={
                      passwordChangeFormik.errors.iv_old_password &&
                        (passwordChangeFormik.touched.iv_old_password ||
                          passwordChangeFormik.submitCount > 0)
                        ? passwordChangeFormik.errors.iv_old_password
                        : ""
                    }
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 1.5,
                        bgcolor: "#fafafa",
                      },
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            type="button"
                            onClick={handleClickShowOldPassword}
                            edge="end"
                            size="small"
                            aria-label="toggle current password visibility"
                          >
                            {!showOldPassword ? (
                              <Visibility />
                            ) : (
                              <VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    variant="body2"
                    sx={{ mb: 0.75, fontWeight: 600, color: "text.secondary" }}
                  >
                    New Password
                  </Typography>
                  <TextField
                    type={showNewPassword ? "text" : "password"}
                    autoComplete="off"
                    fullWidth
                    size="small"
                    variant="outlined"
                    onChange={passwordChangeFormik.handleChange}
                    name="iv_new_password"
                    value={passwordChangeFormik.values.iv_new_password}
                    onBlur={passwordChangeFormik.handleBlur}
                    error={Boolean(
                      passwordChangeFormik.errors.iv_new_password &&
                      (passwordChangeFormik.touched.iv_new_password ||
                        passwordChangeFormik.submitCount > 0),
                    )}
                    helperText={
                      passwordChangeFormik.errors.iv_new_password &&
                        (passwordChangeFormik.touched.iv_new_password ||
                          passwordChangeFormik.submitCount > 0)
                        ? passwordChangeFormik.errors.iv_new_password
                        : ""
                    }
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 1.5,
                        bgcolor: "#fafafa",
                      },
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            type="button"
                            onClick={handleClickShowNewPassword}
                            edge="end"
                            size="small"
                            aria-label="toggle new password visibility"
                          >
                            {!showNewPassword ? (
                              <Visibility />
                            ) : (
                              <VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    variant="body2"
                    sx={{ mb: 0.75, fontWeight: 600, color: "text.secondary" }}
                  >
                    Confirm New Password
                  </Typography>
                  <TextField
                    type={showConfirmPassword ? "text" : "password"}
                    autoComplete="off"
                    fullWidth
                    size="small"
                    variant="outlined"
                    onChange={passwordChangeFormik.handleChange}
                    name="iv_confirm_password"
                    value={passwordChangeFormik.values.iv_confirm_password}
                    onBlur={passwordChangeFormik.handleBlur}
                    error={Boolean(
                      passwordChangeFormik.errors.iv_confirm_password &&
                      (passwordChangeFormik.touched.iv_confirm_password ||
                        passwordChangeFormik.submitCount > 0),
                    )}
                    helperText={
                      passwordChangeFormik.errors.iv_confirm_password &&
                        (passwordChangeFormik.touched.iv_confirm_password ||
                          passwordChangeFormik.submitCount > 0)
                        ? passwordChangeFormik.errors.iv_confirm_password
                        : ""
                    }
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 1.5,
                        bgcolor: "#fafafa",
                      },
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            type="button"
                            onClick={handleClickShowConfirmPassword}
                            edge="end"
                            size="small"
                            aria-label="toggle confirm password visibility"
                          >
                            {!showConfirmPassword ? (
                              <Visibility />
                            ) : (
                              <VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  {apiError && (
                    <Error
                      error={apiError}
                      onClose={() => errorCloses()}
                      backgroundColor="#FFC0CB"
                      textColor="#bb0303"
                      iconColor="#bb0303"
                    />
                  )}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 0.5 }}
                >
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{
                      px: 3.5,
                      py: 1,
                      borderRadius: 1.5,
                      fontWeight: 700,
                      letterSpacing: "0.06em",
                      textTransform: "none",
                      color: "#fff",
                      bgcolor: "#003971",
                      "&:hover": { bgcolor: "#002a56" },
                      "&.Mui-disabled": {
                        bgcolor: "rgba(0, 57, 113, 0.42)",
                        color: "rgba(255, 255, 255, 0.9)",
                      },
                      boxShadow: "0 2px 8px rgba(0, 57, 113, 0.35)",
                    }}
                  >
                    SUBMIT
                  </Button>
                </Grid>
              </Grid>
            </form>
          </DialogContentText>
        </DialogContent>
      </Dialog>

      {/* Search Popups */}
      <SearchPopup
        searchBarrPopupOpen={searchBarrPopupOpen}
        handleCloseSearchBarPopup={handleCloseSearchBarPopup}
        selectedTab={selectedTab}
        handleTabChange={handleTabChange}
        tabLabels={tabLabels}
        searchFormik={searchFormik}
        isAdmin={String(code) === "10"}
      />
      <SearchResultsPopup
        openDialogOfApplication={openDialogOfApplication}
        handleDialogOfApplicationClose={handleDialogOfApplicationClose}
        selectedTab={selectedTab}
        selectedValueOfTab={selectedValueOfTab}
        resultSearchedData={resultSearchedData}
        resultSearchedData1={resultSearchedData1}
        setViewBackdrop={setViewBackdrop}
      />

      {/* Backdrop */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <AppLoader />
      </Backdrop>

      {/* Delete Workforce Warning */}
      <Dialog
        open={deleteLMWarning}
        onClose={() => setDeleteLMWarning(false)}
        className="dialog"
        fullWidth={true}
        maxWidth={"sm"}
        sx={{ zIndex: "9999" }}
        PaperProps={{ style: { borderRadius: 20, width: "70%" } }}
      >
        <DialogTitle></DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div style={{ textAlign: "center" }}>
              <img src={batchIcon} alt="batchIcon" width="80px" height="80px" />
            </div>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "500",
                fontSize: "26px",
                color: "#1976d2",
                textAlign: "center",
              }}
            >
              {" "}
              Warning
            </Typography>
            <h5 className="applicationSubmit" style={{ fontSize: "16px" }}>
              Do you want to delete the lineman?
            </h5>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "25px",
              }}
            >
              <Button
                sx={{
                  width: "30%",
                  backgroundColor: "#d32f2f",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#b71c1c" },
                }}
                variant="contained"
                size="small"
                onClick={async () => {
                  await deleteWFData(workForceToDelete, token);
                  await getWFData();
                  setDeleteLMWarning(false);
                }}
              >
                Yes
              </Button>
              <Button
                sx={{
                  width: "30%",
                  backgroundColor: "#4caf50",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#388e3c" },
                }}
                variant="contained"
                size="small"
                onClick={() => {
                  setWorkForceToDelete({});
                  setDeleteLMWarning(false);
                }}
              >
                No
              </Button>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>

      <EditLinemanDialog
        open={editWF}
        onClose={() => {
          editWorkForceFormik.resetForm();
          setEditWF(false);
          setApiError("");
          setEditSelectedItems([]);
        }}
        formik={editWorkForceFormik}
        apiError={apiError}
        shifts={shifts}
        selectedShiftIds={editSelectedItems}
        onShiftToggle={handleCheckboxChange1}
        designations={fieldStaffDesignations}
      />

      <AddWorkforceDialog
        open={addWF}
        onClose={() => {
          workForceAddFormik.resetForm();
          setAddWF(false);
          setApiError("");
          window.location.reload();
        }}
        formik={workForceAddFormik}
        apiError={apiError}
        code={code}
        hierarchy={hierarchy}
        selectedCompanyCode={selectedCompanyCode}
        onCompanyChange={handleChangeCompany}
        circleCode={circleCode}
        circleCodee={circleCodee}
        onCircleChange={handleCircleChange}
        selectedDivision={selectedDivision}
        onDivisionChange={handleDivisionChange}
        filteredCircles={filteredCircles}
        filteredDivisions={filteredDivisions}
        filteredSubDivisions={filteredSubDivisions}
        onSubDivisionChange={(e) => {
          workForceAddFormik.handleChange(e);
          handleSubDivisionChange(e);
        }}
        designations={fieldStaffDesignations}
        shifts={shifts}
        selectedShiftIds={selectedItems}
        onShiftToggle={handleCheckboxChange}
        showPassword={showPassword}
        showConfirmPassword={showConfirmPassword}
        onTogglePassword={handleClickShowPassword}
        onToggleConfirmPassword={handleClickShowConfirmPassword}
      />

      <ChangeWorkforcePasswordDialog
        open={passwordWF}
        onClose={() => {
          passwordChangeWorkForceFormik.resetForm();
          setPasswordWF(false);
          setApiError("");
        }}
        formik={passwordChangeWorkForceFormik}
        apiError={apiError}
        showPassword={showPassword}
        showConfirmPassword={showConfirmPassword}
        onTogglePassword={handleClickShowPassword}
        onToggleConfirmPassword={handleClickShowConfirmPassword}
      />

      <Dialog
        open={openAmendBillPopup}
        onClose={() => {
          setOpenAmendBillPopup(false);
          amendBill.resetForm();
          setError1("");
          setSuccess("");
        }}
        className="amend-duplicate-bill-dialog"
        fullWidth
        maxWidth="md"
        PaperProps={{
          className: "amend-duplicate-bill-dialog__paper",
          sx: { borderRadius: "16px", overflow: "hidden" },
        }}
      >
        <form onSubmit={amendBill.handleSubmit}>
          <DialogTitle
            className="amend-duplicate-bill-dialog__title"
            sx={{
              position: "relative",
              background: "linear-gradient(to bottom, #1e52a7, #a0bbe7)",
              color: "white",
              fontWeight: 600,
              padding: "16px 48px",
              textAlign: "center",
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Amend Duplicate Bill
            </Typography>
            <IconButton
              onClick={() => {
                setOpenAmendBillPopup(false);
                amendBill.resetForm();
                setError1("");
                setSuccess("");
              }}
              sx={{
                position: "absolute",
                right: 12,
                top: "50%",
                transform: "translateY(-50%)",
                color: "white",
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent dividers className="amend-duplicate-bill-dialog__content">
            <Grid container spacing={2}>
              <Grid item xs={12} md={5}>
                <Typography className="fieldLabel" gutterBottom>
                  Application ID <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  name="iv_application_id"
                  value={amendBill.values.iv_application_id}
                  onChange={amendBill.handleChange}
                  onBlur={amendBill.handleBlur}
                  inputProps={{ maxLength: 18, inputMode: "numeric" }}
                  placeholder="Enter 18-digit ID"
                  fullWidth
                  size="small"
                  autoFocus
                  error={
                    amendBill.touched.iv_application_id &&
                    Boolean(amendBill.errors.iv_application_id)
                  }
                  helperText={
                    amendBill.touched.iv_application_id &&
                    amendBill.errors.iv_application_id
                  }
                />
              </Grid>
            </Grid>

            {/* Alerts */}
            <Box sx={{ mt: 2 }}>
              {error1 && <Error error={error1} onClose={() => setError1("")} />}
              {success && (
                <Success error={success} onClose={() => setSuccess("")} />
              )}
            </Box>
          </DialogContent>

          <DialogActions
            className="amend-duplicate-bill-dialog__actions"
            sx={{ justifyContent: "flex-end", p: 2, gap: 1 }}
          >
            <Button
              onClick={() => {
                setOpenAmendBillPopup(false);
                amendBill.resetForm();
                setError1("");
                setSuccess("");
              }}
              variant="outlined"
              color="secondary"
            >
              Cancel
            </Button>

            <Button
              type="submit"
              variant="contained"
              color="primary"
              // disabled={amendBill.isSubmitting || !amendBill.isValid || !amendBill.dirty}
              startIcon={
                amendBill.isSubmitting ? <AppLoader size={18} /> : null
              }
            >
              {amendBill.isSubmitting ? "Processing..." : "Submit & Download"}
            </Button>
          </DialogActions>
        </form>

        <Backdrop sx={{ color: "#fff", zIndex: 9999 }} open={Boolean(viewBackdrop && openAmendBillPopup)}>
          <AppLoader />
        </Backdrop>
      </Dialog>
    </>
  );
};

const MemorizedSideBar = React.memo(Sidebar);
export default MemorizedSideBar;
